//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.2.0.0 (NJsonSchema v11.1.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

import axios, { AxiosError } from 'axios';
import type { AxiosInstance, AxiosRequestConfig, AxiosResponse, CancelToken } from 'axios';

import dayjs from 'dayjs';

export class UserContractClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "https://userapi-staging.s2f.projectx.com";

    }

    /**
     * Returns a list of all contracts available (for stat sharing)
     */
    getAll( cancelToken?: CancelToken): Promise<UserContractModel[]> {
        let url_ = this.baseUrl + "/UserContract/all";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAll(_response);
        });
    }

    protected processGetAll(response: AxiosResponse): Promise<UserContractModel[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(UserContractModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<UserContractModel[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UserContractModel[]>(null as any);
    }

    /**
     * Gets a list of all active contracts allowed for the currently logged-in user (non-professional)
     */
    getNonProfessional( cancelToken?: CancelToken): Promise<UserContractModel[]> {
        let url_ = this.baseUrl + "/UserContract/active/nonprofesional";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetNonProfessional(_response);
        });
    }

    protected processGetNonProfessional(response: AxiosResponse): Promise<UserContractModel[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(UserContractModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<UserContractModel[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UserContractModel[]>(null as any);
    }

    /**
     * Gets a list of all active contracts allowed for the currently logged-in user (professional only - live)
     */
    getProfessional( cancelToken?: CancelToken): Promise<UserContractModel[]> {
        let url_ = this.baseUrl + "/UserContract/active/professional";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetProfessional(_response);
        });
    }

    protected processGetProfessional(response: AxiosResponse): Promise<UserContractModel[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(UserContractModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<UserContractModel[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UserContractModel[]>(null as any);
    }
}

export class AccountTemplateClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "https://userapi-staging.s2f.projectx.com";

    }

    /**
     * Retrieves a list of all templates associated with a specific user
     * @return A list of AccountTemplateModel.
     */
    getUserTemplates( cancelToken?: CancelToken): Promise<AccountTemplateModel[]> {
        let url_ = this.baseUrl + "/AccountTemplate/userTemplates";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetUserTemplates(_response);
        });
    }

    protected processGetUserTemplates(response: AxiosResponse): Promise<AccountTemplateModel[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AccountTemplateModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<AccountTemplateModel[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AccountTemplateModel[]>(null as any);
    }
}

export class AccountTemplateRuleClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "https://userapi-staging.s2f.projectx.com";

    }

    /**
     * Retrieves a list of all rule configurations for the specified account template id
     * @param accountTemplateId Account template id
     * @return List of rule types (rule IDs) attached to the template
     */
    getAllAttachedRules(accountTemplateId: number, cancelToken?: CancelToken): Promise<AccountTemplateRuleModel[]> {
        let url_ = this.baseUrl + "/AccountTemplateRule/rules/{accountTemplateId}/all";
        if (accountTemplateId === undefined || accountTemplateId === null)
            throw new Error("The parameter 'accountTemplateId' must be defined.");
        url_ = url_.replace("{accountTemplateId}", encodeURIComponent("" + accountTemplateId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAllAttachedRules(_response);
        });
    }

    protected processGetAllAttachedRules(response: AxiosResponse): Promise<AccountTemplateRuleModel[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AccountTemplateRuleModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<AccountTemplateRuleModel[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AccountTemplateRuleModel[]>(null as any);
    }
}

export class ChartDataClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "https://userapi-staging.s2f.projectx.com";

    }

    delete(client: string | undefined, user: string | undefined, chart: string | undefined, cancelToken?: CancelToken): Promise<ChartResult> {
        let url_ = this.baseUrl + "/charts_old/1.1/charts?";
        if (client === null)
            throw new Error("The parameter 'client' cannot be null.");
        else if (client !== undefined)
            url_ += "client=" + encodeURIComponent("" + client) + "&";
        if (user === null)
            throw new Error("The parameter 'user' cannot be null.");
        else if (user !== undefined)
            url_ += "user=" + encodeURIComponent("" + user) + "&";
        if (chart === null)
            throw new Error("The parameter 'chart' cannot be null.");
        else if (chart !== undefined)
            url_ += "chart=" + encodeURIComponent("" + chart) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: AxiosResponse): Promise<ChartResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ChartResult.fromJS(resultData200);
            return Promise.resolve<ChartResult>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ChartResult>(null as any);
    }

    get(client: string | undefined, user: string | undefined, chart: string | null | undefined, cancelToken?: CancelToken): Promise<ChartResult> {
        let url_ = this.baseUrl + "/charts_old/1.1/charts?";
        if (client === null)
            throw new Error("The parameter 'client' cannot be null.");
        else if (client !== undefined)
            url_ += "client=" + encodeURIComponent("" + client) + "&";
        if (user === null)
            throw new Error("The parameter 'user' cannot be null.");
        else if (user !== undefined)
            url_ += "user=" + encodeURIComponent("" + user) + "&";
        if (chart !== undefined && chart !== null)
            url_ += "chart=" + encodeURIComponent("" + chart) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: AxiosResponse): Promise<ChartResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ChartResult.fromJS(resultData200);
            return Promise.resolve<ChartResult>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ChartResult>(null as any);
    }

    post(client: string | undefined, user: string | undefined, chart: string | null | undefined, name: string | undefined, content: string | undefined, symbol: string | null | undefined, resolution: string | null | undefined, cancelToken?: CancelToken): Promise<ChartResult> {
        let url_ = this.baseUrl + "/charts_old/1.1/charts?";
        if (client === null)
            throw new Error("The parameter 'client' cannot be null.");
        else if (client !== undefined)
            url_ += "client=" + encodeURIComponent("" + client) + "&";
        if (user === null)
            throw new Error("The parameter 'user' cannot be null.");
        else if (user !== undefined)
            url_ += "user=" + encodeURIComponent("" + user) + "&";
        if (chart !== undefined && chart !== null)
            url_ += "chart=" + encodeURIComponent("" + chart) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (name === null || name === undefined)
            throw new Error("The parameter 'name' cannot be null.");
        else
            content_.append("name", name.toString());
        if (content === null || content === undefined)
            throw new Error("The parameter 'content' cannot be null.");
        else
            content_.append("content", content.toString());
        if (symbol !== null && symbol !== undefined)
            content_.append("symbol", symbol.toString());
        if (resolution !== null && resolution !== undefined)
            content_.append("resolution", resolution.toString());

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPost(_response);
        });
    }

    protected processPost(response: AxiosResponse): Promise<ChartResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ChartResult.fromJS(resultData200);
            return Promise.resolve<ChartResult>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ChartResult>(null as any);
    }
}

export class ChartsClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "https://userapi-staging.s2f.projectx.com";

    }

    getAll( cancelToken?: CancelToken): Promise<ChartSummaryModel[]> {
        let url_ = this.baseUrl + "/charts/all";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAll(_response);
        });
    }

    protected processGetAll(response: AxiosResponse): Promise<ChartSummaryModel[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ChartSummaryModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<ChartSummaryModel[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ChartSummaryModel[]>(null as any);
    }

    remove(id: string, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/charts/remove/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRemove(_response);
        });
    }

    protected processRemove(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    saveChart(model: ChartModel, cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/charts";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSaveChart(_response);
        });
    }

    protected processSaveChart(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;

            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    getChart(chartId: string, cancelToken?: CancelToken): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/charts/content/{chartId}";
        if (chartId === undefined || chartId === null)
            throw new Error("The parameter 'chartId' must be defined.");
        url_ = url_.replace("{chartId}", encodeURIComponent("" + chartId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetChart(_response);
        });
    }

    protected processGetChart(response: AxiosResponse): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }
}

export class ChartTemplatesClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "https://userapi-staging.s2f.projectx.com";

    }

    getAll( cancelToken?: CancelToken): Promise<string[]> {
        let url_ = this.baseUrl + "/chart-templates/all";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAll(_response);
        });
    }

    protected processGetAll(response: AxiosResponse): Promise<string[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<string[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string[]>(null as any);
    }

    remove(templateName: string, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/chart-templates/remove/{templateName}";
        if (templateName === undefined || templateName === null)
            throw new Error("The parameter 'templateName' must be defined.");
        url_ = url_.replace("{templateName}", encodeURIComponent("" + templateName));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRemove(_response);
        });
    }

    protected processRemove(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    saveChartTemplate(model: ChartTemplateModel, cancelToken?: CancelToken): Promise<number> {
        let url_ = this.baseUrl + "/chart-templates";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSaveChartTemplate(_response);
        });
    }

    protected processSaveChartTemplate(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;

            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }

    getChartTemplate(templateName: string, cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/chart-templates/content/{templateName}";
        if (templateName === undefined || templateName === null)
            throw new Error("The parameter 'templateName' must be defined.");
        url_ = url_.replace("{templateName}", encodeURIComponent("" + templateName));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetChartTemplate(_response);
        });
    }

    protected processGetChartTemplate(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;

            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }
}

export class ContractLimitClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "https://userapi-staging.s2f.projectx.com";

    }

    getAll(accountId: number, cancelToken?: CancelToken): Promise<RiskContractLimitModel[]> {
        let url_ = this.baseUrl + "/ContractLimit/all/{accountId}";
        if (accountId === undefined || accountId === null)
            throw new Error("The parameter 'accountId' must be defined.");
        url_ = url_.replace("{accountId}", encodeURIComponent("" + accountId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAll(_response);
        });
    }

    protected processGetAll(response: AxiosResponse): Promise<RiskContractLimitModel[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(RiskContractLimitModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<RiskContractLimitModel[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<RiskContractLimitModel[]>(null as any);
    }

    set(request: SetRiskContractLimitsRequest, cancelToken?: CancelToken): Promise<SetRiskContractLimitsResult> {
        let url_ = this.baseUrl + "/ContractLimit/set";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSet(_response);
        });
    }

    protected processSet(response: AxiosResponse): Promise<SetRiskContractLimitsResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = SetRiskContractLimitsResult.fromJS(resultData200);
            return Promise.resolve<SetRiskContractLimitsResult>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SetRiskContractLimitsResult>(null as any);
    }
}

export class DrawingTemplatesClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "https://userapi-staging.s2f.projectx.com";

    }

    getAll(toolName: string, cancelToken?: CancelToken): Promise<DrawingTemplateModel[]> {
        let url_ = this.baseUrl + "/drawing-templates/all/{toolName}";
        if (toolName === undefined || toolName === null)
            throw new Error("The parameter 'toolName' must be defined.");
        url_ = url_.replace("{toolName}", encodeURIComponent("" + toolName));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAll(_response);
        });
    }

    protected processGetAll(response: AxiosResponse): Promise<DrawingTemplateModel[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DrawingTemplateModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<DrawingTemplateModel[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DrawingTemplateModel[]>(null as any);
    }

    getAllNames(toolName: string, cancelToken?: CancelToken): Promise<string[]> {
        let url_ = this.baseUrl + "/drawing-templates/all/{toolName}/names";
        if (toolName === undefined || toolName === null)
            throw new Error("The parameter 'toolName' must be defined.");
        url_ = url_.replace("{toolName}", encodeURIComponent("" + toolName));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAllNames(_response);
        });
    }

    protected processGetAllNames(response: AxiosResponse): Promise<string[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<string[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string[]>(null as any);
    }

    removeDrawingTemplate(request: RemoveDrawingTemplateRequest, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/drawing-templates/remove";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRemoveDrawingTemplate(_response);
        });
    }

    protected processRemoveDrawingTemplate(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    saveDrawingTemplate(model: DrawingTemplateModel, cancelToken?: CancelToken): Promise<number> {
        let url_ = this.baseUrl + "/drawing-templates/save";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSaveDrawingTemplate(_response);
        });
    }

    protected processSaveDrawingTemplate(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;

            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }

    getDrawingTemplate(request: GetDrawingTemplateRequest, cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/drawing-templates/content";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetDrawingTemplate(_response);
        });
    }

    protected processGetDrawingTemplate(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;

            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * @deprecated
     */
    getDrawingTemplateDepracated(toolName: string, templateName: string, cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/drawing-templates/content/{toolName}/{templateName}";
        if (toolName === undefined || toolName === null)
            throw new Error("The parameter 'toolName' must be defined.");
        url_ = url_.replace("{toolName}", encodeURIComponent("" + toolName));
        if (templateName === undefined || templateName === null)
            throw new Error("The parameter 'templateName' must be defined.");
        url_ = url_.replace("{templateName}", encodeURIComponent("" + templateName));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetDrawingTemplateDepracated(_response);
        });
    }

    protected processGetDrawingTemplateDepracated(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;

            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * @deprecated
     */
    saveDrawingTemplateDepracated(model: DrawingTemplateModel, cancelToken?: CancelToken): Promise<number> {
        let url_ = this.baseUrl + "/drawing-templates";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSaveDrawingTemplateDepracated(_response);
        });
    }

    protected processSaveDrawingTemplateDepracated(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;

            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }

    /**
     * @deprecated
     */
    remove(toolName: string, templateName: string, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/drawing-templates/remove/{toolName}/{templateName}";
        if (toolName === undefined || toolName === null)
            throw new Error("The parameter 'toolName' must be defined.");
        url_ = url_.replace("{toolName}", encodeURIComponent("" + toolName));
        if (templateName === undefined || templateName === null)
            throw new Error("The parameter 'templateName' must be defined.");
        url_ = url_.replace("{templateName}", encodeURIComponent("" + templateName));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRemove(_response);
        });
    }

    protected processRemove(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

export class ForgotPasswordClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "https://userapi-staging.s2f.projectx.com";

    }

    /**
     * Begin the password reset process for a user.
    This will send out a password reset email to the user.
     * @param userName (optional) The username associated with the user
     */
    get(userName: string | undefined, cancelToken?: CancelToken): Promise<PasswordResetResult> {
        let url_ = this.baseUrl + "/ForgotPassword?";
        if (userName === null)
            throw new Error("The parameter 'userName' cannot be null.");
        else if (userName !== undefined)
            url_ += "userName=" + encodeURIComponent("" + userName) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: AxiosResponse): Promise<PasswordResetResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;

            return Promise.resolve<PasswordResetResult>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PasswordResetResult>(null as any);
    }

    /**
     * Complete the password reset process for a user.
     */
    post(request: PasswordResetRequest, cancelToken?: CancelToken): Promise<PasswordResetResult> {
        let url_ = this.baseUrl + "/ForgotPassword";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPost(_response);
        });
    }

    protected processPost(response: AxiosResponse): Promise<PasswordResetResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;

            return Promise.resolve<PasswordResetResult>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PasswordResetResult>(null as any);
    }
}

export class JournalLogClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "https://userapi-staging.s2f.projectx.com";

    }

    upsert(model: JournalLogUpsertRequest, cancelToken?: CancelToken): Promise<JournalLogUpsertResponse> {
        let url_ = this.baseUrl + "/JournalLog/upsert";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpsert(_response);
        });
    }

    protected processUpsert(response: AxiosResponse): Promise<JournalLogUpsertResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JournalLogUpsertResponse.fromJS(resultData200);
            return Promise.resolve<JournalLogUpsertResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<JournalLogUpsertResponse>(null as any);
    }

    getForDay(model: GetJournalLogDayRequest, cancelToken?: CancelToken): Promise<JournalLog[]> {
        let url_ = this.baseUrl + "/JournalLog/getForDay";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetForDay(_response);
        });
    }

    protected processGetForDay(response: AxiosResponse): Promise<JournalLog[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(JournalLog.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<JournalLog[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<JournalLog[]>(null as any);
    }

    getForTrade(model: GetJournalLogTradeRequest, cancelToken?: CancelToken): Promise<JournalLog> {
        let url_ = this.baseUrl + "/JournalLog/getForTrade";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetForTrade(_response);
        });
    }

    protected processGetForTrade(response: AxiosResponse): Promise<JournalLog> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JournalLog.fromJS(resultData200);
            return Promise.resolve<JournalLog>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<JournalLog>(null as any);
    }

    getForRange(model: GetJournalLogRangeRequest, cancelToken?: CancelToken): Promise<JournalLog[]> {
        let url_ = this.baseUrl + "/JournalLog/getForRange";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetForRange(_response);
        });
    }

    protected processGetForRange(response: AxiosResponse): Promise<JournalLog[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(JournalLog.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<JournalLog[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<JournalLog[]>(null as any);
    }

    delete(model: DeleteJournalLogRequest, cancelToken?: CancelToken): Promise<boolean> {
        let url_ = this.baseUrl + "/JournalLog/delete";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "DELETE",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;

            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }
}

export class LayoutsClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "https://userapi-staging.s2f.projectx.com";

    }

    post(model: LayoutModel, cancelToken?: CancelToken): Promise<number> {
        let url_ = this.baseUrl + "/Layouts";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPost(_response);
        });
    }

    protected processPost(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;

            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }

    delete(id: number | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/Layouts?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    get( cancelToken?: CancelToken): Promise<LayoutModel[]> {
        let url_ = this.baseUrl + "/Layouts";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: AxiosResponse): Promise<LayoutModel[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(LayoutModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<LayoutModel[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<LayoutModel[]>(null as any);
    }
}

export class LineToolsClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "https://userapi-staging.s2f.projectx.com";

    }

    load(layoutId: string, chartId: string, cancelToken?: CancelToken): Promise<LineToolsModel> {
        let url_ = this.baseUrl + "/line-tools/load/{layoutId}/{chartId}";
        if (layoutId === undefined || layoutId === null)
            throw new Error("The parameter 'layoutId' must be defined.");
        url_ = url_.replace("{layoutId}", encodeURIComponent("" + layoutId));
        if (chartId === undefined || chartId === null)
            throw new Error("The parameter 'chartId' must be defined.");
        url_ = url_.replace("{chartId}", encodeURIComponent("" + chartId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processLoad(_response);
        });
    }

    protected processLoad(response: AxiosResponse): Promise<LineToolsModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = LineToolsModel.fromJS(resultData200);
            return Promise.resolve<LineToolsModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<LineToolsModel>(null as any);
    }

    remove(id: number, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/line-tools/remove/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRemove(_response);
        });
    }

    protected processRemove(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    saveLineTool(model: LineToolsModel, cancelToken?: CancelToken): Promise<number> {
        let url_ = this.baseUrl + "/line-tools";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSaveLineTool(_response);
        });
    }

    protected processSaveLineTool(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;

            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }
}

export class LinkedOrderClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "https://userapi-staging.s2f.projectx.com";

    }

    unlinkOrders(request: UnlinkOrderUserRequest, cancelToken?: CancelToken): Promise<UnlinkOrderUserResponse> {
        let url_ = this.baseUrl + "/LinkedOrder";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "DELETE",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUnlinkOrders(_response);
        });
    }

    protected processUnlinkOrders(response: AxiosResponse): Promise<UnlinkOrderUserResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = UnlinkOrderUserResponse.fromJS(resultData200);
            return Promise.resolve<UnlinkOrderUserResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UnlinkOrderUserResponse>(null as any);
    }

    getLinkedOrders(tradingAccountId: number | undefined, cancelToken?: CancelToken): Promise<GetLinkedOrdersResponse> {
        let url_ = this.baseUrl + "/LinkedOrder?";
        if (tradingAccountId === null)
            throw new Error("The parameter 'tradingAccountId' cannot be null.");
        else if (tradingAccountId !== undefined)
            url_ += "tradingAccountId=" + encodeURIComponent("" + tradingAccountId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetLinkedOrders(_response);
        });
    }

    protected processGetLinkedOrders(response: AxiosResponse): Promise<GetLinkedOrdersResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetLinkedOrdersResponse.fromJS(resultData200);
            return Promise.resolve<GetLinkedOrdersResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetLinkedOrdersResponse>(null as any);
    }

    linkOrders(request: LinkOrderUserRequest, cancelToken?: CancelToken): Promise<LinkOrderUserResponse> {
        let url_ = this.baseUrl + "/LinkedOrder";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processLinkOrders(_response);
        });
    }

    protected processLinkOrders(response: AxiosResponse): Promise<LinkOrderUserResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = LinkOrderUserResponse.fromJS(resultData200);
            return Promise.resolve<LinkOrderUserResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<LinkOrderUserResponse>(null as any);
    }
}

export class LoginClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "https://userapi-staging.s2f.projectx.com";

    }

    /**
     * Authenticates a user based on the provided login request.
     * @param model A login request model containing the username and password of the user.
     * @return A model containing the result of the login attempt and the token, if successful.
     */
    login(model: LoginRequestModel, cancelToken?: CancelToken): Promise<LoginResultModel> {
        let url_ = this.baseUrl + "/Login";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processLogin(_response);
        });
    }

    protected processLogin(response: AxiosResponse): Promise<LoginResultModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = LoginResultModel.fromJS(resultData200);
            return Promise.resolve<LoginResultModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<LoginResultModel>(null as any);
    }

    apiLogin(request: ApiKeyLoginRequest, cancelToken?: CancelToken): Promise<LoginResultModel> {
        let url_ = this.baseUrl + "/Login/key";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processApiLogin(_response);
        });
    }

    protected processApiLogin(response: AxiosResponse): Promise<LoginResultModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = LoginResultModel.fromJS(resultData200);
            return Promise.resolve<LoginResultModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<LoginResultModel>(null as any);
    }
}

export class MarketClosureClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "https://userapi-staging.s2f.projectx.com";

    }

    get( cancelToken?: CancelToken): Promise<MarketClosureModel[]> {
        let url_ = this.baseUrl + "/MarketClosure";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: AxiosResponse): Promise<MarketClosureModel[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(MarketClosureModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<MarketClosureModel[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<MarketClosureModel[]>(null as any);
    }
}

export class MarketStatusClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "https://userapi-staging.s2f.projectx.com";

    }

    /**
     * @deprecated
     */
    get( cancelToken?: CancelToken): Promise<MarketStatusSummary> {
        let url_ = this.baseUrl + "/MarketStatus";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: AxiosResponse): Promise<MarketStatusSummary> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = MarketStatusSummary.fromJS(resultData200);
            return Promise.resolve<MarketStatusSummary>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<MarketStatusSummary>(null as any);
    }

    getSummary( cancelToken?: CancelToken): Promise<MarketStatusSummary> {
        let url_ = this.baseUrl + "/MarketStatus/summary";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetSummary(_response);
        });
    }

    protected processGetSummary(response: AxiosResponse): Promise<MarketStatusSummary> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = MarketStatusSummary.fromJS(resultData200);
            return Promise.resolve<MarketStatusSummary>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<MarketStatusSummary>(null as any);
    }

    getMarkets( cancelToken?: CancelToken): Promise<MarketStatus[]> {
        let url_ = this.baseUrl + "/MarketStatus/markets";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetMarkets(_response);
        });
    }

    protected processGetMarkets(response: AxiosResponse): Promise<MarketStatus[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(MarketStatus.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<MarketStatus[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<MarketStatus[]>(null as any);
    }

    setMarketStatus(request: SetSingleMarketStatusRequest, cancelToken?: CancelToken): Promise<SetMarketStatusResponse> {
        let url_ = this.baseUrl + "/MarketStatus/setStatus";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSetMarketStatus(_response);
        });
    }

    protected processSetMarketStatus(response: AxiosResponse): Promise<SetMarketStatusResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = SetMarketStatusResponse.fromJS(resultData200);
            return Promise.resolve<SetMarketStatusResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SetMarketStatusResponse>(null as any);
    }

    setAllMarketStatus(request: SetManyMarketStatusRequest, cancelToken?: CancelToken): Promise<SetManyMarketStatusResponse> {
        let url_ = this.baseUrl + "/MarketStatus/setStatus/all";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSetAllMarketStatus(_response);
        });
    }

    protected processSetAllMarketStatus(response: AxiosResponse): Promise<SetManyMarketStatusResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = SetManyMarketStatusResponse.fromJS(resultData200);
            return Promise.resolve<SetManyMarketStatusResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SetManyMarketStatusResponse>(null as any);
    }

    resetMarketStatus(request: ResetSingleMarketStatusRequest, cancelToken?: CancelToken): Promise<SetMarketStatusResponse> {
        let url_ = this.baseUrl + "/MarketStatus/resetStatus";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processResetMarketStatus(_response);
        });
    }

    protected processResetMarketStatus(response: AxiosResponse): Promise<SetMarketStatusResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = SetMarketStatusResponse.fromJS(resultData200);
            return Promise.resolve<SetMarketStatusResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SetMarketStatusResponse>(null as any);
    }

    resetAllMarketStatus( cancelToken?: CancelToken): Promise<SetManyMarketStatusResponse> {
        let url_ = this.baseUrl + "/MarketStatus/resetStatus/all";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processResetAllMarketStatus(_response);
        });
    }

    protected processResetAllMarketStatus(response: AxiosResponse): Promise<SetManyMarketStatusResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = SetManyMarketStatusResponse.fromJS(resultData200);
            return Promise.resolve<SetManyMarketStatusResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SetManyMarketStatusResponse>(null as any);
    }

    debugMarketStatus(symbolId: string, num: number, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/MarketStatus/debug/{symbolId}/{num}";
        if (symbolId === undefined || symbolId === null)
            throw new Error("The parameter 'symbolId' must be defined.");
        url_ = url_.replace("{symbolId}", encodeURIComponent("" + symbolId));
        if (num === undefined || num === null)
            throw new Error("The parameter 'num' must be defined.");
        url_ = url_.replace("{num}", encodeURIComponent("" + num));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDebugMarketStatus(_response);
        });
    }

    protected processDebugMarketStatus(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

export class MetadataClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "https://userapi-staging.s2f.projectx.com";

    }

    get( cancelToken?: CancelToken): Promise<SymbolMetadata[]> {
        let url_ = this.baseUrl + "/Metadata";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: AxiosResponse): Promise<SymbolMetadata[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SymbolMetadata.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<SymbolMetadata[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SymbolMetadata[]>(null as any);
    }
}

export class MigrateDataClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "https://userapi-staging.s2f.projectx.com";

    }

    migrateChartsPartial(request: MigratePartialChartsRequest, cancelToken?: CancelToken): Promise<string[]> {
        let url_ = this.baseUrl + "/MigrateData/partialcharts";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processMigrateChartsPartial(_response);
        });
    }

    protected processMigrateChartsPartial(response: AxiosResponse): Promise<string[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<string[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string[]>(null as any);
    }

    migrateCharts(request: MigrateChartsRequest, cancelToken?: CancelToken): Promise<string[]> {
        let url_ = this.baseUrl + "/MigrateData/charts";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "GET",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processMigrateCharts(_response);
        });
    }

    protected processMigrateCharts(response: AxiosResponse): Promise<string[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<string[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string[]>(null as any);
    }
}

export class MultiFactorAuthenticationClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "https://userapi-staging.s2f.projectx.com";

    }

    create(request: Create2FARequest, cancelToken?: CancelToken): Promise<Create2FAErrorCode> {
        let url_ = this.baseUrl + "/MultiFactorAuthentication/create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreate(_response);
        });
    }

    protected processCreate(response: AxiosResponse): Promise<Create2FAErrorCode> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;

            return Promise.resolve<Create2FAErrorCode>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Create2FAErrorCode>(null as any);
    }

    submit2FA(token: string, cancelToken?: CancelToken): Promise<Submit2FAResult> {
        let url_ = this.baseUrl + "/MultiFactorAuthentication/submit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(token);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSubmit2FA(_response);
        });
    }

    protected processSubmit2FA(response: AxiosResponse): Promise<Submit2FAResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = Submit2FAResult.fromJS(resultData200);
            return Promise.resolve<Submit2FAResult>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Submit2FAResult>(null as any);
    }

    submitRecoveryCode(token: string, cancelToken?: CancelToken): Promise<SubmitRecoveryCodeResult> {
        let url_ = this.baseUrl + "/MultiFactorAuthentication/submitRecovery";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(token);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSubmitRecoveryCode(_response);
        });
    }

    protected processSubmitRecoveryCode(response: AxiosResponse): Promise<SubmitRecoveryCodeResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = SubmitRecoveryCodeResult.fromJS(resultData200);
            return Promise.resolve<SubmitRecoveryCodeResult>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SubmitRecoveryCodeResult>(null as any);
    }

    getRecoveryCodes(token: string, cancelToken?: CancelToken): Promise<GetRecoveryCodesResult> {
        let url_ = this.baseUrl + "/MultiFactorAuthentication/getRecoveryCodes";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(token);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetRecoveryCodes(_response);
        });
    }

    protected processGetRecoveryCodes(response: AxiosResponse): Promise<GetRecoveryCodesResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetRecoveryCodesResult.fromJS(resultData200);
            return Promise.resolve<GetRecoveryCodesResult>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetRecoveryCodesResult>(null as any);
    }

    regenerateRecoveryCodes( cancelToken?: CancelToken): Promise<RegenerateRecoveryCodesResult> {
        let url_ = this.baseUrl + "/MultiFactorAuthentication/regenerateRecoveryCodes";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRegenerateRecoveryCodes(_response);
        });
    }

    protected processRegenerateRecoveryCodes(response: AxiosResponse): Promise<RegenerateRecoveryCodesResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = RegenerateRecoveryCodesResult.fromJS(resultData200);
            return Promise.resolve<RegenerateRecoveryCodesResult>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<RegenerateRecoveryCodesResult>(null as any);
    }

    has2FA( cancelToken?: CancelToken): Promise<boolean> {
        let url_ = this.baseUrl + "/MultiFactorAuthentication/has2FA";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processHas2FA(_response);
        });
    }

    protected processHas2FA(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;

            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    disable2FA(token: string, cancelToken?: CancelToken): Promise<Disable2FAErrorCode> {
        let url_ = this.baseUrl + "/MultiFactorAuthentication/Disable2FA";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(token);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDisable2FA(_response);
        });
    }

    protected processDisable2FA(response: AxiosResponse): Promise<Disable2FAErrorCode> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;

            return Promise.resolve<Disable2FAErrorCode>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Disable2FAErrorCode>(null as any);
    }

    adminDisable2FA(userId: number, cancelToken?: CancelToken): Promise<Disable2FAErrorCode> {
        let url_ = this.baseUrl + "/MultiFactorAuthentication/AdminDisable2FA";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(userId);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAdminDisable2FA(_response);
        });
    }

    protected processAdminDisable2FA(response: AxiosResponse): Promise<Disable2FAErrorCode> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;

            return Promise.resolve<Disable2FAErrorCode>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Disable2FAErrorCode>(null as any);
    }
}

export class OrderClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "https://userapi-staging.s2f.projectx.com";

    }

    /**
     * Cancels all open orders for an account.
     * @param accountId The ID of the account.
     * @return A boolean that is true if the operation was successful; otherwise, false.
     */
    cancelAllAccountOrders(accountId: number, cancelToken?: CancelToken): Promise<boolean> {
        let url_ = this.baseUrl + "/Order/cancel/{accountId}/all";
        if (accountId === undefined || accountId === null)
            throw new Error("The parameter 'accountId' must be defined.");
        url_ = url_.replace("{accountId}", encodeURIComponent("" + accountId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCancelAllAccountOrders(_response);
        });
    }

    protected processCancelAllAccountOrders(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;

            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * Cancels all open orders on a symbol for an account.
     * @param accountId The ID of the account.
     * @param symbolId The ID of the symbol.
     * @return A boolean value indicating whether an order was cancelled.
     */
    cancelAccountOrderBySymbolId(accountId: number, symbolId: string, cancelToken?: CancelToken): Promise<boolean> {
        let url_ = this.baseUrl + "/Order/cancel/{accountId}/symbol/{symbolId}";
        if (accountId === undefined || accountId === null)
            throw new Error("The parameter 'accountId' must be defined.");
        url_ = url_.replace("{accountId}", encodeURIComponent("" + accountId));
        if (symbolId === undefined || symbolId === null)
            throw new Error("The parameter 'symbolId' must be defined.");
        url_ = url_.replace("{symbolId}", encodeURIComponent("" + symbolId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCancelAccountOrderBySymbolId(_response);
        });
    }

    protected processCancelAccountOrderBySymbolId(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;

            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * Cancels all open orders on a contract for an account.
     * @param accountId The ID of the account.
     * @param contractId The ID of the contract.
     * @return A boolean value indicating whether an order was cancelled.
     */
    cancelAccountOrderByContractId(accountId: number, contractId: string, cancelToken?: CancelToken): Promise<boolean> {
        let url_ = this.baseUrl + "/Order/cancel/{accountId}/contract/{contractId}";
        if (accountId === undefined || accountId === null)
            throw new Error("The parameter 'accountId' must be defined.");
        url_ = url_.replace("{accountId}", encodeURIComponent("" + accountId));
        if (contractId === undefined || contractId === null)
            throw new Error("The parameter 'contractId' must be defined.");
        url_ = url_.replace("{contractId}", encodeURIComponent("" + contractId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCancelAccountOrderByContractId(_response);
        });
    }

    protected processCancelAccountOrderByContractId(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;

            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * Updates the trailing distance of an existing order.
     * @param orderId The ID of the order to update.
     * @param trailingDistance (optional) The new trailing distance for the order.
     * @return A boolean value indicating whether the operation was successful.
     */
    putTrailingOrderDistance(orderId: number, trailingDistance: number | undefined, cancelToken?: CancelToken): Promise<boolean> {
        let url_ = this.baseUrl + "/Order/edit/trailingDistance/{orderId}?";
        if (orderId === undefined || orderId === null)
            throw new Error("The parameter 'orderId' must be defined.");
        url_ = url_.replace("{orderId}", encodeURIComponent("" + orderId));
        if (trailingDistance === null)
            throw new Error("The parameter 'trailingDistance' cannot be null.");
        else if (trailingDistance !== undefined)
            url_ += "trailingDistance=" + encodeURIComponent("" + trailingDistance) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "PUT",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPutTrailingOrderDistance(_response);
        });
    }

    protected processPutTrailingOrderDistance(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;

            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * Updates the limit price of an existing order.
     * @param orderId The ID of the order to update.
     * @param limitPrice (optional) The new limit price for the order.
     * @return A boolean value indicating whether the operation was successful.
     */
    editOrder(orderId: number, limitPrice: number | undefined, cancelToken?: CancelToken): Promise<boolean> {
        let url_ = this.baseUrl + "/Order/edit/stopLimit/{orderId}?";
        if (orderId === undefined || orderId === null)
            throw new Error("The parameter 'orderId' must be defined.");
        url_ = url_.replace("{orderId}", encodeURIComponent("" + orderId));
        if (limitPrice === null)
            throw new Error("The parameter 'limitPrice' cannot be null.");
        else if (limitPrice !== undefined)
            url_ += "limitPrice=" + encodeURIComponent("" + limitPrice) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "PATCH",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processEditOrder(_response);
        });
    }

    protected processEditOrder(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;

            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * Cancels an order for an account.
     * @param accountId The ID of the account.
     * @param orderId The ID of the order.
     * @return A boolean value indicating whether the cancellation was successful.
     */
    cancelAccountOrderById(accountId: number, orderId: number, cancelToken?: CancelToken): Promise<boolean> {
        let url_ = this.baseUrl + "/Order/cancel/{accountId}/id/{orderId}";
        if (accountId === undefined || accountId === null)
            throw new Error("The parameter 'accountId' must be defined.");
        url_ = url_.replace("{accountId}", encodeURIComponent("" + accountId));
        if (orderId === undefined || orderId === null)
            throw new Error("The parameter 'orderId' must be defined.");
        url_ = url_.replace("{orderId}", encodeURIComponent("" + orderId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCancelAccountOrderById(_response);
        });
    }

    protected processCancelAccountOrderById(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;

            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * Retrieves a list of recent orders for an account.
     * @param accountId (optional) The ID of the account.
     * @return A list of recent orders for the specified account.
     */
    get(accountId: number | undefined, cancelToken?: CancelToken): Promise<OrderModel[]> {
        let url_ = this.baseUrl + "/Order?";
        if (accountId === null)
            throw new Error("The parameter 'accountId' cannot be null.");
        else if (accountId !== undefined)
            url_ += "accountId=" + encodeURIComponent("" + accountId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: AxiosResponse): Promise<OrderModel[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(OrderModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<OrderModel[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<OrderModel[]>(null as any);
    }

    /**
     * Places an order.
     * @param request The request containing the details of the order to be placed.
     * @return A response containing the result of the order placement operation.
     */
    post(request: PlaceOrderRequest, cancelToken?: CancelToken): Promise<PlaceOrderResponse> {
        let url_ = this.baseUrl + "/Order";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPost(_response);
        });
    }

    protected processPost(response: AxiosResponse): Promise<PlaceOrderResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = PlaceOrderResponse.fromJS(resultData200);
            return Promise.resolve<PlaceOrderResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PlaceOrderResponse>(null as any);
    }

    userExportJson(request: UserExportRequest, cancelToken?: CancelToken): Promise<OrderExportModel[]> {
        let url_ = this.baseUrl + "/Order/user/export/json";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUserExportJson(_response);
        });
    }

    protected processUserExportJson(response: AxiosResponse): Promise<OrderExportModel[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(OrderExportModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<OrderExportModel[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<OrderExportModel[]>(null as any);
    }

    userExportCsv(request: UserExportRequest, cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/Order/user/export/csv";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUserExportCsv(_response);
        });
    }

    protected processUserExportCsv(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    updateStopLossAccount(request: UpdateStopLossAccountRequest, cancelToken?: CancelToken): Promise<UpdateStopLossResponse> {
        let url_ = this.baseUrl + "/Order/editStopLossAccount";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateStopLossAccount(_response);
        });
    }

    protected processUpdateStopLossAccount(response: AxiosResponse): Promise<UpdateStopLossResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = UpdateStopLossResponse.fromJS(resultData200);
            return Promise.resolve<UpdateStopLossResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UpdateStopLossResponse>(null as any);
    }

    /**
     * @deprecated
     */
    updateStopLoss(request: UpdateStopLossRequest, cancelToken?: CancelToken): Promise<UpdateStopLossResponse> {
        let url_ = this.baseUrl + "/Order/editStopLoss";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateStopLoss(_response);
        });
    }

    protected processUpdateStopLoss(response: AxiosResponse): Promise<UpdateStopLossResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = UpdateStopLossResponse.fromJS(resultData200);
            return Promise.resolve<UpdateStopLossResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UpdateStopLossResponse>(null as any);
    }

    /**
     * Places an order.
     * @param request The request containing the details of the order to be placed.
     * @return A response containing the result of the order placement operation.
     */
    postWithContract(request: PlaceOrderRequest, cancelToken?: CancelToken): Promise<PlaceOrderResponse> {
        let url_ = this.baseUrl + "/Order/postWithContract";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPostWithContract(_response);
        });
    }

    protected processPostWithContract(response: AxiosResponse): Promise<PlaceOrderResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = PlaceOrderResponse.fromJS(resultData200);
            return Promise.resolve<PlaceOrderResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PlaceOrderResponse>(null as any);
    }
}

export class PersonalLockoutClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "https://userapi-staging.s2f.projectx.com";

    }

    getActive(tradingAccountId: number, cancelToken?: CancelToken): Promise<PersonalLockoutModel[]> {
        let url_ = this.baseUrl + "/PersonalLockout/active/{tradingAccountId}";
        if (tradingAccountId === undefined || tradingAccountId === null)
            throw new Error("The parameter 'tradingAccountId' must be defined.");
        url_ = url_.replace("{tradingAccountId}", encodeURIComponent("" + tradingAccountId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetActive(_response);
        });
    }

    protected processGetActive(response: AxiosResponse): Promise<PersonalLockoutModel[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PersonalLockoutModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<PersonalLockoutModel[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PersonalLockoutModel[]>(null as any);
    }

    getAll(tradingAccountId: number | undefined, cancelToken?: CancelToken): Promise<PersonalLockoutModel[]> {
        let url_ = this.baseUrl + "/PersonalLockout/all?";
        if (tradingAccountId === null)
            throw new Error("The parameter 'tradingAccountId' cannot be null.");
        else if (tradingAccountId !== undefined)
            url_ += "tradingAccountId=" + encodeURIComponent("" + tradingAccountId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAll(_response);
        });
    }

    protected processGetAll(response: AxiosResponse): Promise<PersonalLockoutModel[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PersonalLockoutModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<PersonalLockoutModel[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PersonalLockoutModel[]>(null as any);
    }

    add(lockouts: PersonalLockoutModel[], cancelToken?: CancelToken): Promise<SetPersonalLockoutResult> {
        let url_ = this.baseUrl + "/PersonalLockout/add";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(lockouts);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAdd(_response);
        });
    }

    protected processAdd(response: AxiosResponse): Promise<SetPersonalLockoutResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = SetPersonalLockoutResult.fromJS(resultData200);
            return Promise.resolve<SetPersonalLockoutResult>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SetPersonalLockoutResult>(null as any);
    }
}

export class PositionClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "https://userapi-staging.s2f.projectx.com";

    }

    /**
     * Closes an open position on the symbol for an account.
     * @param accountId The ID of the account.
     * @param symbolId The ID of the symbol to be closed.
     */
    close(accountId: number, symbolId: string, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/Position/close/{accountId}/symbol/{symbolId}";
        if (accountId === undefined || accountId === null)
            throw new Error("The parameter 'accountId' must be defined.");
        url_ = url_.replace("{accountId}", encodeURIComponent("" + accountId));
        if (symbolId === undefined || symbolId === null)
            throw new Error("The parameter 'symbolId' must be defined.");
        url_ = url_.replace("{symbolId}", encodeURIComponent("" + symbolId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processClose(_response);
        });
    }

    protected processClose(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Closes an open position on the contract for an account.
     * @param accountId The ID of the account.
     * @param contractId The ID of the contract to be closed.
     */
    closeByContract(accountId: number, contractId: string, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/Position/close/{accountId}/contract/{contractId}";
        if (accountId === undefined || accountId === null)
            throw new Error("The parameter 'accountId' must be defined.");
        url_ = url_.replace("{accountId}", encodeURIComponent("" + accountId));
        if (contractId === undefined || contractId === null)
            throw new Error("The parameter 'contractId' must be defined.");
        url_ = url_.replace("{contractId}", encodeURIComponent("" + contractId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCloseByContract(_response);
        });
    }

    protected processCloseByContract(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Closes all open positions for an account.
     * @param accountId The ID of the account.
     */
    closeAll(accountId: number, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/Position/close/{accountId}";
        if (accountId === undefined || accountId === null)
            throw new Error("The parameter 'accountId' must be defined.");
        url_ = url_.replace("{accountId}", encodeURIComponent("" + accountId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCloseAll(_response);
        });
    }

    protected processCloseAll(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Updates the to-risk and to-make targets for a position.
     * @param positionId (optional)
     * @param risk (optional)
     * @param toMake (optional)
     * @return A StopLossTakeProfitModel containing the updated stop-loss and take-profit values.
     */
    putRiskToMake(positionId: number | undefined, risk: number | null | undefined, toMake: number | null | undefined, cancelToken?: CancelToken): Promise<StopLossTakeProfitModel> {
        let url_ = this.baseUrl + "/Position/riskToMake?";
        if (positionId === null)
            throw new Error("The parameter 'positionId' cannot be null.");
        else if (positionId !== undefined)
            url_ += "PositionId=" + encodeURIComponent("" + positionId) + "&";
        if (risk !== undefined && risk !== null)
            url_ += "Risk=" + encodeURIComponent("" + risk) + "&";
        if (toMake !== undefined && toMake !== null)
            url_ += "ToMake=" + encodeURIComponent("" + toMake) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "PUT",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPutRiskToMake(_response);
        });
    }

    protected processPutRiskToMake(response: AxiosResponse): Promise<StopLossTakeProfitModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = StopLossTakeProfitModel.fromJS(resultData200);
            return Promise.resolve<StopLossTakeProfitModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<StopLossTakeProfitModel>(null as any);
    }

    /**
     * Updates the stop-loss and take-profit values for a position.
     * @param positionId (optional)
     * @param stopLoss (optional)
     * @param takeProfit (optional)
     * @param errorMessage (optional)
     * @param cancellationSource (optional)
     * @return A StopLossTakeProfitModel containing the updated stop-loss and take-profit values.
     */
    putSltp(positionId: number | undefined, stopLoss: number | null | undefined, takeProfit: number | null | undefined, errorMessage: string | null | undefined, cancellationSource: LegacyOrderCancellationSource | undefined, cancelToken?: CancelToken): Promise<UpdateStopLossTakeProfitResult> {
        let url_ = this.baseUrl + "/Position/sltp?";
        if (positionId === null)
            throw new Error("The parameter 'positionId' cannot be null.");
        else if (positionId !== undefined)
            url_ += "PositionId=" + encodeURIComponent("" + positionId) + "&";
        if (stopLoss !== undefined && stopLoss !== null)
            url_ += "StopLoss=" + encodeURIComponent("" + stopLoss) + "&";
        if (takeProfit !== undefined && takeProfit !== null)
            url_ += "TakeProfit=" + encodeURIComponent("" + takeProfit) + "&";
        if (errorMessage !== undefined && errorMessage !== null)
            url_ += "ErrorMessage=" + encodeURIComponent("" + errorMessage) + "&";
        if (cancellationSource === null)
            throw new Error("The parameter 'cancellationSource' cannot be null.");
        else if (cancellationSource !== undefined)
            url_ += "CancellationSource=" + encodeURIComponent("" + cancellationSource) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "PUT",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPutSltp(_response);
        });
    }

    protected processPutSltp(response: AxiosResponse): Promise<UpdateStopLossTakeProfitResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = UpdateStopLossTakeProfitResult.fromJS(resultData200);
            return Promise.resolve<UpdateStopLossTakeProfitResult>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UpdateStopLossTakeProfitResult>(null as any);
    }

    /**
     * Reverses a position on a symbol for an account.
     * @param accountId (optional) The ID of the account.
     * @param symbol (optional) The ID of the symbol to be reversed.
     * @return A boolean indicating the success of the operation.
     */
    reverse(accountId: number | undefined, symbol: string | undefined, cancelToken?: CancelToken): Promise<boolean> {
        let url_ = this.baseUrl + "/Position/reverse?";
        if (accountId === null)
            throw new Error("The parameter 'accountId' cannot be null.");
        else if (accountId !== undefined)
            url_ += "accountId=" + encodeURIComponent("" + accountId) + "&";
        if (symbol === null)
            throw new Error("The parameter 'symbol' cannot be null.");
        else if (symbol !== undefined)
            url_ += "symbol=" + encodeURIComponent("" + symbol) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processReverse(_response);
        });
    }

    protected processReverse(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;

            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * Reverses a position on a contract for an account.
     * @param accountId (optional) The ID of the account.
     * @param contractId (optional) The ID of the contract to be reversed.
     * @return A boolean indicating the success of the operation.
     */
    reverseByContract(accountId: number | undefined, contractId: string | undefined, cancelToken?: CancelToken): Promise<boolean> {
        let url_ = this.baseUrl + "/Position/reverseByContract?";
        if (accountId === null)
            throw new Error("The parameter 'accountId' cannot be null.");
        else if (accountId !== undefined)
            url_ += "accountId=" + encodeURIComponent("" + accountId) + "&";
        if (contractId === null)
            throw new Error("The parameter 'contractId' cannot be null.");
        else if (contractId !== undefined)
            url_ += "contractId=" + encodeURIComponent("" + contractId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processReverseByContract(_response);
        });
    }

    protected processReverseByContract(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;

            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * Retrieves the open positions for a specific trading account.
     * @param accountId The ID of the account.
     * @return A list of PositionModel representing the open positions for the account.
     */
    getByTradingAccount(accountId: number, cancelToken?: CancelToken): Promise<PositionModel[]> {
        let url_ = this.baseUrl + "/Position/all/account/{accountId}";
        if (accountId === undefined || accountId === null)
            throw new Error("The parameter 'accountId' must be defined.");
        url_ = url_.replace("{accountId}", encodeURIComponent("" + accountId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetByTradingAccount(_response);
        });
    }

    protected processGetByTradingAccount(response: AxiosResponse): Promise<PositionModel[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PositionModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<PositionModel[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PositionModel[]>(null as any);
    }

    /**
     * Retrieves the open positions for an account.
     * @param accountId (optional) The ID of the account.
     * @return A list of PositionModel representing the open positions for the account.
     */
    get(accountId: number | undefined, cancelToken?: CancelToken): Promise<PositionModel[]> {
        let url_ = this.baseUrl + "/Position?";
        if (accountId === null)
            throw new Error("The parameter 'accountId' cannot be null.");
        else if (accountId !== undefined)
            url_ += "accountId=" + encodeURIComponent("" + accountId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: AxiosResponse): Promise<PositionModel[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PositionModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<PositionModel[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PositionModel[]>(null as any);
    }

    /**
     * Retrieves the open positions for the current user.
     * @param userId The ID of the user.
     * @return A list of PositionModel representing the open positions for the current user.
     */
    getAllByUser(userId: number, cancelToken?: CancelToken): Promise<PositionModel[]> {
        let url_ = this.baseUrl + "/Position/all/user/{userId}";
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAllByUser(_response);
        });
    }

    protected processGetAllByUser(response: AxiosResponse): Promise<PositionModel[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PositionModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<PositionModel[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PositionModel[]>(null as any);
    }
}

export class RegisterClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "https://userapi-staging.s2f.projectx.com";

    }

    register(model: RegisterRequest, cancelToken?: CancelToken): Promise<RegisterResponse> {
        let url_ = this.baseUrl + "/Register";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRegister(_response);
        });
    }

    protected processRegister(response: AxiosResponse): Promise<RegisterResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = RegisterResponse.fromJS(resultData200);
            return Promise.resolve<RegisterResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<RegisterResponse>(null as any);
    }
}

export class RiskSettingsLockoutClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "https://userapi-staging.s2f.projectx.com";

    }

    get(tradingAccountId: number, cancelToken?: CancelToken): Promise<RiskSettingsLockout> {
        let url_ = this.baseUrl + "/RiskSettingsLockout/active/{tradingAccountId}";
        if (tradingAccountId === undefined || tradingAccountId === null)
            throw new Error("The parameter 'tradingAccountId' must be defined.");
        url_ = url_.replace("{tradingAccountId}", encodeURIComponent("" + tradingAccountId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: AxiosResponse): Promise<RiskSettingsLockout> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = RiskSettingsLockout.fromJS(resultData200);
            return Promise.resolve<RiskSettingsLockout>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<RiskSettingsLockout>(null as any);
    }

    addForDay(tradingAccountId: number | undefined, cancelToken?: CancelToken): Promise<CreateRiskSettingsLockoutResult> {
        let url_ = this.baseUrl + "/RiskSettingsLockout/addForDay?";
        if (tradingAccountId === null)
            throw new Error("The parameter 'tradingAccountId' cannot be null.");
        else if (tradingAccountId !== undefined)
            url_ += "tradingAccountId=" + encodeURIComponent("" + tradingAccountId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAddForDay(_response);
        });
    }

    protected processAddForDay(response: AxiosResponse): Promise<CreateRiskSettingsLockoutResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CreateRiskSettingsLockoutResult.fromJS(resultData200);
            return Promise.resolve<CreateRiskSettingsLockoutResult>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CreateRiskSettingsLockoutResult>(null as any);
    }

    add(lockout: RiskSettingsLockoutModel, cancelToken?: CancelToken): Promise<CreateRiskSettingsLockoutResult> {
        let url_ = this.baseUrl + "/RiskSettingsLockout/add";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(lockout);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAdd(_response);
        });
    }

    protected processAdd(response: AxiosResponse): Promise<CreateRiskSettingsLockoutResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CreateRiskSettingsLockoutResult.fromJS(resultData200);
            return Promise.resolve<CreateRiskSettingsLockoutResult>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CreateRiskSettingsLockoutResult>(null as any);
    }
}

export class SessionClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "https://userapi-staging.s2f.projectx.com";

    }

    validate( cancelToken?: CancelToken): Promise<UserSessionValidateResponse> {
        let url_ = this.baseUrl + "/Session/validate";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processValidate(_response);
        });
    }

    protected processValidate(response: AxiosResponse): Promise<UserSessionValidateResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = UserSessionValidateResponse.fromJS(resultData200);
            return Promise.resolve<UserSessionValidateResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UserSessionValidateResponse>(null as any);
    }
}

export class StatisticsClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "https://userapi-staging.s2f.projectx.com";

    }

    getMonthly(model: GetMonthlyStatisticsRequest, cancelToken?: CancelToken): Promise<CompleteDayStatistic[]> {
        let url_ = this.baseUrl + "/Statistics/monthly";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetMonthly(_response);
        });
    }

    protected processGetMonthly(response: AxiosResponse): Promise<CompleteDayStatistic[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CompleteDayStatistic.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<CompleteDayStatistic[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CompleteDayStatistic[]>(null as any);
    }

    getWeekly(model: GetWeeklyStatisticsRequest, cancelToken?: CancelToken): Promise<CompleteDayStatistic[]> {
        let url_ = this.baseUrl + "/Statistics/weekly";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetWeekly(_response);
        });
    }

    protected processGetWeekly(response: AxiosResponse): Promise<CompleteDayStatistic[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CompleteDayStatistic.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<CompleteDayStatistic[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CompleteDayStatistic[]>(null as any);
    }

    getDaily(model: GetDailyStatisticsRequest, cancelToken?: CancelToken): Promise<CompleteDayStatistic[]> {
        let url_ = this.baseUrl + "/Statistics/daily";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetDaily(_response);
        });
    }

    protected processGetDaily(response: AxiosResponse): Promise<CompleteDayStatistic[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CompleteDayStatistic.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<CompleteDayStatistic[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CompleteDayStatistic[]>(null as any);
    }

    getProfitFactor(model: GetDailyStatisticsRequest, cancelToken?: CancelToken): Promise<ProfitFactorData> {
        let url_ = this.baseUrl + "/Statistics/profitFactor";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetProfitFactor(_response);
        });
    }

    protected processGetProfitFactor(response: AxiosResponse): Promise<ProfitFactorData> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ProfitFactorData.fromJS(resultData200);
            return Promise.resolve<ProfitFactorData>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ProfitFactorData>(null as any);
    }

    getLifetimeStats(model: GetLifetimeStatisticsRequest, cancelToken?: CancelToken): Promise<DayStatistic[]> {
        let url_ = this.baseUrl + "/Statistics/lifetimestats";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetLifetimeStats(_response);
        });
    }

    protected processGetLifetimeStats(response: AxiosResponse): Promise<DayStatistic[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DayStatistic.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<DayStatistic[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DayStatistic[]>(null as any);
    }

    getDayStats(model: GetDailyStatisticsRequest, cancelToken?: CancelToken): Promise<DayStatistic[]> {
        let url_ = this.baseUrl + "/Statistics/daystats";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetDayStats(_response);
        });
    }

    protected processGetDayStats(response: AxiosResponse): Promise<DayStatistic[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DayStatistic.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<DayStatistic[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DayStatistic[]>(null as any);
    }

    getTodayStats(accountId: number | undefined, cancelToken?: CancelToken): Promise<CompleteDayStatistic[]> {
        let url_ = this.baseUrl + "/Statistics/todaystats?";
        if (accountId === null)
            throw new Error("The parameter 'accountId' cannot be null.");
        else if (accountId !== undefined)
            url_ += "accountId=" + encodeURIComponent("" + accountId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetTodayStats(_response);
        });
    }

    protected processGetTodayStats(response: AxiosResponse): Promise<CompleteDayStatistic[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CompleteDayStatistic.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<CompleteDayStatistic[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CompleteDayStatistic[]>(null as any);
    }

    getTradesForDay(model: GetTradesForDayRequest, cancelToken?: CancelToken): Promise<TradeSummary[]> {
        let url_ = this.baseUrl + "/Statistics/daytrades";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetTradesForDay(_response);
        });
    }

    protected processGetTradesForDay(response: AxiosResponse): Promise<TradeSummary[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TradeSummary.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<TradeSummary[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<TradeSummary[]>(null as any);
    }

    getTradesForRange(model: GetDailyStatisticsRequest, cancelToken?: CancelToken): Promise<TradeSummary[]> {
        let url_ = this.baseUrl + "/Statistics/trades";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetTradesForRange(_response);
        });
    }

    protected processGetTradesForRange(response: AxiosResponse): Promise<TradeSummary[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TradeSummary.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<TradeSummary[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<TradeSummary[]>(null as any);
    }

    getWinLossAvg(model: GetDailyStatisticsRequest, cancelToken?: CancelToken): Promise<AverageWinLossData> {
        let url_ = this.baseUrl + "/Statistics/winlossavg";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetWinLossAvg(_response);
        });
    }

    protected processGetWinLossAvg(response: AxiosResponse): Promise<AverageWinLossData> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = AverageWinLossData.fromJS(resultData200);
            return Promise.resolve<AverageWinLossData>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AverageWinLossData>(null as any);
    }

    setAccountSharing(model: SetAccountSharingRequest, cancelToken?: CancelToken): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/Statistics/setSharing";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSetAccountSharing(_response);
        });
    }

    protected processSetAccountSharing(response: AxiosResponse): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    checkAccountSharing(tradingAccountId: number | undefined, cancelToken?: CancelToken): Promise<boolean> {
        let url_ = this.baseUrl + "/Statistics/checkSharing?";
        if (tradingAccountId === null)
            throw new Error("The parameter 'tradingAccountId' cannot be null.");
        else if (tradingAccountId !== undefined)
            url_ += "tradingAccountId=" + encodeURIComponent("" + tradingAccountId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCheckAccountSharing(_response);
        });
    }

    protected processCheckAccountSharing(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;

            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    getAccountName(tradingAccountId: number | undefined, cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/Statistics/getAccountName?";
        if (tradingAccountId === null)
            throw new Error("The parameter 'tradingAccountId' cannot be null.");
        else if (tradingAccountId !== undefined)
            url_ += "tradingAccountId=" + encodeURIComponent("" + tradingAccountId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAccountName(_response);
        });
    }

    protected processGetAccountName(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;

            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }
}

export class StudyTemplatesClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "https://userapi-staging.s2f.projectx.com";

    }

    getAll( cancelToken?: CancelToken): Promise<string[]> {
        let url_ = this.baseUrl + "/study-templates/all";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAll(_response);
        });
    }

    protected processGetAll(response: AxiosResponse): Promise<string[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<string[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string[]>(null as any);
    }

    removeByName(name: string, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/study-templates/removeByName/{name}";
        if (name === undefined || name === null)
            throw new Error("The parameter 'name' must be defined.");
        url_ = url_.replace("{name}", encodeURIComponent("" + name));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRemoveByName(_response);
        });
    }

    protected processRemoveByName(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    saveStudyTemplate(model: StudyTemplateModel, cancelToken?: CancelToken): Promise<number> {
        let url_ = this.baseUrl + "/study-templates";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSaveStudyTemplate(_response);
        });
    }

    protected processSaveStudyTemplate(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;

            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }

    getStudyTemplate(studyTemplateName: string, cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/study-templates/content/{studyTemplateName}";
        if (studyTemplateName === undefined || studyTemplateName === null)
            throw new Error("The parameter 'studyTemplateName' must be defined.");
        url_ = url_.replace("{studyTemplateName}", encodeURIComponent("" + studyTemplateName));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetStudyTemplate(_response);
        });
    }

    protected processGetStudyTemplate(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;

            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }
}

export class SymbolBlockClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "https://userapi-staging.s2f.projectx.com";

    }

    getAll(accountId: number, cancelToken?: CancelToken): Promise<RiskSymbolBlockModel[]> {
        let url_ = this.baseUrl + "/SymbolBlock/all/{accountId}";
        if (accountId === undefined || accountId === null)
            throw new Error("The parameter 'accountId' must be defined.");
        url_ = url_.replace("{accountId}", encodeURIComponent("" + accountId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAll(_response);
        });
    }

    protected processGetAll(response: AxiosResponse): Promise<RiskSymbolBlockModel[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(RiskSymbolBlockModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<RiskSymbolBlockModel[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<RiskSymbolBlockModel[]>(null as any);
    }

    set(request: SetRiskSymbolBlocksRequest, cancelToken?: CancelToken): Promise<SetRiskSymbolBlocksResult> {
        let url_ = this.baseUrl + "/SymbolBlock/set";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSet(_response);
        });
    }

    protected processSet(response: AxiosResponse): Promise<SetRiskSymbolBlocksResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = SetRiskSymbolBlocksResult.fromJS(resultData200);
            return Promise.resolve<SetRiskSymbolBlocksResult>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SetRiskSymbolBlocksResult>(null as any);
    }

    add(request: AddRiskSymbolBlockRequest, cancelToken?: CancelToken): Promise<AddRiskSymbolBlockResult> {
        let url_ = this.baseUrl + "/SymbolBlock/add";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAdd(_response);
        });
    }

    protected processAdd(response: AxiosResponse): Promise<AddRiskSymbolBlockResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = AddRiskSymbolBlockResult.fromJS(resultData200);
            return Promise.resolve<AddRiskSymbolBlockResult>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AddRiskSymbolBlockResult>(null as any);
    }

    remove(request: RemoveRiskSymbolBlockRequest, cancelToken?: CancelToken): Promise<RemoveRiskSymbolBlockResult> {
        let url_ = this.baseUrl + "/SymbolBlock/remove";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "DELETE",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRemove(_response);
        });
    }

    protected processRemove(response: AxiosResponse): Promise<RemoveRiskSymbolBlockResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = RemoveRiskSymbolBlockResult.fromJS(resultData200);
            return Promise.resolve<RemoveRiskSymbolBlockResult>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<RemoveRiskSymbolBlockResult>(null as any);
    }
}

export class TiltClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "https://userapi-staging.s2f.projectx.com";

    }

    activate(refreshCount: number | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/Tilt/activate?";
        if (refreshCount === null)
            throw new Error("The parameter 'refreshCount' cannot be null.");
        else if (refreshCount !== undefined)
            url_ += "refreshCount=" + encodeURIComponent("" + refreshCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processActivate(_response);
        });
    }

    protected processActivate(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    activateWithAccountId(accountId: number, refreshCount: number | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/Tilt/activate/{accountId}?";
        if (accountId === undefined || accountId === null)
            throw new Error("The parameter 'accountId' must be defined.");
        url_ = url_.replace("{accountId}", encodeURIComponent("" + accountId));
        if (refreshCount === null)
            throw new Error("The parameter 'refreshCount' cannot be null.");
        else if (refreshCount !== undefined)
            url_ += "refreshCount=" + encodeURIComponent("" + refreshCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processActivateWithAccountId(_response);
        });
    }

    protected processActivateWithAccountId(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

export class TradeClockClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "https://userapi-staging.s2f.projectx.com";

    }

    setTradeClock(request: SetTradeClockRequest, cancelToken?: CancelToken): Promise<SetTradeClockResponse> {
        let url_ = this.baseUrl + "/TradeClock";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSetTradeClock(_response);
        });
    }

    protected processSetTradeClock(response: AxiosResponse): Promise<SetTradeClockResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = SetTradeClockResponse.fromJS(resultData200);
            return Promise.resolve<SetTradeClockResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SetTradeClockResponse>(null as any);
    }
}

export class TradeClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "https://userapi-staging.s2f.projectx.com";

    }

    /**
     * Retrieves a list of filled trades for an account.
     * @param accountId The ID of the account.
     * @return A list of filled trades for the specified account.
     */
    get(accountId: number, cancelToken?: CancelToken): Promise<TradeModel[]> {
        let url_ = this.baseUrl + "/Trade/id/{accountId}";
        if (accountId === undefined || accountId === null)
            throw new Error("The parameter 'accountId' must be defined.");
        url_ = url_.replace("{accountId}", encodeURIComponent("" + accountId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: AxiosResponse): Promise<TradeModel[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TradeModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<TradeModel[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<TradeModel[]>(null as any);
    }

    getInRange(request: TradesInRangeRequest, cancelToken?: CancelToken): Promise<TradeModel[]> {
        let url_ = this.baseUrl + "/Trade/range";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetInRange(_response);
        });
    }

    protected processGetInRange(response: AxiosResponse): Promise<TradeModel[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TradeModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<TradeModel[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<TradeModel[]>(null as any);
    }

    userExportJson(request: UserExportTradeRequest, cancelToken?: CancelToken): Promise<TradeExportModel[]> {
        let url_ = this.baseUrl + "/Trade/user/export/json";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUserExportJson(_response);
        });
    }

    protected processUserExportJson(response: AxiosResponse): Promise<TradeExportModel[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TradeExportModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<TradeExportModel[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<TradeExportModel[]>(null as any);
    }

    userExportCsv(request: UserExportTradeRequest, cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/Trade/user/export/csv";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUserExportCsv(_response);
        });
    }

    protected processUserExportCsv(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }
}

export class TradeLimitClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "https://userapi-staging.s2f.projectx.com";

    }

    addTradeLimits(limits: TradeLimitsModel, cancelToken?: CancelToken): Promise<SetTradeLimitsResult> {
        let url_ = this.baseUrl + "/TradeLimit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(limits);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAddTradeLimits(_response);
        });
    }

    protected processAddTradeLimits(response: AxiosResponse): Promise<SetTradeLimitsResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = SetTradeLimitsResult.fromJS(resultData200);
            return Promise.resolve<SetTradeLimitsResult>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SetTradeLimitsResult>(null as any);
    }
}

export class TradingAccountClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "https://userapi-staging.s2f.projectx.com";

    }

    setAccountNickname(request: SetAccountNicknameRequest, cancelToken?: CancelToken): Promise<SetAccountNicknameResultCode> {
        let url_ = this.baseUrl + "/TradingAccount";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSetAccountNickname(_response);
        });
    }

    protected processSetAccountNickname(response: AxiosResponse): Promise<SetAccountNicknameResultCode> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;

            return Promise.resolve<SetAccountNicknameResultCode>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SetAccountNicknameResultCode>(null as any);
    }

    /**
     * Retrieves all accounts associated with the current user.
     * @return A list of TradingAccountModel representing the accounts of the current user.
     */
    get( cancelToken?: CancelToken): Promise<TradingAccountModel[]> {
        let url_ = this.baseUrl + "/TradingAccount";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: AxiosResponse): Promise<TradingAccountModel[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TradingAccountModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<TradingAccountModel[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<TradingAccountModel[]>(null as any);
    }

    /**
     * Sets the personal daily loss limit for an account.
     * @param accountId The ID of the account.
     * @param limit (optional) The new personal daily loss limit. If null, the personal daily loss limit will be removed.
     * @return A TradingAccountResult representing the result of the operation.
     */
    setPersonalDailyLossLimit(accountId: number, limit: number | null | undefined, cancelToken?: CancelToken): Promise<TradingAccountResult> {
        let url_ = this.baseUrl + "/TradingAccount/pdll/{accountId}?";
        if (accountId === undefined || accountId === null)
            throw new Error("The parameter 'accountId' must be defined.");
        url_ = url_.replace("{accountId}", encodeURIComponent("" + accountId));
        if (limit !== undefined && limit !== null)
            url_ += "limit=" + encodeURIComponent("" + limit) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "PUT",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSetPersonalDailyLossLimit(_response);
        });
    }

    protected processSetPersonalDailyLossLimit(response: AxiosResponse): Promise<TradingAccountResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;

            return Promise.resolve<TradingAccountResult>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<TradingAccountResult>(null as any);
    }

    setPersonalDailyLimits(request: PersonalDailyLimitsRequest, cancelToken?: CancelToken): Promise<PersonalDailyLimitsResponse> {
        let url_ = this.baseUrl + "/TradingAccount/personalLimits";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSetPersonalDailyLimits(_response);
        });
    }

    protected processSetPersonalDailyLimits(response: AxiosResponse): Promise<PersonalDailyLimitsResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = PersonalDailyLimitsResponse.fromJS(resultData200);
            return Promise.resolve<PersonalDailyLimitsResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PersonalDailyLimitsResponse>(null as any);
    }

    /**
     * Follows the trades made by another account.
     * @param request A request object containing the ID of the leader's account, the ID of the trading account, and the ratio for following.
     * @return A FollowTraderResponse indicating the success of the operation and any error message.
     */
    follow(request: FollowTraderRequest, cancelToken?: CancelToken): Promise<FollowTraderResponse> {
        let url_ = this.baseUrl + "/TradingAccount/follow";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processFollow(_response);
        });
    }

    protected processFollow(response: AxiosResponse): Promise<FollowTraderResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = FollowTraderResponse.fromJS(resultData200);
            return Promise.resolve<FollowTraderResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FollowTraderResponse>(null as any);
    }

    /**
     * Unfollows an account that is following another account and liquidates the account.
     * @param tradingAccountId (optional) The ID of the account to unfollow on.
     * @return A FollowTraderResponse indicating the success or failure of the operation.
     */
    unfollow(tradingAccountId: number | undefined, cancelToken?: CancelToken): Promise<FollowTraderResponse> {
        let url_ = this.baseUrl + "/TradingAccount/unfollow?";
        if (tradingAccountId === null)
            throw new Error("The parameter 'tradingAccountId' cannot be null.");
        else if (tradingAccountId !== undefined)
            url_ += "tradingAccountId=" + encodeURIComponent("" + tradingAccountId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUnfollow(_response);
        });
    }

    protected processUnfollow(response: AxiosResponse): Promise<FollowTraderResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = FollowTraderResponse.fromJS(resultData200);
            return Promise.resolve<FollowTraderResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FollowTraderResponse>(null as any);
    }

    /**
     * Clears all followers from an account.
     * @param tradingAccountId The ID of the account from which followers should be removed.
     * @return A boolean value that indicates whether the operation was successful.
     */
    clearFollowers(tradingAccountId: number, cancelToken?: CancelToken): Promise<boolean> {
        let url_ = this.baseUrl + "/TradingAccount/followers/clear/{tradingAccountId}";
        if (tradingAccountId === undefined || tradingAccountId === null)
            throw new Error("The parameter 'tradingAccountId' must be defined.");
        url_ = url_.replace("{tradingAccountId}", encodeURIComponent("" + tradingAccountId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processClearFollowers(_response);
        });
    }

    protected processClearFollowers(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;

            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * Retrieves a list of following accounts for the current user.
     * @return A list of FollowTraderEntry representing the accounts that the current user has for following trades.
     */
    getFollowEntries( cancelToken?: CancelToken): Promise<FollowTraderEntry[]> {
        let url_ = this.baseUrl + "/TradingAccount/followers";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetFollowEntries(_response);
        });
    }

    protected processGetFollowEntries(response: AxiosResponse): Promise<FollowTraderEntry[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FollowTraderEntry.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<FollowTraderEntry[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FollowTraderEntry[]>(null as any);
    }

    /**
     * Immediately stops all trading and liquidates the account. A "personal stop" violation will be added to the account for informational purposes.
     */
    stopTrading(tradingAccountId: number, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/TradingAccount/stopTrading/{tradingAccountId}";
        if (tradingAccountId === undefined || tradingAccountId === null)
            throw new Error("The parameter 'tradingAccountId' must be defined.");
        url_ = url_.replace("{tradingAccountId}", encodeURIComponent("" + tradingAccountId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "PUT",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processStopTrading(_response);
        });
    }

    protected processStopTrading(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

export class TradingAccountStateLogClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "https://userapi-staging.s2f.projectx.com";

    }

    getTradingAccountStateLog(request: TradingAccountStateLogRequest, cancelToken?: CancelToken): Promise<TradingAccountStateLogModel[]> {
        let url_ = this.baseUrl + "/TradingAccountStateLog";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetTradingAccountStateLog(_response);
        });
    }

    protected processGetTradingAccountStateLog(response: AxiosResponse): Promise<TradingAccountStateLogModel[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TradingAccountStateLogModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<TradingAccountStateLogModel[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<TradingAccountStateLogModel[]>(null as any);
    }
}

export class TradingRuleClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "https://userapi-staging.s2f.projectx.com";

    }

    getTradingRules( cancelToken?: CancelToken): Promise<TradingRuleModel[]> {
        let url_ = this.baseUrl + "/TradingRule";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetTradingRules(_response);
        });
    }

    protected processGetTradingRules(response: AxiosResponse): Promise<TradingRuleModel[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TradingRuleModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<TradingRuleModel[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<TradingRuleModel[]>(null as any);
    }
}

export class UserAgreementClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "https://userapi-staging.s2f.projectx.com";

    }

    get( cancelToken?: CancelToken): Promise<UserAgreementModel[]> {
        let url_ = this.baseUrl + "/UserAgreement";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: AxiosResponse): Promise<UserAgreementModel[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(UserAgreementModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<UserAgreementModel[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UserAgreementModel[]>(null as any);
    }

    sign(request: SignAgreementRequest, cancelToken?: CancelToken): Promise<UserAgreementModel[]> {
        let url_ = this.baseUrl + "/UserAgreement/sign";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSign(_response);
        });
    }

    protected processSign(response: AxiosResponse): Promise<UserAgreementModel[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(UserAgreementModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<UserAgreementModel[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UserAgreementModel[]>(null as any);
    }

    legacyGetRequired( cancelToken?: CancelToken): Promise<UserAgreementModel[]> {
        let url_ = this.baseUrl + "/UserAgreement/signed";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processLegacyGetRequired(_response);
        });
    }

    protected processLegacyGetRequired(response: AxiosResponse): Promise<UserAgreementModel[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(UserAgreementModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<UserAgreementModel[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UserAgreementModel[]>(null as any);
    }

    getRequired( cancelToken?: CancelToken): Promise<UserAgreementModel[]> {
        let url_ = this.baseUrl + "/UserAgreement/signed/v2";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetRequired(_response);
        });
    }

    protected processGetRequired(response: AxiosResponse): Promise<UserAgreementModel[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(UserAgreementModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<UserAgreementModel[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UserAgreementModel[]>(null as any);
    }
}

export class UserClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "https://userapi-staging.s2f.projectx.com";

    }

    /**
     * Retrieves details about the current user.
     * @return A UserModel containing the user's details.
     */
    get( cancelToken?: CancelToken): Promise<UserModel> {
        let url_ = this.baseUrl + "/User";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: AxiosResponse): Promise<UserModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = UserModel.fromJS(resultData200);
            return Promise.resolve<UserModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UserModel>(null as any);
    }

    /**
     * Updates the agreement status for a specific user or the current user if no user ID is provided.
     * @param userId (optional) The ID of the user. If null, the method will default to the current user.
     * @return A boolean indicating whether the operation was successful.
     */
    putAgreementsCompleted(userId: number | null | undefined, cancelToken?: CancelToken): Promise<boolean> {
        let url_ = this.baseUrl + "/User/agreementsCompleted?";
        if (userId !== undefined && userId !== null)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "PUT",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPutAgreementsCompleted(_response);
        });
    }

    protected processPutAgreementsCompleted(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;

            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    getIntercomHash( cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/User/intercom/hash";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetIntercomHash(_response);
        });
    }

    protected processGetIntercomHash(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;

            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Creates a new API key for the current user.
     * @return A CreateUserApiKeyResponse indicating the result of the operation.
     */
    createApiKey( cancelToken?: CancelToken): Promise<CreateUserApiKeyResponse> {
        let url_ = this.baseUrl + "/User/createApiKey";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateApiKey(_response);
        });
    }

    protected processCreateApiKey(response: AxiosResponse): Promise<CreateUserApiKeyResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CreateUserApiKeyResponse.fromJS(resultData200);
            return Promise.resolve<CreateUserApiKeyResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CreateUserApiKeyResponse>(null as any);
    }

    revokeApiKey(request: RevokeUserApiKeyRequest, cancelToken?: CancelToken): Promise<RevokeUserApiKeyResponse> {
        let url_ = this.baseUrl + "/User/revokeApiKey";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRevokeApiKey(_response);
        });
    }

    protected processRevokeApiKey(response: AxiosResponse): Promise<RevokeUserApiKeyResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = RevokeUserApiKeyResponse.fromJS(resultData200);
            return Promise.resolve<RevokeUserApiKeyResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<RevokeUserApiKeyResponse>(null as any);
    }

    getApiKeys( cancelToken?: CancelToken): Promise<UserApiKeyModel[]> {
        let url_ = this.baseUrl + "/User/apiKeys";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetApiKeys(_response);
        });
    }

    protected processGetApiKeys(response: AxiosResponse): Promise<UserApiKeyModel[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(UserApiKeyModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<UserApiKeyModel[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UserApiKeyModel[]>(null as any);
    }

    getDashboardLinkUrl( cancelToken?: CancelToken): Promise<DashboardLinkResponse> {
        let url_ = this.baseUrl + "/User/dashboardLink";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetDashboardLinkUrl(_response);
        });
    }

    protected processGetDashboardLinkUrl(response: AxiosResponse): Promise<DashboardLinkResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = DashboardLinkResponse.fromJS(resultData200);
            return Promise.resolve<DashboardLinkResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DashboardLinkResponse>(null as any);
    }

    /**
     * Returns the time in UTC.
    Used to ensure clock synchronization between the client and the server.
     */
    getCurrentTimeUtc( cancelToken?: CancelToken): Promise<dayjs.Dayjs> {
        let url_ = this.baseUrl + "/User/currentTimeUtc";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetCurrentTimeUtc(_response);
        });
    }

    protected processGetCurrentTimeUtc(response: AxiosResponse): Promise<dayjs.Dayjs> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 ? dayjs(resultData200.toString()) : <any>null;

            return Promise.resolve<dayjs.Dayjs>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<dayjs.Dayjs>(null as any);
    }
}

export class UserDataUploadClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "https://userapi-staging.s2f.projectx.com";

    }

    /**
     * @param contentType (optional)
     * @param contentDisposition (optional)
     * @param headers (optional)
     * @param length (optional)
     * @param name (optional)
     * @param fileName (optional)
     * @param file file
     */
    uploadUserData(contentType: string | undefined, contentDisposition: string | undefined, headers: Headers[] | undefined, length: number | undefined, name: string | undefined, fileName: string | undefined, file: FileParameter, cancelToken?: CancelToken): Promise<UserDataUploadResponse> {
        let url_ = this.baseUrl + "/UserDataUpload";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (contentType === null || contentType === undefined)
            throw new Error("The parameter 'contentType' cannot be null.");
        else
            content_.append("ContentType", contentType.toString());
        if (contentDisposition === null || contentDisposition === undefined)
            throw new Error("The parameter 'contentDisposition' cannot be null.");
        else
            content_.append("ContentDisposition", contentDisposition.toString());
        if (headers === null || headers === undefined)
            throw new Error("The parameter 'headers' cannot be null.");
        else
            headers.forEach(item_ => content_.append("Headers", item_.toString()));
        if (length === null || length === undefined)
            throw new Error("The parameter 'length' cannot be null.");
        else
            content_.append("Length", length.toString());
        if (name === null || name === undefined)
            throw new Error("The parameter 'name' cannot be null.");
        else
            content_.append("Name", name.toString());
        if (fileName === null || fileName === undefined)
            throw new Error("The parameter 'fileName' cannot be null.");
        else
            content_.append("FileName", fileName.toString());
        if (file === null || file === undefined)
            throw new Error("The parameter 'file' cannot be null.");
        else
            content_.append("file", file.data, file.fileName ? file.fileName : "file");

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUploadUserData(_response);
        });
    }

    protected processUploadUserData(response: AxiosResponse): Promise<UserDataUploadResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = UserDataUploadResponse.fromJS(resultData200);
            return Promise.resolve<UserDataUploadResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UserDataUploadResponse>(null as any);
    }
}

export class UserNotificationClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "https://userapi-staging.s2f.projectx.com";

    }

    getUnreadNotifications( cancelToken?: CancelToken): Promise<NotificationModel[]> {
        let url_ = this.baseUrl + "/UserNotification";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetUnreadNotifications(_response);
        });
    }

    protected processGetUnreadNotifications(response: AxiosResponse): Promise<NotificationModel[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(NotificationModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<NotificationModel[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<NotificationModel[]>(null as any);
    }

    readNotification(request: ReadNotificationRequest, cancelToken?: CancelToken): Promise<ReadNotificationResponse> {
        let url_ = this.baseUrl + "/UserNotification/read";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processReadNotification(_response);
        });
    }

    protected processReadNotification(response: AxiosResponse): Promise<ReadNotificationResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ReadNotificationResponse.fromJS(resultData200);
            return Promise.resolve<ReadNotificationResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ReadNotificationResponse>(null as any);
    }
}

export class UserRoleClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "https://userapi-staging.s2f.projectx.com";

    }

    getAvailableRoles( cancelToken?: CancelToken): Promise<RoleModel[]> {
        let url_ = this.baseUrl + "/UserRole/roles";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAvailableRoles(_response);
        });
    }

    protected processGetAvailableRoles(response: AxiosResponse): Promise<RoleModel[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(RoleModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<RoleModel[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<RoleModel[]>(null as any);
    }

    getUserRolesByUserId(userId: number, cancelToken?: CancelToken): Promise<UserRoleModel[]> {
        let url_ = this.baseUrl + "/UserRole/{userId}";
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetUserRolesByUserId(_response);
        });
    }

    protected processGetUserRolesByUserId(response: AxiosResponse): Promise<UserRoleModel[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(UserRoleModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<UserRoleModel[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UserRoleModel[]>(null as any);
    }

    getRolesByUserId(userId: number, cancelToken?: CancelToken): Promise<RoleModel[]> {
        let url_ = this.baseUrl + "/UserRole/{userId}/roles";
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetRolesByUserId(_response);
        });
    }

    protected processGetRolesByUserId(response: AxiosResponse): Promise<RoleModel[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(RoleModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<RoleModel[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<RoleModel[]>(null as any);
    }

    hasUserRole(userId: number, roleId: number, cancelToken?: CancelToken): Promise<boolean> {
        let url_ = this.baseUrl + "/UserRole/{userId}/has/{roleId}";
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        if (roleId === undefined || roleId === null)
            throw new Error("The parameter 'roleId' must be defined.");
        url_ = url_.replace("{roleId}", encodeURIComponent("" + roleId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processHasUserRole(_response);
        });
    }

    protected processHasUserRole(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;

            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }
}

export class UserSettingsClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "https://userapi-staging.s2f.projectx.com";

    }

    get( cancelToken?: CancelToken): Promise<UserSettingsModel> {
        let url_ = this.baseUrl + "/UserSettings";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: AxiosResponse): Promise<UserSettingsModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = UserSettingsModel.fromJS(resultData200);
            return Promise.resolve<UserSettingsModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UserSettingsModel>(null as any);
    }

    post(model: UserSettingsModel, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/UserSettings";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPost(_response);
        });
    }

    protected processPost(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

export class ViolationsClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "https://userapi-staging.s2f.projectx.com";

    }

    getActiveViolation(tradingAccountId: number, cancelToken?: CancelToken): Promise<ActiveViolationModel> {
        let url_ = this.baseUrl + "/Violations/active/{tradingAccountId}";
        if (tradingAccountId === undefined || tradingAccountId === null)
            throw new Error("The parameter 'tradingAccountId' must be defined.");
        url_ = url_.replace("{tradingAccountId}", encodeURIComponent("" + tradingAccountId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetActiveViolation(_response);
        });
    }

    protected processGetActiveViolation(response: AxiosResponse): Promise<ActiveViolationModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ActiveViolationModel.fromJS(resultData200);
            return Promise.resolve<ActiveViolationModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ActiveViolationModel>(null as any);
    }
}

export class UserContractModel implements IUserContractModel {
    /** This is the contract's parent product ID */
    productId!: string;
    /** This is the contract's parent product name (ex: ES, NQ, CL, etc) */
    productName!: string;
    /** This is the contract's ID */
    contractId!: string;
    /** This is the contract's name (ex: ESU21, NQU21, CLU21, etc) */
    contractName!: string;
    /** This is the contract cost per 1 tick movement */
    tickValue!: number;
    /** This is the minimum price movement for the contract */
    tickSize!: number;
    /** This is the value of a single point in the contract (TickValue / TickSize)
Used for calculating Profit and Loss (price difference * PointValue * Quantity) */
    pointValue!: number;
    /** This is the exchange fee for the contract */
    exchangeFee!: number;
    /** This is the regulatory fee for the contract */
    regulatoryFee!: number;
    /** This is the commission fee for the contract */
    commissionFee!: number;
    /** This is the total fees for the contract (ExchangeFee + RegulatoryFee + CommissionFee) for 1 contract */
    totalFees!: number;
    /** This is the contract's description */
    description!: string;
    /** Whether the contract is disabled globally or not */
    disabled!: boolean;
    /** Number of decimal places for the contract's price */
    decimalPlaces!: number;
    /** This is the contract's price scale */
    priceScale!: number;
    /** Value used by charts to calculate the minimum tick movement
             */
    minMove!: number;
    /** Whether the contract uses fractional pricing or not */
    fractionalPrice!: boolean;
    /** This is the contract's exchange */
    exchange!: string;
    /** Value used by charts to calculate the minimum tick movement for fractional prices */
    minMove2!: number;
    /** Whether this contract is for a professional subscription */
    isProfessional!: boolean;

    constructor(data?: IUserContractModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.productId = _data["productId"];
            this.productName = _data["productName"];
            this.contractId = _data["contractId"];
            this.contractName = _data["contractName"];
            this.tickValue = _data["tickValue"];
            this.tickSize = _data["tickSize"];
            this.pointValue = _data["pointValue"];
            this.exchangeFee = _data["exchangeFee"];
            this.regulatoryFee = _data["regulatoryFee"];
            this.commissionFee = _data["commissionFee"];
            this.totalFees = _data["totalFees"];
            this.description = _data["description"];
            this.disabled = _data["disabled"];
            this.decimalPlaces = _data["decimalPlaces"];
            this.priceScale = _data["priceScale"];
            this.minMove = _data["minMove"];
            this.fractionalPrice = _data["fractionalPrice"];
            this.exchange = _data["exchange"];
            this.minMove2 = _data["minMove2"];
            this.isProfessional = _data["isProfessional"];
        }
    }

    static fromJS(data: any): UserContractModel {
        data = typeof data === 'object' ? data : {};
        let result = new UserContractModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["productId"] = this.productId;
        data["productName"] = this.productName;
        data["contractId"] = this.contractId;
        data["contractName"] = this.contractName;
        data["tickValue"] = this.tickValue;
        data["tickSize"] = this.tickSize;
        data["pointValue"] = this.pointValue;
        data["exchangeFee"] = this.exchangeFee;
        data["regulatoryFee"] = this.regulatoryFee;
        data["commissionFee"] = this.commissionFee;
        data["totalFees"] = this.totalFees;
        data["description"] = this.description;
        data["disabled"] = this.disabled;
        data["decimalPlaces"] = this.decimalPlaces;
        data["priceScale"] = this.priceScale;
        data["minMove"] = this.minMove;
        data["fractionalPrice"] = this.fractionalPrice;
        data["exchange"] = this.exchange;
        data["minMove2"] = this.minMove2;
        data["isProfessional"] = this.isProfessional;
        return data;
    }
}

export interface IUserContractModel {
    /** This is the contract's parent product ID */
    productId: string;
    /** This is the contract's parent product name (ex: ES, NQ, CL, etc) */
    productName: string;
    /** This is the contract's ID */
    contractId: string;
    /** This is the contract's name (ex: ESU21, NQU21, CLU21, etc) */
    contractName: string;
    /** This is the contract cost per 1 tick movement */
    tickValue: number;
    /** This is the minimum price movement for the contract */
    tickSize: number;
    /** This is the value of a single point in the contract (TickValue / TickSize)
Used for calculating Profit and Loss (price difference * PointValue * Quantity) */
    pointValue: number;
    /** This is the exchange fee for the contract */
    exchangeFee: number;
    /** This is the regulatory fee for the contract */
    regulatoryFee: number;
    /** This is the commission fee for the contract */
    commissionFee: number;
    /** This is the total fees for the contract (ExchangeFee + RegulatoryFee + CommissionFee) for 1 contract */
    totalFees: number;
    /** This is the contract's description */
    description: string;
    /** Whether the contract is disabled globally or not */
    disabled: boolean;
    /** Number of decimal places for the contract's price */
    decimalPlaces: number;
    /** This is the contract's price scale */
    priceScale: number;
    /** Value used by charts to calculate the minimum tick movement
             */
    minMove: number;
    /** Whether the contract uses fractional pricing or not */
    fractionalPrice: boolean;
    /** This is the contract's exchange */
    exchange: string;
    /** Value used by charts to calculate the minimum tick movement for fractional prices */
    minMove2: number;
    /** Whether this contract is for a professional subscription */
    isProfessional: boolean;
}

export class AccountTemplateModel implements IAccountTemplateModel {
    id!: number;
    title!: string;
    titleColor?: string | undefined;
    description?: string | undefined;
    startingBalance!: number;
    margin!: number;
    tag!: Tag;
    limitCopyTradingToTemplate!: boolean;
    copyTradingGroup?: string | undefined;

    constructor(data?: IAccountTemplateModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.title = _data["title"];
            this.titleColor = _data["titleColor"];
            this.description = _data["description"];
            this.startingBalance = _data["startingBalance"];
            this.margin = _data["margin"];
            this.tag = _data["tag"];
            this.limitCopyTradingToTemplate = _data["limitCopyTradingToTemplate"];
            this.copyTradingGroup = _data["copyTradingGroup"];
        }
    }

    static fromJS(data: any): AccountTemplateModel {
        data = typeof data === 'object' ? data : {};
        let result = new AccountTemplateModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["title"] = this.title;
        data["titleColor"] = this.titleColor;
        data["description"] = this.description;
        data["startingBalance"] = this.startingBalance;
        data["margin"] = this.margin;
        data["tag"] = this.tag;
        data["limitCopyTradingToTemplate"] = this.limitCopyTradingToTemplate;
        data["copyTradingGroup"] = this.copyTradingGroup;
        return data;
    }
}

export interface IAccountTemplateModel {
    id: number;
    title: string;
    titleColor?: string | undefined;
    description?: string | undefined;
    startingBalance: number;
    margin: number;
    tag: Tag;
    limitCopyTradingToTemplate: boolean;
    copyTradingGroup?: string | undefined;
}

/** 0 = None 1 = Practice */
export enum Tag {
    None = 0,
    Practice = 1,
}

export class AccountTemplateRuleModel implements IAccountTemplateRuleModel {
    accountTemplateId!: number;
    ruleId!: TradingRuleType;
    configuration!: RuleConfiguration;

    constructor(data?: IAccountTemplateRuleModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.configuration = new RuleConfiguration();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accountTemplateId = _data["accountTemplateId"];
            this.ruleId = _data["ruleId"];
            this.configuration = _data["configuration"] ? RuleConfiguration.fromJS(_data["configuration"]) : new RuleConfiguration();
        }
    }

    static fromJS(data: any): AccountTemplateRuleModel {
        data = typeof data === 'object' ? data : {};
        let result = new AccountTemplateRuleModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accountTemplateId"] = this.accountTemplateId;
        data["ruleId"] = this.ruleId;
        data["configuration"] = this.configuration ? this.configuration.toJSON() : <any>undefined;
        return data;
    }
}

export interface IAccountTemplateRuleModel {
    accountTemplateId: number;
    ruleId: TradingRuleType;
    configuration: RuleConfiguration;
}

/** 0 = Undefined 1 = DailyLossLimit 2 = MaximumLossLimit 3 = MarginScale */
export enum TradingRuleType {
    Undefined = 0,
    DailyLossLimit = 1,
    MaximumLossLimit = 2,
    MarginScale = 3,
}

export class RuleConfiguration implements IRuleConfiguration {
    violationStatus?: TradingAccountStatus | undefined;
    violationDuration?: ViolationDuration | undefined;
    liquidateFollowers?: boolean | undefined;
    dailyLossLimit?: DailyLossLimitConfiguration | undefined;
    maximumLossLimit?: MaximumLossLimitConfiguration | undefined;
    marginScale?: MarginScaleConfiguration | undefined;

    constructor(data?: IRuleConfiguration) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.violationStatus = _data["violationStatus"];
            this.violationDuration = _data["violationDuration"];
            this.liquidateFollowers = _data["liquidateFollowers"];
            this.dailyLossLimit = _data["dailyLossLimit"] ? DailyLossLimitConfiguration.fromJS(_data["dailyLossLimit"]) : <any>undefined;
            this.maximumLossLimit = _data["maximumLossLimit"] ? MaximumLossLimitConfiguration.fromJS(_data["maximumLossLimit"]) : <any>undefined;
            this.marginScale = _data["marginScale"] ? MarginScaleConfiguration.fromJS(_data["marginScale"]) : <any>undefined;
        }
    }

    static fromJS(data: any): RuleConfiguration {
        data = typeof data === 'object' ? data : {};
        let result = new RuleConfiguration();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["violationStatus"] = this.violationStatus;
        data["violationDuration"] = this.violationDuration;
        data["liquidateFollowers"] = this.liquidateFollowers;
        data["dailyLossLimit"] = this.dailyLossLimit ? this.dailyLossLimit.toJSON() : <any>undefined;
        data["maximumLossLimit"] = this.maximumLossLimit ? this.maximumLossLimit.toJSON() : <any>undefined;
        data["marginScale"] = this.marginScale ? this.marginScale.toJSON() : <any>undefined;
        return data;
    }
}

export interface IRuleConfiguration {
    violationStatus?: TradingAccountStatus | undefined;
    violationDuration?: ViolationDuration | undefined;
    liquidateFollowers?: boolean | undefined;
    dailyLossLimit?: DailyLossLimitConfiguration | undefined;
    maximumLossLimit?: MaximumLossLimitConfiguration | undefined;
    marginScale?: MarginScaleConfiguration | undefined;
}

/** 0 = Active 1 = TemporaryViolation 2 = Violation 3 = Inactive 4 = Closed 5 = GoalAchieved 6 = Ineligible 7 = Paused */
export enum TradingAccountStatus {
    Active = 0,
    TemporaryViolation = 1,
    Violation = 2,
    Inactive = 3,
    Closed = 4,
    GoalAchieved = 5,
    Ineligible = 6,
    Paused = 7,
}

/** 0 = Unspecified 1 = Permanent 2 = Temporary */
export enum ViolationDuration {
    Unspecified = 0,
    Permanent = 1,
    Temporary = 2,
}

export class DailyLossLimitConfiguration implements IDailyLossLimitConfiguration {
    source!: BalanceSource;
    percentage?: number | undefined;
    limit?: number | undefined;
    disableBalanceSource?: BalanceSource | undefined;
    disableCheckSource?: BalanceSource | undefined;
    disablePercentage?: number | undefined;
    disableLimit?: number | undefined;
    disableMinimumBalanceSource?: BalanceSource | undefined;
    disableMaximumBalanceSource?: BalanceSource | undefined;

    constructor(data?: IDailyLossLimitConfiguration) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.source = _data["source"];
            this.percentage = _data["percentage"];
            this.limit = _data["limit"];
            this.disableBalanceSource = _data["disableBalanceSource"];
            this.disableCheckSource = _data["disableCheckSource"];
            this.disablePercentage = _data["disablePercentage"];
            this.disableLimit = _data["disableLimit"];
            this.disableMinimumBalanceSource = _data["disableMinimumBalanceSource"];
            this.disableMaximumBalanceSource = _data["disableMaximumBalanceSource"];
        }
    }

    static fromJS(data: any): DailyLossLimitConfiguration {
        data = typeof data === 'object' ? data : {};
        let result = new DailyLossLimitConfiguration();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["source"] = this.source;
        data["percentage"] = this.percentage;
        data["limit"] = this.limit;
        data["disableBalanceSource"] = this.disableBalanceSource;
        data["disableCheckSource"] = this.disableCheckSource;
        data["disablePercentage"] = this.disablePercentage;
        data["disableLimit"] = this.disableLimit;
        data["disableMinimumBalanceSource"] = this.disableMinimumBalanceSource;
        data["disableMaximumBalanceSource"] = this.disableMaximumBalanceSource;
        return data;
    }
}

export interface IDailyLossLimitConfiguration {
    source: BalanceSource;
    percentage?: number | undefined;
    limit?: number | undefined;
    disableBalanceSource?: BalanceSource | undefined;
    disableCheckSource?: BalanceSource | undefined;
    disablePercentage?: number | undefined;
    disableLimit?: number | undefined;
    disableMinimumBalanceSource?: BalanceSource | undefined;
    disableMaximumBalanceSource?: BalanceSource | undefined;
}

/** 0 = None 1 = StartingBalance 2 = StartOfDayBalance 3 = CurrentBalance 4 = GoalBalance 5 = HighestBalance 6 = HighestUnrealizedBalance 7 = HighestRealizedBalance 8 = SpecifiedBalance */
export enum BalanceSource {
    None = 0,
    StartingBalance = 1,
    StartOfDayBalance = 2,
    CurrentBalance = 3,
    GoalBalance = 4,
    HighestBalance = 5,
    HighestUnrealizedBalance = 6,
    HighestRealizedBalance = 7,
    SpecifiedBalance = 8,
}

export class MaximumLossLimitConfiguration implements IMaximumLossLimitConfiguration {
    source!: BalanceSource;
    percentage?: number | undefined;
    limit?: number | undefined;
    minimumSource?: BalanceSource | undefined;
    maximumSource?: BalanceSource | undefined;
    maximumSourceSpecifiedBalance?: number | undefined;

    constructor(data?: IMaximumLossLimitConfiguration) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.source = _data["source"];
            this.percentage = _data["percentage"];
            this.limit = _data["limit"];
            this.minimumSource = _data["minimumSource"];
            this.maximumSource = _data["maximumSource"];
            this.maximumSourceSpecifiedBalance = _data["maximumSourceSpecifiedBalance"];
        }
    }

    static fromJS(data: any): MaximumLossLimitConfiguration {
        data = typeof data === 'object' ? data : {};
        let result = new MaximumLossLimitConfiguration();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["source"] = this.source;
        data["percentage"] = this.percentage;
        data["limit"] = this.limit;
        data["minimumSource"] = this.minimumSource;
        data["maximumSource"] = this.maximumSource;
        data["maximumSourceSpecifiedBalance"] = this.maximumSourceSpecifiedBalance;
        return data;
    }
}

export interface IMaximumLossLimitConfiguration {
    source: BalanceSource;
    percentage?: number | undefined;
    limit?: number | undefined;
    minimumSource?: BalanceSource | undefined;
    maximumSource?: BalanceSource | undefined;
    maximumSourceSpecifiedBalance?: number | undefined;
}

export class MarginScaleConfiguration implements IMarginScaleConfiguration {
    time!: MarginScaleTime;
    values?: ScaleValue[] | undefined;

    constructor(data?: IMarginScaleConfiguration) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.time = _data["time"];
            if (Array.isArray(_data["values"])) {
                this.values = [] as any;
                for (let item of _data["values"])
                    this.values!.push(ScaleValue.fromJS(item));
            }
        }
    }

    static fromJS(data: any): MarginScaleConfiguration {
        data = typeof data === 'object' ? data : {};
        let result = new MarginScaleConfiguration();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["time"] = this.time;
        if (Array.isArray(this.values)) {
            data["values"] = [];
            for (let item of this.values)
                data["values"].push(item.toJSON());
        }
        return data;
    }
}

export interface IMarginScaleConfiguration {
    time: MarginScaleTime;
    values?: ScaleValue[] | undefined;
}

/** 0 = EndOfDay */
export enum MarginScaleTime {
    EndOfDay = 0,
}

export class ScaleValue implements IScaleValue {
    minValue!: number;
    maxValue!: number;
    source!: ProfitSource;
    margin!: number;

    constructor(data?: IScaleValue) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.minValue = _data["minValue"];
            this.maxValue = _data["maxValue"];
            this.source = _data["source"];
            this.margin = _data["margin"];
        }
    }

    static fromJS(data: any): ScaleValue {
        data = typeof data === 'object' ? data : {};
        let result = new ScaleValue();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["minValue"] = this.minValue;
        data["maxValue"] = this.maxValue;
        data["source"] = this.source;
        data["margin"] = this.margin;
        return data;
    }
}

export interface IScaleValue {
    minValue: number;
    maxValue: number;
    source: ProfitSource;
    margin: number;
}

/** 0 = RealizedDayPnl 1 = EndOfDayBalance */
export enum ProfitSource {
    RealizedDayPnl = 0,
    EndOfDayBalance = 1,
}

export class ChartResult implements IChartResult {
    status!: string;
    id?: number | undefined;
    data!: any;

    constructor(data?: IChartResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.status = _data["status"];
            this.id = _data["id"];
            this.data = _data["data"];
        }
    }

    static fromJS(data: any): ChartResult {
        data = typeof data === 'object' ? data : {};
        let result = new ChartResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status;
        data["id"] = this.id;
        data["data"] = this.data;
        return data;
    }
}

export interface IChartResult {
    status: string;
    id?: number | undefined;
    data: any;
}

export class ChartBaseModel implements IChartBaseModel {
    id?: string | undefined;
    name!: string;
    symbol!: string;
    resolution!: string;

    constructor(data?: IChartBaseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.symbol = _data["symbol"];
            this.resolution = _data["resolution"];
        }
    }

    static fromJS(data: any): ChartBaseModel {
        data = typeof data === 'object' ? data : {};
        let result = new ChartBaseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["symbol"] = this.symbol;
        data["resolution"] = this.resolution;
        return data;
    }
}

export interface IChartBaseModel {
    id?: string | undefined;
    name: string;
    symbol: string;
    resolution: string;
}

export class ChartSummaryModel extends ChartBaseModel implements IChartSummaryModel {
    timestamp!: dayjs.Dayjs;

    constructor(data?: IChartSummaryModel) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.timestamp = _data["timestamp"] ? dayjs(_data["timestamp"].toString()) : <any>undefined;
        }
    }

    static override fromJS(data: any): ChartSummaryModel {
        data = typeof data === 'object' ? data : {};
        let result = new ChartSummaryModel();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["timestamp"] = this.timestamp ? this.timestamp.toISOString() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IChartSummaryModel extends IChartBaseModel {
    timestamp: dayjs.Dayjs;
}

export class ChartModel extends ChartBaseModel implements IChartModel {
    content!: string;

    constructor(data?: IChartModel) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.content = _data["content"];
        }
    }

    static override fromJS(data: any): ChartModel {
        data = typeof data === 'object' ? data : {};
        let result = new ChartModel();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["content"] = this.content;
        super.toJSON(data);
        return data;
    }
}

export interface IChartModel extends IChartBaseModel {
    content: string;
}

export class ChartTemplateModel implements IChartTemplateModel {
    id!: number;
    userId!: number;
    name!: string;
    content!: string;

    constructor(data?: IChartTemplateModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.userId = _data["userId"];
            this.name = _data["name"];
            this.content = _data["content"];
        }
    }

    static fromJS(data: any): ChartTemplateModel {
        data = typeof data === 'object' ? data : {};
        let result = new ChartTemplateModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["userId"] = this.userId;
        data["name"] = this.name;
        data["content"] = this.content;
        return data;
    }
}

export interface IChartTemplateModel {
    id: number;
    userId: number;
    name: string;
    content: string;
}

export class RiskContractLimitModel implements IRiskContractLimitModel {
    id!: number;
    symbolId!: string;
    limit!: number;
    accountId!: number;

    constructor(data?: IRiskContractLimitModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.symbolId = _data["symbolId"];
            this.limit = _data["limit"];
            this.accountId = _data["accountId"];
        }
    }

    static fromJS(data: any): RiskContractLimitModel {
        data = typeof data === 'object' ? data : {};
        let result = new RiskContractLimitModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["symbolId"] = this.symbolId;
        data["limit"] = this.limit;
        data["accountId"] = this.accountId;
        return data;
    }
}

export interface IRiskContractLimitModel {
    id: number;
    symbolId: string;
    limit: number;
    accountId: number;
}

export class SetRiskContractLimitsResult implements ISetRiskContractLimitsResult {
    success!: boolean;
    errorMessage?: string | undefined;

    constructor(data?: ISetRiskContractLimitsResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.success = _data["success"];
            this.errorMessage = _data["errorMessage"];
        }
    }

    static fromJS(data: any): SetRiskContractLimitsResult {
        data = typeof data === 'object' ? data : {};
        let result = new SetRiskContractLimitsResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        data["errorMessage"] = this.errorMessage;
        return data;
    }
}

export interface ISetRiskContractLimitsResult {
    success: boolean;
    errorMessage?: string | undefined;
}

export class SetRiskContractLimitsRequest implements ISetRiskContractLimitsRequest {
    accountId!: number;
    limits!: SetRiskContractLimitModel[];

    constructor(data?: ISetRiskContractLimitsRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.limits = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accountId = _data["accountId"];
            if (Array.isArray(_data["limits"])) {
                this.limits = [] as any;
                for (let item of _data["limits"])
                    this.limits!.push(SetRiskContractLimitModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SetRiskContractLimitsRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SetRiskContractLimitsRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accountId"] = this.accountId;
        if (Array.isArray(this.limits)) {
            data["limits"] = [];
            for (let item of this.limits)
                data["limits"].push(item.toJSON());
        }
        return data;
    }
}

export interface ISetRiskContractLimitsRequest {
    accountId: number;
    limits: SetRiskContractLimitModel[];
}

export class SetRiskContractLimitModel implements ISetRiskContractLimitModel {
    symbolId!: string;
    limit!: number;

    constructor(data?: ISetRiskContractLimitModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.symbolId = _data["symbolId"];
            this.limit = _data["limit"];
        }
    }

    static fromJS(data: any): SetRiskContractLimitModel {
        data = typeof data === 'object' ? data : {};
        let result = new SetRiskContractLimitModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["symbolId"] = this.symbolId;
        data["limit"] = this.limit;
        return data;
    }
}

export interface ISetRiskContractLimitModel {
    symbolId: string;
    limit: number;
}

export class DrawingTemplateModel implements IDrawingTemplateModel {
    id!: number;
    userId!: number;
    content!: string;
    toolName!: string;
    templateName!: string;

    constructor(data?: IDrawingTemplateModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.userId = _data["userId"];
            this.content = _data["content"];
            this.toolName = _data["toolName"];
            this.templateName = _data["templateName"];
        }
    }

    static fromJS(data: any): DrawingTemplateModel {
        data = typeof data === 'object' ? data : {};
        let result = new DrawingTemplateModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["userId"] = this.userId;
        data["content"] = this.content;
        data["toolName"] = this.toolName;
        data["templateName"] = this.templateName;
        return data;
    }
}

export interface IDrawingTemplateModel {
    id: number;
    userId: number;
    content: string;
    toolName: string;
    templateName: string;
}

export class RemoveDrawingTemplateRequest implements IRemoveDrawingTemplateRequest {
    toolName!: string;
    templateName!: string;

    constructor(data?: IRemoveDrawingTemplateRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.toolName = _data["toolName"];
            this.templateName = _data["templateName"];
        }
    }

    static fromJS(data: any): RemoveDrawingTemplateRequest {
        data = typeof data === 'object' ? data : {};
        let result = new RemoveDrawingTemplateRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["toolName"] = this.toolName;
        data["templateName"] = this.templateName;
        return data;
    }
}

export interface IRemoveDrawingTemplateRequest {
    toolName: string;
    templateName: string;
}

export class GetDrawingTemplateRequest implements IGetDrawingTemplateRequest {
    toolName!: string;
    templateName!: string;

    constructor(data?: IGetDrawingTemplateRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.toolName = _data["toolName"];
            this.templateName = _data["templateName"];
        }
    }

    static fromJS(data: any): GetDrawingTemplateRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetDrawingTemplateRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["toolName"] = this.toolName;
        data["templateName"] = this.templateName;
        return data;
    }
}

export interface IGetDrawingTemplateRequest {
    toolName: string;
    templateName: string;
}

/** 0 = Success 1 = InvalidToken 2 = InvalidPassword 3 = InvalidUsername 4 = Failed 5 = Pending */
export enum PasswordResetResult {
    Success = 0,
    InvalidToken = 1,
    InvalidPassword = 2,
    InvalidUsername = 3,
    Failed = 4,
    Pending = 5,
}

export class PasswordResetRequest implements IPasswordResetRequest {
    userName!: string;
    token!: string;
    password!: string;

    constructor(data?: IPasswordResetRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userName = _data["userName"];
            this.token = _data["token"];
            this.password = _data["password"];
        }
    }

    static fromJS(data: any): PasswordResetRequest {
        data = typeof data === 'object' ? data : {};
        let result = new PasswordResetRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userName"] = this.userName;
        data["token"] = this.token;
        data["password"] = this.password;
        return data;
    }
}

export interface IPasswordResetRequest {
    userName: string;
    token: string;
    password: string;
}

export class JournalLogUpsertResponse implements IJournalLogUpsertResponse {
    success!: boolean;
    resultCode!: JournalUpsertResult;

    constructor(data?: IJournalLogUpsertResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.success = _data["success"];
            this.resultCode = _data["resultCode"];
        }
    }

    static fromJS(data: any): JournalLogUpsertResponse {
        data = typeof data === 'object' ? data : {};
        let result = new JournalLogUpsertResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        data["resultCode"] = this.resultCode;
        return data;
    }
}

export interface IJournalLogUpsertResponse {
    success: boolean;
    resultCode: JournalUpsertResult;
}

/** 0 = Inserted 1 = Updated 2 = TradingAccountNotFound 3 = TradeNotFound 4 = AccountMismatch 5 = TradeDayMismatch 6 = ContentTooLarge 7 = Forbidden */
export enum JournalUpsertResult {
    Inserted = 0,
    Updated = 1,
    TradingAccountNotFound = 2,
    TradeNotFound = 3,
    AccountMismatch = 4,
    TradeDayMismatch = 5,
    ContentTooLarge = 6,
    Forbidden = 7,
}

export class JournalLogUpsertRequest implements IJournalLogUpsertRequest {
    tradingAccountId!: number;
    tradeId?: number | undefined;
    tradeDay!: dayjs.Dayjs;
    content!: string;

    constructor(data?: IJournalLogUpsertRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tradingAccountId = _data["tradingAccountId"];
            this.tradeId = _data["tradeId"];
            this.tradeDay = _data["tradeDay"] ? dayjs(_data["tradeDay"].toString()) : <any>undefined;
            this.content = _data["content"];
        }
    }

    static fromJS(data: any): JournalLogUpsertRequest {
        data = typeof data === 'object' ? data : {};
        let result = new JournalLogUpsertRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tradingAccountId"] = this.tradingAccountId;
        data["tradeId"] = this.tradeId;
        data["tradeDay"] = this.tradeDay ? this.tradeDay.toISOString() : <any>undefined;
        data["content"] = this.content;
        return data;
    }
}

export interface IJournalLogUpsertRequest {
    tradingAccountId: number;
    tradeId?: number | undefined;
    tradeDay: dayjs.Dayjs;
    content: string;
}

export class JournalLog implements IJournalLog {
    tradingAccountId!: number;
    tradeId?: number | undefined;
    tradeDay!: dayjs.Dayjs;
    content!: string;

    constructor(data?: IJournalLog) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tradingAccountId = _data["tradingAccountId"];
            this.tradeId = _data["tradeId"];
            this.tradeDay = _data["tradeDay"] ? dayjs(_data["tradeDay"].toString()) : <any>undefined;
            this.content = _data["content"];
        }
    }

    static fromJS(data: any): JournalLog {
        data = typeof data === 'object' ? data : {};
        let result = new JournalLog();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tradingAccountId"] = this.tradingAccountId;
        data["tradeId"] = this.tradeId;
        data["tradeDay"] = this.tradeDay ? this.tradeDay.toISOString() : <any>undefined;
        data["content"] = this.content;
        return data;
    }
}

export interface IJournalLog {
    tradingAccountId: number;
    tradeId?: number | undefined;
    tradeDay: dayjs.Dayjs;
    content: string;
}

export class GetJournalLogDayRequest implements IGetJournalLogDayRequest {
    tradingAccountId!: number;
    tradeDay!: dayjs.Dayjs;

    constructor(data?: IGetJournalLogDayRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tradingAccountId = _data["tradingAccountId"];
            this.tradeDay = _data["tradeDay"] ? dayjs(_data["tradeDay"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): GetJournalLogDayRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetJournalLogDayRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tradingAccountId"] = this.tradingAccountId;
        data["tradeDay"] = this.tradeDay ? this.tradeDay.toISOString() : <any>undefined;
        return data;
    }
}

export interface IGetJournalLogDayRequest {
    tradingAccountId: number;
    tradeDay: dayjs.Dayjs;
}

export class GetJournalLogTradeRequest implements IGetJournalLogTradeRequest {
    tradingAccountId!: number;
    tradeId!: number;

    constructor(data?: IGetJournalLogTradeRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tradingAccountId = _data["tradingAccountId"];
            this.tradeId = _data["tradeId"];
        }
    }

    static fromJS(data: any): GetJournalLogTradeRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetJournalLogTradeRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tradingAccountId"] = this.tradingAccountId;
        data["tradeId"] = this.tradeId;
        return data;
    }
}

export interface IGetJournalLogTradeRequest {
    tradingAccountId: number;
    tradeId: number;
}

export class GetJournalLogRangeRequest implements IGetJournalLogRangeRequest {
    tradingAccountId!: number;
    startDate!: dayjs.Dayjs;
    endDate!: dayjs.Dayjs;

    constructor(data?: IGetJournalLogRangeRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tradingAccountId = _data["tradingAccountId"];
            this.startDate = _data["startDate"] ? dayjs(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? dayjs(_data["endDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): GetJournalLogRangeRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetJournalLogRangeRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tradingAccountId"] = this.tradingAccountId;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        return data;
    }
}

export interface IGetJournalLogRangeRequest {
    tradingAccountId: number;
    startDate: dayjs.Dayjs;
    endDate: dayjs.Dayjs;
}

export class DeleteJournalLogRequest implements IDeleteJournalLogRequest {
    tradingAccountId!: number;
    tradeDay!: dayjs.Dayjs;
    tradeId?: number | undefined;

    constructor(data?: IDeleteJournalLogRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tradingAccountId = _data["tradingAccountId"];
            this.tradeDay = _data["tradeDay"] ? dayjs(_data["tradeDay"].toString()) : <any>undefined;
            this.tradeId = _data["tradeId"];
        }
    }

    static fromJS(data: any): DeleteJournalLogRequest {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteJournalLogRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tradingAccountId"] = this.tradingAccountId;
        data["tradeDay"] = this.tradeDay ? this.tradeDay.toISOString() : <any>undefined;
        data["tradeId"] = this.tradeId;
        return data;
    }
}

export interface IDeleteJournalLogRequest {
    tradingAccountId: number;
    tradeDay: dayjs.Dayjs;
    tradeId?: number | undefined;
}

export class LayoutModel implements ILayoutModel {
    id!: number;
    name!: string;
    content!: JsonDocument;
    createdAt!: dayjs.Dayjs;
    isDraft!: boolean;

    constructor(data?: ILayoutModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.content = new JsonDocument();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.content = _data["content"] ? JsonDocument.fromJS(_data["content"]) : new JsonDocument();
            this.createdAt = _data["createdAt"] ? dayjs(_data["createdAt"].toString()) : <any>undefined;
            this.isDraft = _data["isDraft"];
        }
    }

    static fromJS(data: any): LayoutModel {
        data = typeof data === 'object' ? data : {};
        let result = new LayoutModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["content"] = this.content ? this.content.toJSON() : <any>undefined;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : <any>undefined;
        data["isDraft"] = this.isDraft;
        return data;
    }
}

export interface ILayoutModel {
    id: number;
    name: string;
    content: JsonDocument;
    createdAt: dayjs.Dayjs;
    isDraft: boolean;
}

export class JsonDocument implements IJsonDocument {
    isDisposable!: boolean;
    rootElement!: RootElement;

    constructor(data?: IJsonDocument) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isDisposable = _data["isDisposable"];
            this.rootElement = _data["rootElement"];
        }
    }

    static fromJS(data: any): JsonDocument {
        data = typeof data === 'object' ? data : {};
        let result = new JsonDocument();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isDisposable"] = this.isDisposable;
        data["rootElement"] = this.rootElement;
        return data;
    }
}

export interface IJsonDocument {
    isDisposable: boolean;
    rootElement: RootElement;
}

export class LineToolsModel implements ILineToolsModel {
    id!: number;
    userId!: number;
    layoutId!: string;
    chartId!: string;
    symbol?: string | undefined;
    sources!: string;
    groups!: string;

    constructor(data?: ILineToolsModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.userId = _data["userId"];
            this.layoutId = _data["layoutId"];
            this.chartId = _data["chartId"];
            this.symbol = _data["symbol"];
            this.sources = _data["sources"];
            this.groups = _data["groups"];
        }
    }

    static fromJS(data: any): LineToolsModel {
        data = typeof data === 'object' ? data : {};
        let result = new LineToolsModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["userId"] = this.userId;
        data["layoutId"] = this.layoutId;
        data["chartId"] = this.chartId;
        data["symbol"] = this.symbol;
        data["sources"] = this.sources;
        data["groups"] = this.groups;
        return data;
    }
}

export interface ILineToolsModel {
    id: number;
    userId: number;
    layoutId: string;
    chartId: string;
    symbol?: string | undefined;
    sources: string;
    groups: string;
}

export class UnlinkOrderUserResponse implements IUnlinkOrderUserResponse {
    orderIds!: number[];
    result!: LinkOrderUserResult;
    success!: boolean;
    errorMessage?: string | undefined;

    constructor(data?: IUnlinkOrderUserResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.orderIds = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["orderIds"])) {
                this.orderIds = [] as any;
                for (let item of _data["orderIds"])
                    this.orderIds!.push(item);
            }
            this.result = _data["result"];
            this.success = _data["success"];
            this.errorMessage = _data["errorMessage"];
        }
    }

    static fromJS(data: any): UnlinkOrderUserResponse {
        data = typeof data === 'object' ? data : {};
        let result = new UnlinkOrderUserResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.orderIds)) {
            data["orderIds"] = [];
            for (let item of this.orderIds)
                data["orderIds"].push(item);
        }
        data["result"] = this.result;
        data["success"] = this.success;
        data["errorMessage"] = this.errorMessage;
        return data;
    }
}

export interface IUnlinkOrderUserResponse {
    orderIds: number[];
    result: LinkOrderUserResult;
    success: boolean;
    errorMessage?: string | undefined;
}

/** 0 = Success 1 = Exception 2 = InvalidOrder 3 = MultipleSymbols 4 = AlreadyLinked 5 = InvalidLinkGroup 6 = InvalidTradingAccount 7 = InvalidAccountType */
export enum LinkOrderUserResult {
    Success = 0,
    Exception = 1,
    InvalidOrder = 2,
    MultipleSymbols = 3,
    AlreadyLinked = 4,
    InvalidLinkGroup = 5,
    InvalidTradingAccount = 6,
    InvalidAccountType = 7,
}

export class UnlinkOrderUserRequest implements IUnlinkOrderUserRequest {
    tradingAccountId!: number;
    groupId!: string;

    constructor(data?: IUnlinkOrderUserRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tradingAccountId = _data["tradingAccountId"];
            this.groupId = _data["groupId"];
        }
    }

    static fromJS(data: any): UnlinkOrderUserRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UnlinkOrderUserRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tradingAccountId"] = this.tradingAccountId;
        data["groupId"] = this.groupId;
        return data;
    }
}

export interface IUnlinkOrderUserRequest {
    tradingAccountId: number;
    groupId: string;
}

export class GetLinkedOrdersResponse implements IGetLinkedOrdersResponse {
    linkedOrders!: LinkedOrderModel[];

    constructor(data?: IGetLinkedOrdersResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.linkedOrders = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["linkedOrders"])) {
                this.linkedOrders = [] as any;
                for (let item of _data["linkedOrders"])
                    this.linkedOrders!.push(LinkedOrderModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetLinkedOrdersResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetLinkedOrdersResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.linkedOrders)) {
            data["linkedOrders"] = [];
            for (let item of this.linkedOrders)
                data["linkedOrders"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetLinkedOrdersResponse {
    linkedOrders: LinkedOrderModel[];
}

export class LinkedOrderModel implements ILinkedOrderModel {
    tradingAccountId!: number;
    groupId!: string;
    linkedOrderIds!: number[];

    constructor(data?: ILinkedOrderModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.linkedOrderIds = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tradingAccountId = _data["tradingAccountId"];
            this.groupId = _data["groupId"];
            if (Array.isArray(_data["linkedOrderIds"])) {
                this.linkedOrderIds = [] as any;
                for (let item of _data["linkedOrderIds"])
                    this.linkedOrderIds!.push(item);
            }
        }
    }

    static fromJS(data: any): LinkedOrderModel {
        data = typeof data === 'object' ? data : {};
        let result = new LinkedOrderModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tradingAccountId"] = this.tradingAccountId;
        data["groupId"] = this.groupId;
        if (Array.isArray(this.linkedOrderIds)) {
            data["linkedOrderIds"] = [];
            for (let item of this.linkedOrderIds)
                data["linkedOrderIds"].push(item);
        }
        return data;
    }
}

export interface ILinkedOrderModel {
    tradingAccountId: number;
    groupId: string;
    linkedOrderIds: number[];
}

export class LinkOrderUserResponse implements ILinkOrderUserResponse {
    result!: LinkOrderUserResult;
    success!: boolean;
    errorMessage?: string | undefined;

    constructor(data?: ILinkOrderUserResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.result = _data["result"];
            this.success = _data["success"];
            this.errorMessage = _data["errorMessage"];
        }
    }

    static fromJS(data: any): LinkOrderUserResponse {
        data = typeof data === 'object' ? data : {};
        let result = new LinkOrderUserResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["result"] = this.result;
        data["success"] = this.success;
        data["errorMessage"] = this.errorMessage;
        return data;
    }
}

export interface ILinkOrderUserResponse {
    result: LinkOrderUserResult;
    success: boolean;
    errorMessage?: string | undefined;
}

export class LinkOrderUserRequest implements ILinkOrderUserRequest {
    tradingAccountId!: number;
    orderIds!: number[];

    constructor(data?: ILinkOrderUserRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.orderIds = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tradingAccountId = _data["tradingAccountId"];
            if (Array.isArray(_data["orderIds"])) {
                this.orderIds = [] as any;
                for (let item of _data["orderIds"])
                    this.orderIds!.push(item);
            }
        }
    }

    static fromJS(data: any): LinkOrderUserRequest {
        data = typeof data === 'object' ? data : {};
        let result = new LinkOrderUserRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tradingAccountId"] = this.tradingAccountId;
        if (Array.isArray(this.orderIds)) {
            data["orderIds"] = [];
            for (let item of this.orderIds)
                data["orderIds"].push(item);
        }
        return data;
    }
}

export interface ILinkOrderUserRequest {
    tradingAccountId: number;
    orderIds: number[];
}

export class LoginResultModel implements ILoginResultModel {
    result!: LoginResult;
    token?: string | undefined;

    constructor(data?: ILoginResultModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.result = _data["result"];
            this.token = _data["token"];
        }
    }

    static fromJS(data: any): LoginResultModel {
        data = typeof data === 'object' ? data : {};
        let result = new LoginResultModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["result"] = this.result;
        data["token"] = this.token;
        return data;
    }
}

export interface ILoginResultModel {
    result: LoginResult;
    token?: string | undefined;
}

/** 0 = Success 1 = InvalidUsername 2 = InvalidPassword 3 = Inactive 4 = LockedOut */
export enum LoginResult {
    Success = 0,
    InvalidUsername = 1,
    InvalidPassword = 2,
    Inactive = 3,
    LockedOut = 4,
}

export class LoginRequestModel implements ILoginRequestModel {
    userName!: string;
    password!: string;

    constructor(data?: ILoginRequestModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userName = _data["userName"];
            this.password = _data["password"];
        }
    }

    static fromJS(data: any): LoginRequestModel {
        data = typeof data === 'object' ? data : {};
        let result = new LoginRequestModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userName"] = this.userName;
        data["password"] = this.password;
        return data;
    }
}

export interface ILoginRequestModel {
    userName: string;
    password: string;
}

export class ApiKeyLoginRequest implements IApiKeyLoginRequest {
    userName!: string;
    apiKey!: string;

    constructor(data?: IApiKeyLoginRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userName = _data["userName"];
            this.apiKey = _data["apiKey"];
        }
    }

    static fromJS(data: any): ApiKeyLoginRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ApiKeyLoginRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userName"] = this.userName;
        data["apiKey"] = this.apiKey;
        return data;
    }
}

export interface IApiKeyLoginRequest {
    userName: string;
    apiKey: string;
}

export class MarketClosureModel implements IMarketClosureModel {
    id!: number;
    startTime!: dayjs.Dayjs;
    endTime!: dayjs.Dayjs;
    name!: string;
    description!: string;

    constructor(data?: IMarketClosureModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.startTime = _data["startTime"] ? dayjs(_data["startTime"].toString()) : <any>undefined;
            this.endTime = _data["endTime"] ? dayjs(_data["endTime"].toString()) : <any>undefined;
            this.name = _data["name"];
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): MarketClosureModel {
        data = typeof data === 'object' ? data : {};
        let result = new MarketClosureModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["startTime"] = this.startTime ? this.startTime.toISOString() : <any>undefined;
        data["endTime"] = this.endTime ? this.endTime.toISOString() : <any>undefined;
        data["name"] = this.name;
        data["description"] = this.description;
        return data;
    }
}

export interface IMarketClosureModel {
    id: number;
    startTime: dayjs.Dayjs;
    endTime: dayjs.Dayjs;
    name: string;
    description: string;
}

export class MarketStatusSummary implements IMarketStatusSummary {
    isOpen!: boolean;
    nextOpen!: dayjs.Dayjs;
    close!: dayjs.Dayjs;

    constructor(data?: IMarketStatusSummary) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isOpen = _data["isOpen"];
            this.nextOpen = _data["nextOpen"] ? dayjs(_data["nextOpen"].toString()) : <any>undefined;
            this.close = _data["close"] ? dayjs(_data["close"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): MarketStatusSummary {
        data = typeof data === 'object' ? data : {};
        let result = new MarketStatusSummary();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isOpen"] = this.isOpen;
        data["nextOpen"] = this.nextOpen ? this.nextOpen.toISOString() : <any>undefined;
        data["close"] = this.close ? this.close.toISOString() : <any>undefined;
        return data;
    }
}

export interface IMarketStatusSummary {
    isOpen: boolean;
    nextOpen: dayjs.Dayjs;
    close: dayjs.Dayjs;
}

export class MarketStatus implements IMarketStatus {
    symbolId!: string;
    status!: ExchangeStatus;
    simStatus!: ExchangeStatus;
    openedAt!: dayjs.Dayjs;
    autoLiquidate!: boolean;
    isOpen!: boolean;

    constructor(data?: IMarketStatus) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.symbolId = _data["symbolId"];
            this.status = _data["status"];
            this.simStatus = _data["simStatus"];
            this.openedAt = _data["openedAt"] ? dayjs(_data["openedAt"].toString()) : <any>undefined;
            this.autoLiquidate = _data["autoLiquidate"];
            this.isOpen = _data["isOpen"];
        }
    }

    static fromJS(data: any): MarketStatus {
        data = typeof data === 'object' ? data : {};
        let result = new MarketStatus();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["symbolId"] = this.symbolId;
        data["status"] = this.status;
        data["simStatus"] = this.simStatus;
        data["openedAt"] = this.openedAt ? this.openedAt.toISOString() : <any>undefined;
        data["autoLiquidate"] = this.autoLiquidate;
        data["isOpen"] = this.isOpen;
        return data;
    }
}

export interface IMarketStatus {
    symbolId: string;
    status: ExchangeStatus;
    simStatus: ExchangeStatus;
    openedAt: dayjs.Dayjs;
    autoLiquidate: boolean;
    isOpen: boolean;
}

/** 1 = PreOpen 2 = Open 3 = Closed 4 = Halted 5 = Suspended */
export enum ExchangeStatus {
    PreOpen = 1,
    Open = 2,
    Closed = 3,
    Halted = 4,
    Suspended = 5,
}

export class SetMarketStatusResponse implements ISetMarketStatusResponse {
    success!: boolean;
    errorCode!: SetMarketStatusErrorCode;
    contractGroupId!: string;
    errorMessage?: string | undefined;

    constructor(data?: ISetMarketStatusResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.success = _data["success"];
            this.errorCode = _data["errorCode"];
            this.contractGroupId = _data["contractGroupId"];
            this.errorMessage = _data["errorMessage"];
        }
    }

    static fromJS(data: any): SetMarketStatusResponse {
        data = typeof data === 'object' ? data : {};
        let result = new SetMarketStatusResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        data["errorCode"] = this.errorCode;
        data["contractGroupId"] = this.contractGroupId;
        data["errorMessage"] = this.errorMessage;
        return data;
    }
}

export interface ISetMarketStatusResponse {
    success: boolean;
    errorCode: SetMarketStatusErrorCode;
    contractGroupId: string;
    errorMessage?: string | undefined;
}

/** 0 = Success 1 = ContractGroupNotFound */
export enum SetMarketStatusErrorCode {
    Success = 0,
    ContractGroupNotFound = 1,
}

export class SetSingleMarketStatusRequest implements ISetSingleMarketStatusRequest {
    contractGroupId!: string;
    status!: ExchangeStatus;

    constructor(data?: ISetSingleMarketStatusRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.contractGroupId = _data["contractGroupId"];
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): SetSingleMarketStatusRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SetSingleMarketStatusRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["contractGroupId"] = this.contractGroupId;
        data["status"] = this.status;
        return data;
    }
}

export interface ISetSingleMarketStatusRequest {
    contractGroupId: string;
    status: ExchangeStatus;
}

export class SetManyMarketStatusResponse implements ISetManyMarketStatusResponse {
    success!: boolean;
    responses!: SetMarketStatusResponse[];

    constructor(data?: ISetManyMarketStatusResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.responses = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.success = _data["success"];
            if (Array.isArray(_data["responses"])) {
                this.responses = [] as any;
                for (let item of _data["responses"])
                    this.responses!.push(SetMarketStatusResponse.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SetManyMarketStatusResponse {
        data = typeof data === 'object' ? data : {};
        let result = new SetManyMarketStatusResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        if (Array.isArray(this.responses)) {
            data["responses"] = [];
            for (let item of this.responses)
                data["responses"].push(item.toJSON());
        }
        return data;
    }
}

export interface ISetManyMarketStatusResponse {
    success: boolean;
    responses: SetMarketStatusResponse[];
}

export class SetManyMarketStatusRequest implements ISetManyMarketStatusRequest {
    status!: ExchangeStatus;

    constructor(data?: ISetManyMarketStatusRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): SetManyMarketStatusRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SetManyMarketStatusRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status;
        return data;
    }
}

export interface ISetManyMarketStatusRequest {
    status: ExchangeStatus;
}

export class ResetSingleMarketStatusRequest implements IResetSingleMarketStatusRequest {
    contractGroupId!: string;

    constructor(data?: IResetSingleMarketStatusRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.contractGroupId = _data["contractGroupId"];
        }
    }

    static fromJS(data: any): ResetSingleMarketStatusRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ResetSingleMarketStatusRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["contractGroupId"] = this.contractGroupId;
        return data;
    }
}

export interface IResetSingleMarketStatusRequest {
    contractGroupId: string;
}

export class SymbolMetadata implements ISymbolMetadata {
    symbol!: string;
    friendlyName!: string;
    fullName!: string;
    description!: string;
    maturityMonthYear!: string;
    contractId!: number;
    tickSize!: number;
    tickValue!: number;
    contractCost!: number;
    fees!: number;
    marketGroupId!: number;
    decimalPlaces!: number;
    priceScale!: number;
    minMove!: number;
    fractionalPrice!: boolean;
    exchange!: string;
    minMove2!: number;
    disabled!: boolean;

    constructor(data?: ISymbolMetadata) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.symbol = _data["symbol"];
            this.friendlyName = _data["friendlyName"];
            this.fullName = _data["fullName"];
            this.description = _data["description"];
            this.maturityMonthYear = _data["maturityMonthYear"];
            this.contractId = _data["contractId"];
            this.tickSize = _data["tickSize"];
            this.tickValue = _data["tickValue"];
            this.contractCost = _data["contractCost"];
            this.fees = _data["fees"];
            this.marketGroupId = _data["marketGroupId"];
            this.decimalPlaces = _data["decimalPlaces"];
            this.priceScale = _data["priceScale"];
            this.minMove = _data["minMove"];
            this.fractionalPrice = _data["fractionalPrice"];
            this.exchange = _data["exchange"];
            this.minMove2 = _data["minMove2"];
            this.disabled = _data["disabled"];
        }
    }

    static fromJS(data: any): SymbolMetadata {
        data = typeof data === 'object' ? data : {};
        let result = new SymbolMetadata();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["symbol"] = this.symbol;
        data["friendlyName"] = this.friendlyName;
        data["fullName"] = this.fullName;
        data["description"] = this.description;
        data["maturityMonthYear"] = this.maturityMonthYear;
        data["contractId"] = this.contractId;
        data["tickSize"] = this.tickSize;
        data["tickValue"] = this.tickValue;
        data["contractCost"] = this.contractCost;
        data["fees"] = this.fees;
        data["marketGroupId"] = this.marketGroupId;
        data["decimalPlaces"] = this.decimalPlaces;
        data["priceScale"] = this.priceScale;
        data["minMove"] = this.minMove;
        data["fractionalPrice"] = this.fractionalPrice;
        data["exchange"] = this.exchange;
        data["minMove2"] = this.minMove2;
        data["disabled"] = this.disabled;
        return data;
    }
}

export interface ISymbolMetadata {
    symbol: string;
    friendlyName: string;
    fullName: string;
    description: string;
    maturityMonthYear: string;
    contractId: number;
    tickSize: number;
    tickValue: number;
    contractCost: number;
    fees: number;
    marketGroupId: number;
    decimalPlaces: number;
    priceScale: number;
    minMove: number;
    fractionalPrice: boolean;
    exchange: string;
    minMove2: number;
    disabled: boolean;
}

export class MigratePartialChartsRequest implements IMigratePartialChartsRequest {
    /** Inclusive */
    startId!: number;
    /** End ID is exclusive. */
    endId!: number;

    constructor(data?: IMigratePartialChartsRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.startId = _data["startId"];
            this.endId = _data["endId"];
        }
    }

    static fromJS(data: any): MigratePartialChartsRequest {
        data = typeof data === 'object' ? data : {};
        let result = new MigratePartialChartsRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["startId"] = this.startId;
        data["endId"] = this.endId;
        return data;
    }
}

export interface IMigratePartialChartsRequest {
    /** Inclusive */
    startId: number;
    /** End ID is exclusive. */
    endId: number;
}

export class MigrateChartsRequest implements IMigrateChartsRequest {
    totalUsers!: number;

    constructor(data?: IMigrateChartsRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalUsers = _data["totalUsers"];
        }
    }

    static fromJS(data: any): MigrateChartsRequest {
        data = typeof data === 'object' ? data : {};
        let result = new MigrateChartsRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalUsers"] = this.totalUsers;
        return data;
    }
}

export interface IMigrateChartsRequest {
    totalUsers: number;
}

/** 0 = Success 1 = UserNotFound 2 = InvalidSecret 3 = InvalidToken */
export enum Create2FAErrorCode {
    Success = 0,
    UserNotFound = 1,
    InvalidSecret = 2,
    InvalidToken = 3,
}

export class Create2FARequest implements ICreate2FARequest {
    secret!: string;
    token!: string;

    constructor(data?: ICreate2FARequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.secret = _data["secret"];
            this.token = _data["token"];
        }
    }

    static fromJS(data: any): Create2FARequest {
        data = typeof data === 'object' ? data : {};
        let result = new Create2FARequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["secret"] = this.secret;
        data["token"] = this.token;
        return data;
    }
}

export interface ICreate2FARequest {
    secret: string;
    token: string;
}

export class Submit2FAResult implements ISubmit2FAResult {
    token?: string | undefined;
    errorCode?: Submit2FAErrorCode | undefined;

    constructor(data?: ISubmit2FAResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.token = _data["token"];
            this.errorCode = _data["errorCode"];
        }
    }

    static fromJS(data: any): Submit2FAResult {
        data = typeof data === 'object' ? data : {};
        let result = new Submit2FAResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["token"] = this.token;
        data["errorCode"] = this.errorCode;
        return data;
    }
}

export interface ISubmit2FAResult {
    token?: string | undefined;
    errorCode?: Submit2FAErrorCode | undefined;
}

/** 0 = Success 1 = UserNotFound 2 = TotpTokenNotFound 3 = InvalidToken */
export enum Submit2FAErrorCode {
    Success = 0,
    UserNotFound = 1,
    TotpTokenNotFound = 2,
    InvalidToken = 3,
}

export class SubmitRecoveryCodeResult implements ISubmitRecoveryCodeResult {
    token?: string | undefined;
    errorCode?: SubmitRecoveryErrorCode | undefined;

    constructor(data?: ISubmitRecoveryCodeResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.token = _data["token"];
            this.errorCode = _data["errorCode"];
        }
    }

    static fromJS(data: any): SubmitRecoveryCodeResult {
        data = typeof data === 'object' ? data : {};
        let result = new SubmitRecoveryCodeResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["token"] = this.token;
        data["errorCode"] = this.errorCode;
        return data;
    }
}

export interface ISubmitRecoveryCodeResult {
    token?: string | undefined;
    errorCode?: SubmitRecoveryErrorCode | undefined;
}

/** 0 = Success 1 = UserNotFound 2 = RecoveryCodeAlreadyUsed 3 = InvalidRecoveryCode */
export enum SubmitRecoveryErrorCode {
    Success = 0,
    UserNotFound = 1,
    RecoveryCodeAlreadyUsed = 2,
    InvalidRecoveryCode = 3,
}

export class GetRecoveryCodesResult implements IGetRecoveryCodesResult {
    recoveryCodes?: string[] | undefined;
    errorCode?: Submit2FAErrorCode | undefined;

    constructor(data?: IGetRecoveryCodesResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["recoveryCodes"])) {
                this.recoveryCodes = [] as any;
                for (let item of _data["recoveryCodes"])
                    this.recoveryCodes!.push(item);
            }
            this.errorCode = _data["errorCode"];
        }
    }

    static fromJS(data: any): GetRecoveryCodesResult {
        data = typeof data === 'object' ? data : {};
        let result = new GetRecoveryCodesResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.recoveryCodes)) {
            data["recoveryCodes"] = [];
            for (let item of this.recoveryCodes)
                data["recoveryCodes"].push(item);
        }
        data["errorCode"] = this.errorCode;
        return data;
    }
}

export interface IGetRecoveryCodesResult {
    recoveryCodes?: string[] | undefined;
    errorCode?: Submit2FAErrorCode | undefined;
}

export class RegenerateRecoveryCodesResult implements IRegenerateRecoveryCodesResult {
    recoveryCodes?: string[] | undefined;
    errorCode?: RegenerateRecoveryCodeErrorCode | undefined;

    constructor(data?: IRegenerateRecoveryCodesResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["recoveryCodes"])) {
                this.recoveryCodes = [] as any;
                for (let item of _data["recoveryCodes"])
                    this.recoveryCodes!.push(item);
            }
            this.errorCode = _data["errorCode"];
        }
    }

    static fromJS(data: any): RegenerateRecoveryCodesResult {
        data = typeof data === 'object' ? data : {};
        let result = new RegenerateRecoveryCodesResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.recoveryCodes)) {
            data["recoveryCodes"] = [];
            for (let item of this.recoveryCodes)
                data["recoveryCodes"].push(item);
        }
        data["errorCode"] = this.errorCode;
        return data;
    }
}

export interface IRegenerateRecoveryCodesResult {
    recoveryCodes?: string[] | undefined;
    errorCode?: RegenerateRecoveryCodeErrorCode | undefined;
}

/** 0 = Success 1 = UserNotFound */
export enum RegenerateRecoveryCodeErrorCode {
    Success = 0,
    UserNotFound = 1,
}

/** 0 = Success 1 = UserNotFound 2 = TokenAlreadyDisabled 3 = TokenDoesntExist */
export enum Disable2FAErrorCode {
    Success = 0,
    UserNotFound = 1,
    TokenAlreadyDisabled = 2,
    TokenDoesntExist = 3,
}

export class OrderModel implements IOrderModel {
    id!: number;
    symbolId!: string;
    symbolName!: string;
    accountId!: number;
    limitPrice?: number | undefined;
    stopPrice?: number | undefined;
    executePrice?: number | undefined;
    createdAt!: dayjs.Dayjs;
    tradeDay!: dayjs.Dayjs;
    filledAt?: dayjs.Dayjs | undefined;
    cancelledAt?: dayjs.Dayjs | undefined;
    status!: OrderStatus;
    type!: OrderType;
    positionSize!: number;
    rejectionReason?: string | undefined;
    customTag?: string | undefined;
    trailDistance?: number | undefined;
    contractId!: string;
    contractName!: string;
    totalFilled!: number;

    constructor(data?: IOrderModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.symbolId = _data["symbolId"];
            this.symbolName = _data["symbolName"];
            this.accountId = _data["accountId"];
            this.limitPrice = _data["limitPrice"];
            this.stopPrice = _data["stopPrice"];
            this.executePrice = _data["executePrice"];
            this.createdAt = _data["createdAt"] ? dayjs(_data["createdAt"].toString()) : <any>undefined;
            this.tradeDay = _data["tradeDay"] ? dayjs(_data["tradeDay"].toString()) : <any>undefined;
            this.filledAt = _data["filledAt"] ? dayjs(_data["filledAt"].toString()) : <any>undefined;
            this.cancelledAt = _data["cancelledAt"] ? dayjs(_data["cancelledAt"].toString()) : <any>undefined;
            this.status = _data["status"];
            this.type = _data["type"];
            this.positionSize = _data["positionSize"];
            this.rejectionReason = _data["rejectionReason"];
            this.customTag = _data["customTag"];
            this.trailDistance = _data["trailDistance"];
            this.contractId = _data["contractId"];
            this.contractName = _data["contractName"];
            this.totalFilled = _data["totalFilled"];
        }
    }

    static fromJS(data: any): OrderModel {
        data = typeof data === 'object' ? data : {};
        let result = new OrderModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["symbolId"] = this.symbolId;
        data["symbolName"] = this.symbolName;
        data["accountId"] = this.accountId;
        data["limitPrice"] = this.limitPrice;
        data["stopPrice"] = this.stopPrice;
        data["executePrice"] = this.executePrice;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : <any>undefined;
        data["tradeDay"] = this.tradeDay ? this.tradeDay.toISOString() : <any>undefined;
        data["filledAt"] = this.filledAt ? this.filledAt.toISOString() : <any>undefined;
        data["cancelledAt"] = this.cancelledAt ? this.cancelledAt.toISOString() : <any>undefined;
        data["status"] = this.status;
        data["type"] = this.type;
        data["positionSize"] = this.positionSize;
        data["rejectionReason"] = this.rejectionReason;
        data["customTag"] = this.customTag;
        data["trailDistance"] = this.trailDistance;
        data["contractId"] = this.contractId;
        data["contractName"] = this.contractName;
        data["totalFilled"] = this.totalFilled;
        return data;
    }
}

export interface IOrderModel {
    id: number;
    symbolId: string;
    symbolName: string;
    accountId: number;
    limitPrice?: number | undefined;
    stopPrice?: number | undefined;
    executePrice?: number | undefined;
    createdAt: dayjs.Dayjs;
    tradeDay: dayjs.Dayjs;
    filledAt?: dayjs.Dayjs | undefined;
    cancelledAt?: dayjs.Dayjs | undefined;
    status: OrderStatus;
    type: OrderType;
    positionSize: number;
    rejectionReason?: string | undefined;
    customTag?: string | undefined;
    trailDistance?: number | undefined;
    contractId: string;
    contractName: string;
    totalFilled: number;
}

/** 0 = None 1 = Open 2 = Filled 3 = Cancelled 4 = Expired 5 = Rejected 6 = Pending */
export enum OrderStatus {
    None = 0,
    Open = 1,
    Filled = 2,
    Cancelled = 3,
    Expired = 4,
    Rejected = 5,
    Pending = 6,
}

/** 0 = Unknown 1 = Limit 2 = Market 3 = StopLimit 4 = Stop 5 = TrailingStop 6 = JoinBid 7 = JoinAsk */
export enum OrderType {
    Unknown = 0,
    Limit = 1,
    Market = 2,
    StopLimit = 3,
    Stop = 4,
    TrailingStop = 5,
    JoinBid = 6,
    JoinAsk = 7,
}

export class PlaceOrderResponse implements IPlaceOrderResponse {
    result!: PlaceOrderResult;
    positionDisposition!: OrderPositionDisposition;
    orderId?: number | undefined;
    errorMessage?: string | undefined;

    constructor(data?: IPlaceOrderResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.result = _data["result"];
            this.positionDisposition = _data["positionDisposition"];
            this.orderId = _data["orderId"];
            this.errorMessage = _data["errorMessage"];
        }
    }

    static fromJS(data: any): PlaceOrderResponse {
        data = typeof data === 'object' ? data : {};
        let result = new PlaceOrderResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["result"] = this.result;
        data["positionDisposition"] = this.positionDisposition;
        data["orderId"] = this.orderId;
        data["errorMessage"] = this.errorMessage;
        return data;
    }
}

export interface IPlaceOrderResponse {
    result: PlaceOrderResult;
    positionDisposition: OrderPositionDisposition;
    orderId?: number | undefined;
    errorMessage?: string | undefined;
}

/** 0 = Filled 1 = Queued 2 = Rejected 3 = InsufficientFunds 4 = Violation 5 = OutsideTradingHours 6 = Pending */
export enum PlaceOrderResult {
    Filled = 0,
    Queued = 1,
    Rejected = 2,
    InsufficientFunds = 3,
    Violation = 4,
    OutsideTradingHours = 5,
    Pending = 6,
}

/** 0 = Undetermined 1 = Opening 2 = Closing */
export enum OrderPositionDisposition {
    Undetermined = 0,
    Opening = 1,
    Closing = 2,
}

export class PlaceOrderRequest implements IPlaceOrderRequest {
    accountId!: number;
    symbolId!: string;
    type!: OrderType;
    limitPrice?: number | undefined;
    stopPrice?: number | undefined;
    trailDistance?: number | undefined;
    positionSize!: number;
    customTag?: string | undefined;
    linkedOrderId?: number | undefined;
    contractId?: string | undefined;

    constructor(data?: IPlaceOrderRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accountId = _data["accountId"];
            this.symbolId = _data["symbolId"];
            this.type = _data["type"];
            this.limitPrice = _data["limitPrice"];
            this.stopPrice = _data["stopPrice"];
            this.trailDistance = _data["trailDistance"];
            this.positionSize = _data["positionSize"];
            this.customTag = _data["customTag"];
            this.linkedOrderId = _data["linkedOrderId"];
            this.contractId = _data["contractId"];
        }
    }

    static fromJS(data: any): PlaceOrderRequest {
        data = typeof data === 'object' ? data : {};
        let result = new PlaceOrderRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accountId"] = this.accountId;
        data["symbolId"] = this.symbolId;
        data["type"] = this.type;
        data["limitPrice"] = this.limitPrice;
        data["stopPrice"] = this.stopPrice;
        data["trailDistance"] = this.trailDistance;
        data["positionSize"] = this.positionSize;
        data["customTag"] = this.customTag;
        data["linkedOrderId"] = this.linkedOrderId;
        data["contractId"] = this.contractId;
        return data;
    }
}

export interface IPlaceOrderRequest {
    accountId: number;
    symbolId: string;
    type: OrderType;
    limitPrice?: number | undefined;
    stopPrice?: number | undefined;
    trailDistance?: number | undefined;
    positionSize: number;
    customTag?: string | undefined;
    linkedOrderId?: number | undefined;
    contractId?: string | undefined;
}

export class OrderExportModel implements IOrderExportModel {
    id!: number;
    accountName!: string;
    contractName!: string;
    status!: OrderStatus;
    type!: OrderType;
    size!: number;
    side!: OrderSide;
    createdAt!: dayjs.Dayjs;
    tradeDay!: dayjs.Dayjs;
    filledAt?: dayjs.Dayjs | undefined;
    cancelledAt?: dayjs.Dayjs | undefined;
    stopPrice?: number | undefined;
    limitPrice?: number | undefined;
    executePrice?: number | undefined;
    positionDisposition!: OrderPositionDisposition;
    creationDisposition!: OrderCreationDisposition;
    rejectionReason?: string | undefined;

    constructor(data?: IOrderExportModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.accountName = _data["accountName"];
            this.contractName = _data["contractName"];
            this.status = _data["status"];
            this.type = _data["type"];
            this.size = _data["size"];
            this.side = _data["side"];
            this.createdAt = _data["createdAt"] ? dayjs(_data["createdAt"].toString()) : <any>undefined;
            this.tradeDay = _data["tradeDay"] ? dayjs(_data["tradeDay"].toString()) : <any>undefined;
            this.filledAt = _data["filledAt"] ? dayjs(_data["filledAt"].toString()) : <any>undefined;
            this.cancelledAt = _data["cancelledAt"] ? dayjs(_data["cancelledAt"].toString()) : <any>undefined;
            this.stopPrice = _data["stopPrice"];
            this.limitPrice = _data["limitPrice"];
            this.executePrice = _data["executePrice"];
            this.positionDisposition = _data["positionDisposition"];
            this.creationDisposition = _data["creationDisposition"];
            this.rejectionReason = _data["rejectionReason"];
        }
    }

    static fromJS(data: any): OrderExportModel {
        data = typeof data === 'object' ? data : {};
        let result = new OrderExportModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["accountName"] = this.accountName;
        data["contractName"] = this.contractName;
        data["status"] = this.status;
        data["type"] = this.type;
        data["size"] = this.size;
        data["side"] = this.side;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : <any>undefined;
        data["tradeDay"] = this.tradeDay ? this.tradeDay.toISOString() : <any>undefined;
        data["filledAt"] = this.filledAt ? this.filledAt.toISOString() : <any>undefined;
        data["cancelledAt"] = this.cancelledAt ? this.cancelledAt.toISOString() : <any>undefined;
        data["stopPrice"] = this.stopPrice;
        data["limitPrice"] = this.limitPrice;
        data["executePrice"] = this.executePrice;
        data["positionDisposition"] = this.positionDisposition;
        data["creationDisposition"] = this.creationDisposition;
        data["rejectionReason"] = this.rejectionReason;
        return data;
    }
}

export interface IOrderExportModel {
    id: number;
    accountName: string;
    contractName: string;
    status: OrderStatus;
    type: OrderType;
    size: number;
    side: OrderSide;
    createdAt: dayjs.Dayjs;
    tradeDay: dayjs.Dayjs;
    filledAt?: dayjs.Dayjs | undefined;
    cancelledAt?: dayjs.Dayjs | undefined;
    stopPrice?: number | undefined;
    limitPrice?: number | undefined;
    executePrice?: number | undefined;
    positionDisposition: OrderPositionDisposition;
    creationDisposition: OrderCreationDisposition;
    rejectionReason?: string | undefined;
}

/** 0 = Bid 1 = Ask */
export enum OrderSide {
    Bid = 0,
    Ask = 1,
}

/** 0 = Undetermined 1 = StopLoss 2 = TakeProfit 3 = ClosePosition 4 = ReversePosition 5 = Trader */
export enum OrderCreationDisposition {
    Undetermined = 0,
    StopLoss = 1,
    TakeProfit = 2,
    ClosePosition = 3,
    ReversePosition = 4,
    Trader = 5,
}

export class UserExportRequest implements IUserExportRequest {
    tradingAccountId!: number;
    start!: dayjs.Dayjs;
    end!: dayjs.Dayjs;
    timeZone?: string | undefined;

    constructor(data?: IUserExportRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tradingAccountId = _data["tradingAccountId"];
            this.start = _data["start"] ? dayjs(_data["start"].toString()) : <any>undefined;
            this.end = _data["end"] ? dayjs(_data["end"].toString()) : <any>undefined;
            this.timeZone = _data["timeZone"];
        }
    }

    static fromJS(data: any): UserExportRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UserExportRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tradingAccountId"] = this.tradingAccountId;
        data["start"] = this.start ? this.start.toISOString() : <any>undefined;
        data["end"] = this.end ? this.end.toISOString() : <any>undefined;
        data["timeZone"] = this.timeZone;
        return data;
    }
}

export interface IUserExportRequest {
    tradingAccountId: number;
    start: dayjs.Dayjs;
    end: dayjs.Dayjs;
    timeZone?: string | undefined;
}

export class UpdateStopLossResponse implements IUpdateStopLossResponse {
    success!: boolean;
    errorMessage?: string | undefined;
    stopLoss?: number | undefined;
    takeProfit?: number | undefined;

    constructor(data?: IUpdateStopLossResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.success = _data["success"];
            this.errorMessage = _data["errorMessage"];
            this.stopLoss = _data["stopLoss"];
            this.takeProfit = _data["takeProfit"];
        }
    }

    static fromJS(data: any): UpdateStopLossResponse {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateStopLossResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        data["errorMessage"] = this.errorMessage;
        data["stopLoss"] = this.stopLoss;
        data["takeProfit"] = this.takeProfit;
        return data;
    }
}

export interface IUpdateStopLossResponse {
    success: boolean;
    errorMessage?: string | undefined;
    stopLoss?: number | undefined;
    takeProfit?: number | undefined;
}

export class UpdateStopLossAccountRequest implements IUpdateStopLossAccountRequest {
    tradingAccountId!: number;
    positionId!: number;
    stopLoss?: number | undefined;
    takeProfit?: number | undefined;

    constructor(data?: IUpdateStopLossAccountRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tradingAccountId = _data["tradingAccountId"];
            this.positionId = _data["positionId"];
            this.stopLoss = _data["stopLoss"];
            this.takeProfit = _data["takeProfit"];
        }
    }

    static fromJS(data: any): UpdateStopLossAccountRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateStopLossAccountRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tradingAccountId"] = this.tradingAccountId;
        data["positionId"] = this.positionId;
        data["stopLoss"] = this.stopLoss;
        data["takeProfit"] = this.takeProfit;
        return data;
    }
}

export interface IUpdateStopLossAccountRequest {
    tradingAccountId: number;
    positionId: number;
    stopLoss?: number | undefined;
    takeProfit?: number | undefined;
}

export class UpdateStopLossRequest implements IUpdateStopLossRequest {
    positionId!: number;
    stopLoss?: number | undefined;
    takeProfit?: number | undefined;

    constructor(data?: IUpdateStopLossRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.positionId = _data["positionId"];
            this.stopLoss = _data["stopLoss"];
            this.takeProfit = _data["takeProfit"];
        }
    }

    static fromJS(data: any): UpdateStopLossRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateStopLossRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["positionId"] = this.positionId;
        data["stopLoss"] = this.stopLoss;
        data["takeProfit"] = this.takeProfit;
        return data;
    }
}

export interface IUpdateStopLossRequest {
    positionId: number;
    stopLoss?: number | undefined;
    takeProfit?: number | undefined;
}

export class PersonalLockoutModel implements IPersonalLockoutModel {
    id!: number;
    tradingAccountId!: number;
    userId!: number;
    reason?: string | undefined;
    shouldLiquidate!: boolean;
    createdAt!: dayjs.Dayjs;
    tradeDay!: dayjs.Dayjs;
    startsAt!: dayjs.Dayjs;
    expiresAt!: dayjs.Dayjs;
    type!: PersonalLockoutType;

    constructor(data?: IPersonalLockoutModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.tradingAccountId = _data["tradingAccountId"];
            this.userId = _data["userId"];
            this.reason = _data["reason"];
            this.shouldLiquidate = _data["shouldLiquidate"];
            this.createdAt = _data["createdAt"] ? dayjs(_data["createdAt"].toString()) : <any>undefined;
            this.tradeDay = _data["tradeDay"] ? dayjs(_data["tradeDay"].toString()) : <any>undefined;
            this.startsAt = _data["startsAt"] ? dayjs(_data["startsAt"].toString()) : <any>undefined;
            this.expiresAt = _data["expiresAt"] ? dayjs(_data["expiresAt"].toString()) : <any>undefined;
            this.type = _data["type"];
        }
    }

    static fromJS(data: any): PersonalLockoutModel {
        data = typeof data === 'object' ? data : {};
        let result = new PersonalLockoutModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["tradingAccountId"] = this.tradingAccountId;
        data["userId"] = this.userId;
        data["reason"] = this.reason;
        data["shouldLiquidate"] = this.shouldLiquidate;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : <any>undefined;
        data["tradeDay"] = this.tradeDay ? this.tradeDay.toISOString() : <any>undefined;
        data["startsAt"] = this.startsAt ? this.startsAt.toISOString() : <any>undefined;
        data["expiresAt"] = this.expiresAt ? this.expiresAt.toISOString() : <any>undefined;
        data["type"] = this.type;
        return data;
    }
}

export interface IPersonalLockoutModel {
    id: number;
    tradingAccountId: number;
    userId: number;
    reason?: string | undefined;
    shouldLiquidate: boolean;
    createdAt: dayjs.Dayjs;
    tradeDay: dayjs.Dayjs;
    startsAt: dayjs.Dayjs;
    expiresAt: dayjs.Dayjs;
    type: PersonalLockoutType;
}

/** 0 = Unknown 1 = Personal 2 = WeeklyTradeLimit 3 = DailyTradeLimit 4 = TradeClock */
export enum PersonalLockoutType {
    Unknown = 0,
    Personal = 1,
    WeeklyTradeLimit = 2,
    DailyTradeLimit = 3,
    TradeClock = 4,
}

export class SetPersonalLockoutResult implements ISetPersonalLockoutResult {
    id!: number;
    message!: string;
    success!: boolean;

    constructor(data?: ISetPersonalLockoutResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.message = _data["message"];
            this.success = _data["success"];
        }
    }

    static fromJS(data: any): SetPersonalLockoutResult {
        data = typeof data === 'object' ? data : {};
        let result = new SetPersonalLockoutResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["message"] = this.message;
        data["success"] = this.success;
        return data;
    }
}

export interface ISetPersonalLockoutResult {
    id: number;
    message: string;
    success: boolean;
}

export class StopLossTakeProfitModel implements IStopLossTakeProfitModel {
    positionId!: number;
    stopLoss?: number | undefined;
    takeProfit?: number | undefined;
    errorMessage?: string | undefined;
    cancellationSource!: LegacyOrderCancellationSource;

    constructor(data?: IStopLossTakeProfitModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.positionId = _data["positionId"];
            this.stopLoss = _data["stopLoss"];
            this.takeProfit = _data["takeProfit"];
            this.errorMessage = _data["errorMessage"];
            this.cancellationSource = _data["cancellationSource"];
        }
    }

    static fromJS(data: any): StopLossTakeProfitModel {
        data = typeof data === 'object' ? data : {};
        let result = new StopLossTakeProfitModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["positionId"] = this.positionId;
        data["stopLoss"] = this.stopLoss;
        data["takeProfit"] = this.takeProfit;
        data["errorMessage"] = this.errorMessage;
        data["cancellationSource"] = this.cancellationSource;
        return data;
    }
}

export interface IStopLossTakeProfitModel {
    positionId: number;
    stopLoss?: number | undefined;
    takeProfit?: number | undefined;
    errorMessage?: string | undefined;
    cancellationSource: LegacyOrderCancellationSource;
}

/** 0 = Trader 1 = System 2 = Admin */
export enum LegacyOrderCancellationSource {
    Trader = 0,
    System = 1,
    Admin = 2,
}

export class UpdateStopLossTakeProfitResult implements IUpdateStopLossTakeProfitResult {
    positionId!: number;
    stopLoss?: number | undefined;
    takeProfit?: number | undefined;
    errorCode!: UpdateStopLossTakeProfitErrorCode;

    constructor(data?: IUpdateStopLossTakeProfitResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.positionId = _data["positionId"];
            this.stopLoss = _data["stopLoss"];
            this.takeProfit = _data["takeProfit"];
            this.errorCode = _data["errorCode"];
        }
    }

    static fromJS(data: any): UpdateStopLossTakeProfitResult {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateStopLossTakeProfitResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["positionId"] = this.positionId;
        data["stopLoss"] = this.stopLoss;
        data["takeProfit"] = this.takeProfit;
        data["errorCode"] = this.errorCode;
        return data;
    }
}

export interface IUpdateStopLossTakeProfitResult {
    positionId: number;
    stopLoss?: number | undefined;
    takeProfit?: number | undefined;
    errorCode: UpdateStopLossTakeProfitErrorCode;
}

/** 0 = Success 1 = PositionNotFound 2 = InvalidStopLoss 3 = InvalidTakeProfit 4 = TradingDisabled 5 = FollowAccount */
export enum UpdateStopLossTakeProfitErrorCode {
    Success = 0,
    PositionNotFound = 1,
    InvalidStopLoss = 2,
    InvalidTakeProfit = 3,
    TradingDisabled = 4,
    FollowAccount = 5,
}

export class PositionModel implements IPositionModel {
    id!: number;
    symbolId!: string;
    symbolName!: string;
    positionSize!: number;
    stopLoss?: number | undefined;
    takeProfit?: number | undefined;
    toMake?: number | undefined;
    risk?: number | undefined;
    averagePrice!: number;
    profitAndLoss!: number;
    entryTime!: dayjs.Dayjs;
    accountId!: number;
    stopLossOrderId?: number | undefined;
    takeProfitOrderId?: number | undefined;
    contractId?: string | undefined;

    constructor(data?: IPositionModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.symbolId = _data["symbolId"];
            this.symbolName = _data["symbolName"];
            this.positionSize = _data["positionSize"];
            this.stopLoss = _data["stopLoss"];
            this.takeProfit = _data["takeProfit"];
            this.toMake = _data["toMake"];
            this.risk = _data["risk"];
            this.averagePrice = _data["averagePrice"];
            this.profitAndLoss = _data["profitAndLoss"];
            this.entryTime = _data["entryTime"] ? dayjs(_data["entryTime"].toString()) : <any>undefined;
            this.accountId = _data["accountId"];
            this.stopLossOrderId = _data["stopLossOrderId"];
            this.takeProfitOrderId = _data["takeProfitOrderId"];
            this.contractId = _data["contractId"];
        }
    }

    static fromJS(data: any): PositionModel {
        data = typeof data === 'object' ? data : {};
        let result = new PositionModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["symbolId"] = this.symbolId;
        data["symbolName"] = this.symbolName;
        data["positionSize"] = this.positionSize;
        data["stopLoss"] = this.stopLoss;
        data["takeProfit"] = this.takeProfit;
        data["toMake"] = this.toMake;
        data["risk"] = this.risk;
        data["averagePrice"] = this.averagePrice;
        data["profitAndLoss"] = this.profitAndLoss;
        data["entryTime"] = this.entryTime ? this.entryTime.toISOString() : <any>undefined;
        data["accountId"] = this.accountId;
        data["stopLossOrderId"] = this.stopLossOrderId;
        data["takeProfitOrderId"] = this.takeProfitOrderId;
        data["contractId"] = this.contractId;
        return data;
    }
}

export interface IPositionModel {
    id: number;
    symbolId: string;
    symbolName: string;
    positionSize: number;
    stopLoss?: number | undefined;
    takeProfit?: number | undefined;
    toMake?: number | undefined;
    risk?: number | undefined;
    averagePrice: number;
    profitAndLoss: number;
    entryTime: dayjs.Dayjs;
    accountId: number;
    stopLossOrderId?: number | undefined;
    takeProfitOrderId?: number | undefined;
    contractId?: string | undefined;
}

export class RegisterResponse implements IRegisterResponse {
    userId?: number | undefined;
    loginToken?: string | undefined;
    errorMessage?: string | undefined;
    result!: RegisterResult;

    constructor(data?: IRegisterResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.loginToken = _data["loginToken"];
            this.errorMessage = _data["errorMessage"];
            this.result = _data["result"];
        }
    }

    static fromJS(data: any): RegisterResponse {
        data = typeof data === 'object' ? data : {};
        let result = new RegisterResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["loginToken"] = this.loginToken;
        data["errorMessage"] = this.errorMessage;
        data["result"] = this.result;
        return data;
    }
}

export interface IRegisterResponse {
    userId?: number | undefined;
    loginToken?: string | undefined;
    errorMessage?: string | undefined;
    result: RegisterResult;
}

/** 0 = Success 1 = UsernameTaken 2 = EmailTaken 3 = InvalidEmail 4 = InvalidPassword */
export enum RegisterResult {
    Success = 0,
    UsernameTaken = 1,
    EmailTaken = 2,
    InvalidEmail = 3,
    InvalidPassword = 4,
}

export class RegisterRequest implements IRegisterRequest {
    password!: string;
    email!: string;
    userName?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    screenName?: string | undefined;
    internalTag?: UserInternalTag | undefined;

    constructor(data?: IRegisterRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.password = _data["password"];
            this.email = _data["email"];
            this.userName = _data["userName"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.screenName = _data["screenName"];
            this.internalTag = _data["internalTag"];
        }
    }

    static fromJS(data: any): RegisterRequest {
        data = typeof data === 'object' ? data : {};
        let result = new RegisterRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["password"] = this.password;
        data["email"] = this.email;
        data["userName"] = this.userName;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["screenName"] = this.screenName;
        data["internalTag"] = this.internalTag;
        return data;
    }
}

export interface IRegisterRequest {
    password: string;
    email: string;
    userName?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    screenName?: string | undefined;
    internalTag?: UserInternalTag | undefined;
}

/** 0 = Default 1 = Internal */
export enum UserInternalTag {
    Default = 0,
    Internal = 1,
}

export class RiskSettingsLockout implements IRiskSettingsLockout {
    tradingAccount!: TradingAccount;
    id!: number;
    tradingAccountId!: number;
    createdAt!: dayjs.Dayjs;
    expiresAt!: dayjs.Dayjs;

    constructor(data?: IRiskSettingsLockout) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.tradingAccount = new TradingAccount();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tradingAccount = _data["tradingAccount"] ? TradingAccount.fromJS(_data["tradingAccount"]) : new TradingAccount();
            this.id = _data["id"];
            this.tradingAccountId = _data["tradingAccountId"];
            this.createdAt = _data["createdAt"] ? dayjs(_data["createdAt"].toString()) : <any>undefined;
            this.expiresAt = _data["expiresAt"] ? dayjs(_data["expiresAt"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): RiskSettingsLockout {
        data = typeof data === 'object' ? data : {};
        let result = new RiskSettingsLockout();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tradingAccount"] = this.tradingAccount ? this.tradingAccount.toJSON() : <any>undefined;
        data["id"] = this.id;
        data["tradingAccountId"] = this.tradingAccountId;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : <any>undefined;
        data["expiresAt"] = this.expiresAt ? this.expiresAt.toISOString() : <any>undefined;
        return data;
    }
}

export interface IRiskSettingsLockout {
    tradingAccount: TradingAccount;
    id: number;
    tradingAccountId: number;
    createdAt: dayjs.Dayjs;
    expiresAt: dayjs.Dayjs;
}

export class TradingAccount implements ITradingAccount {
    id!: number;
    createdAt!: dayjs.Dayjs;
    balance!: number;
    highestBalance!: number;
    highestRealizedBalance!: number;
    minimumMll?: number | undefined;
    winPercentage!: number;
    winningTrades!: number;
    totalTrades!: number;
    dailyTrades!: number;
    status!: TradingAccountStatus;
    lockoutExpiration?: dayjs.Dayjs | undefined;
    lockoutReason?: string | undefined;
    dailyTradeLimit?: number | undefined;
    weeklyTradeLimit?: number | undefined;
    ineligible!: boolean;
    startingBalance!: number;
    platformAccountId?: string | undefined;
    platformUserName?: string | undefined;
    platformId!: PlatformId;
    tradingCombineId?: number | undefined;
    userId!: number;
    isSharing!: boolean;
    name!: string;
    nickname?: string | undefined;
    realizedDayPnl!: number;
    externalName?: string | undefined;
    maxPositionSize!: number;
    drawDownLimit!: number;
    dailyLossLimit!: number;
    overrideDailyLossLimit?: number | undefined;
    personalDailyLossLimit?: number | undefined;
    personalDailyLossLimitTrailing!: boolean;
    pdllTrailingType!: PersonalDailyLossLimitTrailingType;
    personalDailyLossLimitAction!: PersonalDailyAction;
    personalDailyProfitTarget?: number | undefined;
    personalDailyProfitTargetAction!: PersonalDailyAction;
    pdllTrailingStartingBalance?: number | undefined;
    updatedAt!: dayjs.Dayjs;
    closedAt?: dayjs.Dayjs | undefined;
    closeReason?: string | undefined;
    type!: TradingAccountType;
    internalTag!: TradingAccountInternalTag;
    maxMargin?: number | undefined;
    archived!: boolean;
    accountTemplateId?: number | undefined;

    constructor(data?: ITradingAccount) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.createdAt = _data["createdAt"] ? dayjs(_data["createdAt"].toString()) : <any>undefined;
            this.balance = _data["balance"];
            this.highestBalance = _data["highestBalance"];
            this.highestRealizedBalance = _data["highestRealizedBalance"];
            this.minimumMll = _data["minimumMll"];
            this.winPercentage = _data["winPercentage"];
            this.winningTrades = _data["winningTrades"];
            this.totalTrades = _data["totalTrades"];
            this.dailyTrades = _data["dailyTrades"];
            this.status = _data["status"];
            this.lockoutExpiration = _data["lockoutExpiration"] ? dayjs(_data["lockoutExpiration"].toString()) : <any>undefined;
            this.lockoutReason = _data["lockoutReason"];
            this.dailyTradeLimit = _data["dailyTradeLimit"];
            this.weeklyTradeLimit = _data["weeklyTradeLimit"];
            this.ineligible = _data["ineligible"];
            this.startingBalance = _data["startingBalance"];
            this.platformAccountId = _data["platformAccountId"];
            this.platformUserName = _data["platformUserName"];
            this.platformId = _data["platformId"];
            this.tradingCombineId = _data["tradingCombineId"];
            this.userId = _data["userId"];
            this.isSharing = _data["isSharing"];
            this.name = _data["name"];
            this.nickname = _data["nickname"];
            this.realizedDayPnl = _data["realizedDayPnl"];
            this.externalName = _data["externalName"];
            this.maxPositionSize = _data["maxPositionSize"];
            this.drawDownLimit = _data["drawDownLimit"];
            this.dailyLossLimit = _data["dailyLossLimit"];
            this.overrideDailyLossLimit = _data["overrideDailyLossLimit"];
            this.personalDailyLossLimit = _data["personalDailyLossLimit"];
            this.personalDailyLossLimitTrailing = _data["personalDailyLossLimitTrailing"];
            this.pdllTrailingType = _data["pdllTrailingType"];
            this.personalDailyLossLimitAction = _data["personalDailyLossLimitAction"];
            this.personalDailyProfitTarget = _data["personalDailyProfitTarget"];
            this.personalDailyProfitTargetAction = _data["personalDailyProfitTargetAction"];
            this.pdllTrailingStartingBalance = _data["pdllTrailingStartingBalance"];
            this.updatedAt = _data["updatedAt"] ? dayjs(_data["updatedAt"].toString()) : <any>undefined;
            this.closedAt = _data["closedAt"] ? dayjs(_data["closedAt"].toString()) : <any>undefined;
            this.closeReason = _data["closeReason"];
            this.type = _data["type"];
            this.internalTag = _data["internalTag"];
            this.maxMargin = _data["maxMargin"];
            this.archived = _data["archived"];
            this.accountTemplateId = _data["accountTemplateId"];
        }
    }

    static fromJS(data: any): TradingAccount {
        data = typeof data === 'object' ? data : {};
        let result = new TradingAccount();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : <any>undefined;
        data["balance"] = this.balance;
        data["highestBalance"] = this.highestBalance;
        data["highestRealizedBalance"] = this.highestRealizedBalance;
        data["minimumMll"] = this.minimumMll;
        data["winPercentage"] = this.winPercentage;
        data["winningTrades"] = this.winningTrades;
        data["totalTrades"] = this.totalTrades;
        data["dailyTrades"] = this.dailyTrades;
        data["status"] = this.status;
        data["lockoutExpiration"] = this.lockoutExpiration ? this.lockoutExpiration.toISOString() : <any>undefined;
        data["lockoutReason"] = this.lockoutReason;
        data["dailyTradeLimit"] = this.dailyTradeLimit;
        data["weeklyTradeLimit"] = this.weeklyTradeLimit;
        data["ineligible"] = this.ineligible;
        data["startingBalance"] = this.startingBalance;
        data["platformAccountId"] = this.platformAccountId;
        data["platformUserName"] = this.platformUserName;
        data["platformId"] = this.platformId;
        data["tradingCombineId"] = this.tradingCombineId;
        data["userId"] = this.userId;
        data["isSharing"] = this.isSharing;
        data["name"] = this.name;
        data["nickname"] = this.nickname;
        data["realizedDayPnl"] = this.realizedDayPnl;
        data["externalName"] = this.externalName;
        data["maxPositionSize"] = this.maxPositionSize;
        data["drawDownLimit"] = this.drawDownLimit;
        data["dailyLossLimit"] = this.dailyLossLimit;
        data["overrideDailyLossLimit"] = this.overrideDailyLossLimit;
        data["personalDailyLossLimit"] = this.personalDailyLossLimit;
        data["personalDailyLossLimitTrailing"] = this.personalDailyLossLimitTrailing;
        data["pdllTrailingType"] = this.pdllTrailingType;
        data["personalDailyLossLimitAction"] = this.personalDailyLossLimitAction;
        data["personalDailyProfitTarget"] = this.personalDailyProfitTarget;
        data["personalDailyProfitTargetAction"] = this.personalDailyProfitTargetAction;
        data["pdllTrailingStartingBalance"] = this.pdllTrailingStartingBalance;
        data["updatedAt"] = this.updatedAt ? this.updatedAt.toISOString() : <any>undefined;
        data["closedAt"] = this.closedAt ? this.closedAt.toISOString() : <any>undefined;
        data["closeReason"] = this.closeReason;
        data["type"] = this.type;
        data["internalTag"] = this.internalTag;
        data["maxMargin"] = this.maxMargin;
        data["archived"] = this.archived;
        data["accountTemplateId"] = this.accountTemplateId;
        return data;
    }
}

export interface ITradingAccount {
    id: number;
    createdAt: dayjs.Dayjs;
    balance: number;
    highestBalance: number;
    highestRealizedBalance: number;
    minimumMll?: number | undefined;
    winPercentage: number;
    winningTrades: number;
    totalTrades: number;
    dailyTrades: number;
    status: TradingAccountStatus;
    lockoutExpiration?: dayjs.Dayjs | undefined;
    lockoutReason?: string | undefined;
    dailyTradeLimit?: number | undefined;
    weeklyTradeLimit?: number | undefined;
    ineligible: boolean;
    startingBalance: number;
    platformAccountId?: string | undefined;
    platformUserName?: string | undefined;
    platformId: PlatformId;
    tradingCombineId?: number | undefined;
    userId: number;
    isSharing: boolean;
    name: string;
    nickname?: string | undefined;
    realizedDayPnl: number;
    externalName?: string | undefined;
    maxPositionSize: number;
    drawDownLimit: number;
    dailyLossLimit: number;
    overrideDailyLossLimit?: number | undefined;
    personalDailyLossLimit?: number | undefined;
    personalDailyLossLimitTrailing: boolean;
    pdllTrailingType: PersonalDailyLossLimitTrailingType;
    personalDailyLossLimitAction: PersonalDailyAction;
    personalDailyProfitTarget?: number | undefined;
    personalDailyProfitTargetAction: PersonalDailyAction;
    pdllTrailingStartingBalance?: number | undefined;
    updatedAt: dayjs.Dayjs;
    closedAt?: dayjs.Dayjs | undefined;
    closeReason?: string | undefined;
    type: TradingAccountType;
    internalTag: TradingAccountInternalTag;
    maxMargin?: number | undefined;
    archived: boolean;
    accountTemplateId?: number | undefined;
}

/** 0 = Sim 10 = CTS */
export enum PlatformId {
    Sim = 0,
    CTS = 10,
}

/** 0 = None 1 = UnrealizedGains 2 = RealizedGains */
export enum PersonalDailyLossLimitTrailingType {
    None = 0,
    UnrealizedGains = 1,
    RealizedGains = 2,
}

/** 0 = None 1 = Liquidate 2 = LiquidateAndBlock */
export enum PersonalDailyAction {
    None = 0,
    Liquidate = 1,
    LiquidateAndBlock = 2,
}

/** 0 = None 1 = Sim 2 = Live 3 = Express 4 = Practice */
export enum TradingAccountType {
    None = 0,
    Sim = 1,
    Live = 2,
    Express = 3,
    Practice = 4,
}

/** 0 = Default 1 = Internal */
export enum TradingAccountInternalTag {
    Default = 0,
    Internal = 1,
}

export class CreateRiskSettingsLockoutResult implements ICreateRiskSettingsLockoutResult {
    message!: string;
    success!: boolean;
    newExpiresAt?: dayjs.Dayjs | undefined;

    constructor(data?: ICreateRiskSettingsLockoutResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.message = _data["message"];
            this.success = _data["success"];
            this.newExpiresAt = _data["newExpiresAt"] ? dayjs(_data["newExpiresAt"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): CreateRiskSettingsLockoutResult {
        data = typeof data === 'object' ? data : {};
        let result = new CreateRiskSettingsLockoutResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["message"] = this.message;
        data["success"] = this.success;
        data["newExpiresAt"] = this.newExpiresAt ? this.newExpiresAt.toISOString() : <any>undefined;
        return data;
    }
}

export interface ICreateRiskSettingsLockoutResult {
    message: string;
    success: boolean;
    newExpiresAt?: dayjs.Dayjs | undefined;
}

export class RiskSettingsLockoutModel implements IRiskSettingsLockoutModel {
    id!: number;
    tradingAccountId!: number;
    createdAt!: dayjs.Dayjs;
    expiresAt!: dayjs.Dayjs;

    constructor(data?: IRiskSettingsLockoutModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.tradingAccountId = _data["tradingAccountId"];
            this.createdAt = _data["createdAt"] ? dayjs(_data["createdAt"].toString()) : <any>undefined;
            this.expiresAt = _data["expiresAt"] ? dayjs(_data["expiresAt"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): RiskSettingsLockoutModel {
        data = typeof data === 'object' ? data : {};
        let result = new RiskSettingsLockoutModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["tradingAccountId"] = this.tradingAccountId;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : <any>undefined;
        data["expiresAt"] = this.expiresAt ? this.expiresAt.toISOString() : <any>undefined;
        return data;
    }
}

export interface IRiskSettingsLockoutModel {
    id: number;
    tradingAccountId: number;
    createdAt: dayjs.Dayjs;
    expiresAt: dayjs.Dayjs;
}

export class UserSessionValidateResponse implements IUserSessionValidateResponse {
    token!: string;
    sessionId!: string;
    result!: SessionValidationResult;

    constructor(data?: IUserSessionValidateResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.token = _data["token"];
            this.sessionId = _data["sessionId"];
            this.result = _data["result"];
        }
    }

    static fromJS(data: any): UserSessionValidateResponse {
        data = typeof data === 'object' ? data : {};
        let result = new UserSessionValidateResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["token"] = this.token;
        data["sessionId"] = this.sessionId;
        data["result"] = this.result;
        return data;
    }
}

export interface IUserSessionValidateResponse {
    token: string;
    sessionId: string;
    result: SessionValidationResult;
}

/** 0 = Success 1 = Expired 2 = Invalid */
export enum SessionValidationResult {
    Success = 0,
    Expired = 1,
    Invalid = 2,
}

export class DayStatistic implements IDayStatistic {
    tradeDate!: dayjs.Dayjs;
    totalPnL!: number;
    totalTrades!: number;
    winningTrades!: number;
    losingTrades!: number;
    neutralTrades!: number;
    winRate!: number;
    totalFees!: number;

    constructor(data?: IDayStatistic) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tradeDate = _data["tradeDate"] ? dayjs(_data["tradeDate"].toString()) : <any>undefined;
            this.totalPnL = _data["totalPnL"];
            this.totalTrades = _data["totalTrades"];
            this.winningTrades = _data["winningTrades"];
            this.losingTrades = _data["losingTrades"];
            this.neutralTrades = _data["neutralTrades"];
            this.winRate = _data["winRate"];
            this.totalFees = _data["totalFees"];
        }
    }

    static fromJS(data: any): DayStatistic {
        data = typeof data === 'object' ? data : {};
        let result = new DayStatistic();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tradeDate"] = this.tradeDate ? this.tradeDate.toISOString() : <any>undefined;
        data["totalPnL"] = this.totalPnL;
        data["totalTrades"] = this.totalTrades;
        data["winningTrades"] = this.winningTrades;
        data["losingTrades"] = this.losingTrades;
        data["neutralTrades"] = this.neutralTrades;
        data["winRate"] = this.winRate;
        data["totalFees"] = this.totalFees;
        return data;
    }
}

export interface IDayStatistic {
    tradeDate: dayjs.Dayjs;
    totalPnL: number;
    totalTrades: number;
    winningTrades: number;
    losingTrades: number;
    neutralTrades: number;
    winRate: number;
    totalFees: number;
}

export class CompleteDayStatistic extends DayStatistic implements ICompleteDayStatistic {
    tradeDay!: dayjs.Dayjs;
    balance!: number;
    products!: ProductStatistic[];

    constructor(data?: ICompleteDayStatistic) {
        super(data);
        if (!data) {
            this.products = [];
        }
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.tradeDay = _data["tradeDay"] ? dayjs(_data["tradeDay"].toString()) : <any>undefined;
            this.balance = _data["balance"];
            if (Array.isArray(_data["products"])) {
                this.products = [] as any;
                for (let item of _data["products"])
                    this.products!.push(ProductStatistic.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): CompleteDayStatistic {
        data = typeof data === 'object' ? data : {};
        let result = new CompleteDayStatistic();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tradeDay"] = this.tradeDay ? this.tradeDay.toISOString() : <any>undefined;
        data["balance"] = this.balance;
        if (Array.isArray(this.products)) {
            data["products"] = [];
            for (let item of this.products)
                data["products"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface ICompleteDayStatistic extends IDayStatistic {
    tradeDay: dayjs.Dayjs;
    balance: number;
    products: ProductStatistic[];
}

export class ProductStatistic implements IProductStatistic {
    tradeDay!: dayjs.Dayjs;
    symbolId!: string;
    totalTradedContracts!: number;

    constructor(data?: IProductStatistic) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tradeDay = _data["tradeDay"] ? dayjs(_data["tradeDay"].toString()) : <any>undefined;
            this.symbolId = _data["symbolId"];
            this.totalTradedContracts = _data["totalTradedContracts"];
        }
    }

    static fromJS(data: any): ProductStatistic {
        data = typeof data === 'object' ? data : {};
        let result = new ProductStatistic();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tradeDay"] = this.tradeDay ? this.tradeDay.toISOString() : <any>undefined;
        data["symbolId"] = this.symbolId;
        data["totalTradedContracts"] = this.totalTradedContracts;
        return data;
    }
}

export interface IProductStatistic {
    tradeDay: dayjs.Dayjs;
    symbolId: string;
    totalTradedContracts: number;
}

export class GetMonthlyStatisticsRequest implements IGetMonthlyStatisticsRequest {
    tradingAccountId!: number;
    startTradeDay?: dayjs.Dayjs | undefined;
    endTradeDay?: dayjs.Dayjs | undefined;

    constructor(data?: IGetMonthlyStatisticsRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tradingAccountId = _data["tradingAccountId"];
            this.startTradeDay = _data["startTradeDay"] ? dayjs(_data["startTradeDay"].toString()) : <any>undefined;
            this.endTradeDay = _data["endTradeDay"] ? dayjs(_data["endTradeDay"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): GetMonthlyStatisticsRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetMonthlyStatisticsRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tradingAccountId"] = this.tradingAccountId;
        data["startTradeDay"] = this.startTradeDay ? this.startTradeDay.toISOString() : <any>undefined;
        data["endTradeDay"] = this.endTradeDay ? this.endTradeDay.toISOString() : <any>undefined;
        return data;
    }
}

export interface IGetMonthlyStatisticsRequest {
    tradingAccountId: number;
    startTradeDay?: dayjs.Dayjs | undefined;
    endTradeDay?: dayjs.Dayjs | undefined;
}

export class GetWeeklyStatisticsRequest implements IGetWeeklyStatisticsRequest {
    tradingAccountId!: number;
    startTradeDay?: dayjs.Dayjs | undefined;
    endTradeDay?: dayjs.Dayjs | undefined;

    constructor(data?: IGetWeeklyStatisticsRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tradingAccountId = _data["tradingAccountId"];
            this.startTradeDay = _data["startTradeDay"] ? dayjs(_data["startTradeDay"].toString()) : <any>undefined;
            this.endTradeDay = _data["endTradeDay"] ? dayjs(_data["endTradeDay"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): GetWeeklyStatisticsRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetWeeklyStatisticsRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tradingAccountId"] = this.tradingAccountId;
        data["startTradeDay"] = this.startTradeDay ? this.startTradeDay.toISOString() : <any>undefined;
        data["endTradeDay"] = this.endTradeDay ? this.endTradeDay.toISOString() : <any>undefined;
        return data;
    }
}

export interface IGetWeeklyStatisticsRequest {
    tradingAccountId: number;
    startTradeDay?: dayjs.Dayjs | undefined;
    endTradeDay?: dayjs.Dayjs | undefined;
}

export class GetDailyStatisticsRequest implements IGetDailyStatisticsRequest {
    tradingAccountId!: number;
    startTradeDay?: dayjs.Dayjs | undefined;
    endTradeDay?: dayjs.Dayjs | undefined;

    constructor(data?: IGetDailyStatisticsRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tradingAccountId = _data["tradingAccountId"];
            this.startTradeDay = _data["startTradeDay"] ? dayjs(_data["startTradeDay"].toString()) : <any>undefined;
            this.endTradeDay = _data["endTradeDay"] ? dayjs(_data["endTradeDay"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): GetDailyStatisticsRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetDailyStatisticsRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tradingAccountId"] = this.tradingAccountId;
        data["startTradeDay"] = this.startTradeDay ? this.startTradeDay.toISOString() : <any>undefined;
        data["endTradeDay"] = this.endTradeDay ? this.endTradeDay.toISOString() : <any>undefined;
        return data;
    }
}

export interface IGetDailyStatisticsRequest {
    tradingAccountId: number;
    startTradeDay?: dayjs.Dayjs | undefined;
    endTradeDay?: dayjs.Dayjs | undefined;
}

export class ProfitFactorData implements IProfitFactorData {
    totalProfit!: number;
    totalLoss!: number;

    constructor(data?: IProfitFactorData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalProfit = _data["totalProfit"];
            this.totalLoss = _data["totalLoss"];
        }
    }

    static fromJS(data: any): ProfitFactorData {
        data = typeof data === 'object' ? data : {};
        let result = new ProfitFactorData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalProfit"] = this.totalProfit;
        data["totalLoss"] = this.totalLoss;
        return data;
    }
}

export interface IProfitFactorData {
    totalProfit: number;
    totalLoss: number;
}

export class GetLifetimeStatisticsRequest implements IGetLifetimeStatisticsRequest {
    tradingAccountId!: number;

    constructor(data?: IGetLifetimeStatisticsRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tradingAccountId = _data["tradingAccountId"];
        }
    }

    static fromJS(data: any): GetLifetimeStatisticsRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetLifetimeStatisticsRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tradingAccountId"] = this.tradingAccountId;
        return data;
    }
}

export interface IGetLifetimeStatisticsRequest {
    tradingAccountId: number;
}

export class TradeSummary implements ITradeSummary {
    id!: number;
    symbolId!: string;
    positionSize!: number;
    profitAndLoss?: number | undefined;
    fees?: number | undefined;
    entryPrice!: number;
    exitPrice?: number | undefined;
    tradeDay!: dayjs.Dayjs;
    createdAt!: dayjs.Dayjs;
    enteredAt!: dayjs.Dayjs;

    constructor(data?: ITradeSummary) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.symbolId = _data["symbolId"];
            this.positionSize = _data["positionSize"];
            this.profitAndLoss = _data["profitAndLoss"];
            this.fees = _data["fees"];
            this.entryPrice = _data["entryPrice"];
            this.exitPrice = _data["exitPrice"];
            this.tradeDay = _data["tradeDay"] ? dayjs(_data["tradeDay"].toString()) : <any>undefined;
            this.createdAt = _data["createdAt"] ? dayjs(_data["createdAt"].toString()) : <any>undefined;
            this.enteredAt = _data["enteredAt"] ? dayjs(_data["enteredAt"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): TradeSummary {
        data = typeof data === 'object' ? data : {};
        let result = new TradeSummary();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["symbolId"] = this.symbolId;
        data["positionSize"] = this.positionSize;
        data["profitAndLoss"] = this.profitAndLoss;
        data["fees"] = this.fees;
        data["entryPrice"] = this.entryPrice;
        data["exitPrice"] = this.exitPrice;
        data["tradeDay"] = this.tradeDay ? this.tradeDay.toISOString() : <any>undefined;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : <any>undefined;
        data["enteredAt"] = this.enteredAt ? this.enteredAt.toISOString() : <any>undefined;
        return data;
    }
}

export interface ITradeSummary {
    id: number;
    symbolId: string;
    positionSize: number;
    profitAndLoss?: number | undefined;
    fees?: number | undefined;
    entryPrice: number;
    exitPrice?: number | undefined;
    tradeDay: dayjs.Dayjs;
    createdAt: dayjs.Dayjs;
    enteredAt: dayjs.Dayjs;
}

export class GetTradesForDayRequest implements IGetTradesForDayRequest {
    tradingAccountId!: number;
    tradeDay!: dayjs.Dayjs;

    constructor(data?: IGetTradesForDayRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tradingAccountId = _data["tradingAccountId"];
            this.tradeDay = _data["tradeDay"] ? dayjs(_data["tradeDay"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): GetTradesForDayRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetTradesForDayRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tradingAccountId"] = this.tradingAccountId;
        data["tradeDay"] = this.tradeDay ? this.tradeDay.toISOString() : <any>undefined;
        return data;
    }
}

export interface IGetTradesForDayRequest {
    tradingAccountId: number;
    tradeDay: dayjs.Dayjs;
}

export class AverageWinLossData implements IAverageWinLossData {
    averageWin!: number;
    averageLoss!: number;

    constructor(data?: IAverageWinLossData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.averageWin = _data["averageWin"];
            this.averageLoss = _data["averageLoss"];
        }
    }

    static fromJS(data: any): AverageWinLossData {
        data = typeof data === 'object' ? data : {};
        let result = new AverageWinLossData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["averageWin"] = this.averageWin;
        data["averageLoss"] = this.averageLoss;
        return data;
    }
}

export interface IAverageWinLossData {
    averageWin: number;
    averageLoss: number;
}

export class SetAccountSharingRequest implements ISetAccountSharingRequest {
    tradingAccountId!: number;
    sharing!: boolean;

    constructor(data?: ISetAccountSharingRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tradingAccountId = _data["tradingAccountId"];
            this.sharing = _data["sharing"];
        }
    }

    static fromJS(data: any): SetAccountSharingRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SetAccountSharingRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tradingAccountId"] = this.tradingAccountId;
        data["sharing"] = this.sharing;
        return data;
    }
}

export interface ISetAccountSharingRequest {
    tradingAccountId: number;
    sharing: boolean;
}

export class StudyTemplateModel implements IStudyTemplateModel {
    id!: number;
    userId!: number;
    name!: string;
    content!: string;

    constructor(data?: IStudyTemplateModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.userId = _data["userId"];
            this.name = _data["name"];
            this.content = _data["content"];
        }
    }

    static fromJS(data: any): StudyTemplateModel {
        data = typeof data === 'object' ? data : {};
        let result = new StudyTemplateModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["userId"] = this.userId;
        data["name"] = this.name;
        data["content"] = this.content;
        return data;
    }
}

export interface IStudyTemplateModel {
    id: number;
    userId: number;
    name: string;
    content: string;
}

export class RiskSymbolBlockModel implements IRiskSymbolBlockModel {
    id!: number;
    symbolId!: string;
    accountId!: number;

    constructor(data?: IRiskSymbolBlockModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.symbolId = _data["symbolId"];
            this.accountId = _data["accountId"];
        }
    }

    static fromJS(data: any): RiskSymbolBlockModel {
        data = typeof data === 'object' ? data : {};
        let result = new RiskSymbolBlockModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["symbolId"] = this.symbolId;
        data["accountId"] = this.accountId;
        return data;
    }
}

export interface IRiskSymbolBlockModel {
    id: number;
    symbolId: string;
    accountId: number;
}

export class SetRiskSymbolBlocksResult implements ISetRiskSymbolBlocksResult {
    success!: boolean;
    errorMessage?: string | undefined;

    constructor(data?: ISetRiskSymbolBlocksResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.success = _data["success"];
            this.errorMessage = _data["errorMessage"];
        }
    }

    static fromJS(data: any): SetRiskSymbolBlocksResult {
        data = typeof data === 'object' ? data : {};
        let result = new SetRiskSymbolBlocksResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        data["errorMessage"] = this.errorMessage;
        return data;
    }
}

export interface ISetRiskSymbolBlocksResult {
    success: boolean;
    errorMessage?: string | undefined;
}

export class SetRiskSymbolBlocksRequest implements ISetRiskSymbolBlocksRequest {
    accountId!: number;
    symbolBlocks!: string[];

    constructor(data?: ISetRiskSymbolBlocksRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.symbolBlocks = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accountId = _data["accountId"];
            if (Array.isArray(_data["symbolBlocks"])) {
                this.symbolBlocks = [] as any;
                for (let item of _data["symbolBlocks"])
                    this.symbolBlocks!.push(item);
            }
        }
    }

    static fromJS(data: any): SetRiskSymbolBlocksRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SetRiskSymbolBlocksRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accountId"] = this.accountId;
        if (Array.isArray(this.symbolBlocks)) {
            data["symbolBlocks"] = [];
            for (let item of this.symbolBlocks)
                data["symbolBlocks"].push(item);
        }
        return data;
    }
}

export interface ISetRiskSymbolBlocksRequest {
    accountId: number;
    symbolBlocks: string[];
}

export class AddRiskSymbolBlockResult implements IAddRiskSymbolBlockResult {
    success!: boolean;
    errorMessage?: string | undefined;

    constructor(data?: IAddRiskSymbolBlockResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.success = _data["success"];
            this.errorMessage = _data["errorMessage"];
        }
    }

    static fromJS(data: any): AddRiskSymbolBlockResult {
        data = typeof data === 'object' ? data : {};
        let result = new AddRiskSymbolBlockResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        data["errorMessage"] = this.errorMessage;
        return data;
    }
}

export interface IAddRiskSymbolBlockResult {
    success: boolean;
    errorMessage?: string | undefined;
}

export class AddRiskSymbolBlockRequest implements IAddRiskSymbolBlockRequest {
    accountId!: number;
    symbolId!: string;

    constructor(data?: IAddRiskSymbolBlockRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accountId = _data["accountId"];
            this.symbolId = _data["symbolId"];
        }
    }

    static fromJS(data: any): AddRiskSymbolBlockRequest {
        data = typeof data === 'object' ? data : {};
        let result = new AddRiskSymbolBlockRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accountId"] = this.accountId;
        data["symbolId"] = this.symbolId;
        return data;
    }
}

export interface IAddRiskSymbolBlockRequest {
    accountId: number;
    symbolId: string;
}

export class RemoveRiskSymbolBlockResult implements IRemoveRiskSymbolBlockResult {
    success!: boolean;
    errorMessage?: string | undefined;

    constructor(data?: IRemoveRiskSymbolBlockResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.success = _data["success"];
            this.errorMessage = _data["errorMessage"];
        }
    }

    static fromJS(data: any): RemoveRiskSymbolBlockResult {
        data = typeof data === 'object' ? data : {};
        let result = new RemoveRiskSymbolBlockResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        data["errorMessage"] = this.errorMessage;
        return data;
    }
}

export interface IRemoveRiskSymbolBlockResult {
    success: boolean;
    errorMessage?: string | undefined;
}

export class RemoveRiskSymbolBlockRequest implements IRemoveRiskSymbolBlockRequest {
    accountId!: number;
    symbolId!: string;

    constructor(data?: IRemoveRiskSymbolBlockRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accountId = _data["accountId"];
            this.symbolId = _data["symbolId"];
        }
    }

    static fromJS(data: any): RemoveRiskSymbolBlockRequest {
        data = typeof data === 'object' ? data : {};
        let result = new RemoveRiskSymbolBlockRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accountId"] = this.accountId;
        data["symbolId"] = this.symbolId;
        return data;
    }
}

export interface IRemoveRiskSymbolBlockRequest {
    accountId: number;
    symbolId: string;
}

export class SetTradeClockResponse implements ISetTradeClockResponse {
    errorCode!: TradeClockErrorCode;
    success!: boolean;
    message?: string | undefined;

    constructor(data?: ISetTradeClockResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.errorCode = _data["errorCode"];
            this.success = _data["success"];
            this.message = _data["message"];
        }
    }

    static fromJS(data: any): SetTradeClockResponse {
        data = typeof data === 'object' ? data : {};
        let result = new SetTradeClockResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["errorCode"] = this.errorCode;
        data["success"] = this.success;
        data["message"] = this.message;
        return data;
    }
}

export interface ISetTradeClockResponse {
    errorCode: TradeClockErrorCode;
    success: boolean;
    message?: string | undefined;
}

/** 0 = Success 1 = DurationTooShort 2 = DurationTooLong 3 = InvalidTradingAccount 4 = NoActiveOrdersOrPositions 5 = Error */
export enum TradeClockErrorCode {
    Success = 0,
    DurationTooShort = 1,
    DurationTooLong = 2,
    InvalidTradingAccount = 3,
    NoActiveOrdersOrPositions = 4,
    Error = 5,
}

export class SetTradeClockRequest implements ISetTradeClockRequest {
    tradingAccountId!: number;
    /** The duration in seconds for the trade clock. */
    duration!: number;

    constructor(data?: ISetTradeClockRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tradingAccountId = _data["tradingAccountId"];
            this.duration = _data["duration"];
        }
    }

    static fromJS(data: any): SetTradeClockRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SetTradeClockRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tradingAccountId"] = this.tradingAccountId;
        data["duration"] = this.duration;
        return data;
    }
}

export interface ISetTradeClockRequest {
    tradingAccountId: number;
    /** The duration in seconds for the trade clock. */
    duration: number;
}

export class TradeModel implements ITradeModel {
    id!: number;
    symbolId!: string;
    contractId!: string;
    accountId!: number;
    createdAt!: dayjs.Dayjs;
    tradeDay!: dayjs.Dayjs;
    exitedAt!: dayjs.Dayjs;
    entryPrice!: number;
    exitPrice!: number;
    fees!: number;
    pnL!: number;
    positionSize!: number;
    voided!: boolean;
    tradeDuration?: dayjs.Dayjs | undefined;
    tradeDurationDisplay!: string;

    constructor(data?: ITradeModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.symbolId = _data["symbolId"];
            this.contractId = _data["contractId"];
            this.accountId = _data["accountId"];
            this.createdAt = _data["createdAt"] ? dayjs(_data["createdAt"].toString()) : <any>undefined;
            this.tradeDay = _data["tradeDay"] ? dayjs(_data["tradeDay"].toString()) : <any>undefined;
            this.exitedAt = _data["exitedAt"] ? dayjs(_data["exitedAt"].toString()) : <any>undefined;
            this.entryPrice = _data["entryPrice"];
            this.exitPrice = _data["exitPrice"];
            this.fees = _data["fees"];
            this.pnL = _data["pnL"];
            this.positionSize = _data["positionSize"];
            this.voided = _data["voided"];
            this.tradeDuration = _data["tradeDuration"] ? dayjs(_data["tradeDuration"].toString()) : <any>undefined;
            this.tradeDurationDisplay = _data["tradeDurationDisplay"];
        }
    }

    static fromJS(data: any): TradeModel {
        data = typeof data === 'object' ? data : {};
        let result = new TradeModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["symbolId"] = this.symbolId;
        data["contractId"] = this.contractId;
        data["accountId"] = this.accountId;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : <any>undefined;
        data["tradeDay"] = this.tradeDay ? this.tradeDay.toISOString() : <any>undefined;
        data["exitedAt"] = this.exitedAt ? this.exitedAt.toISOString() : <any>undefined;
        data["entryPrice"] = this.entryPrice;
        data["exitPrice"] = this.exitPrice;
        data["fees"] = this.fees;
        data["pnL"] = this.pnL;
        data["positionSize"] = this.positionSize;
        data["voided"] = this.voided;
        data["tradeDuration"] = this.tradeDuration ? this.tradeDuration.format('d.hh:mm:ss.SSS') : <any>undefined;
        data["tradeDurationDisplay"] = this.tradeDurationDisplay;
        return data;
    }
}

export interface ITradeModel {
    id: number;
    symbolId: string;
    contractId: string;
    accountId: number;
    createdAt: dayjs.Dayjs;
    tradeDay: dayjs.Dayjs;
    exitedAt: dayjs.Dayjs;
    entryPrice: number;
    exitPrice: number;
    fees: number;
    pnL: number;
    positionSize: number;
    voided: boolean;
    tradeDuration?: dayjs.Dayjs | undefined;
    tradeDurationDisplay: string;
}

export class TradesInRangeRequest implements ITradesInRangeRequest {
    tradingAccountId!: number;
    start?: dayjs.Dayjs | undefined;
    end?: dayjs.Dayjs | undefined;

    constructor(data?: ITradesInRangeRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tradingAccountId = _data["tradingAccountId"];
            this.start = _data["start"] ? dayjs(_data["start"].toString()) : <any>undefined;
            this.end = _data["end"] ? dayjs(_data["end"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): TradesInRangeRequest {
        data = typeof data === 'object' ? data : {};
        let result = new TradesInRangeRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tradingAccountId"] = this.tradingAccountId;
        data["start"] = this.start ? this.start.toISOString() : <any>undefined;
        data["end"] = this.end ? this.end.toISOString() : <any>undefined;
        return data;
    }
}

export interface ITradesInRangeRequest {
    tradingAccountId: number;
    start?: dayjs.Dayjs | undefined;
    end?: dayjs.Dayjs | undefined;
}

export class TradeExportModel implements ITradeExportModel {
    id!: number;
    contractName!: string;
    enteredAt!: dayjs.Dayjs;
    exitedAt!: dayjs.Dayjs;
    entryPrice!: number;
    exitPrice!: number;
    fees!: number;
    pnL!: number;
    size!: number;
    type!: TradeType;
    tradeDay!: dayjs.Dayjs;
    tradeDuration!: dayjs.Dayjs;

    constructor(data?: ITradeExportModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.contractName = _data["contractName"];
            this.enteredAt = _data["enteredAt"] ? dayjs(_data["enteredAt"].toString()) : <any>undefined;
            this.exitedAt = _data["exitedAt"] ? dayjs(_data["exitedAt"].toString()) : <any>undefined;
            this.entryPrice = _data["entryPrice"];
            this.exitPrice = _data["exitPrice"];
            this.fees = _data["fees"];
            this.pnL = _data["pnL"];
            this.size = _data["size"];
            this.type = _data["type"];
            this.tradeDay = _data["tradeDay"] ? dayjs(_data["tradeDay"].toString()) : <any>undefined;
            this.tradeDuration = _data["tradeDuration"] ? dayjs(_data["tradeDuration"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): TradeExportModel {
        data = typeof data === 'object' ? data : {};
        let result = new TradeExportModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["contractName"] = this.contractName;
        data["enteredAt"] = this.enteredAt ? this.enteredAt.toISOString() : <any>undefined;
        data["exitedAt"] = this.exitedAt ? this.exitedAt.toISOString() : <any>undefined;
        data["entryPrice"] = this.entryPrice;
        data["exitPrice"] = this.exitPrice;
        data["fees"] = this.fees;
        data["pnL"] = this.pnL;
        data["size"] = this.size;
        data["type"] = this.type;
        data["tradeDay"] = this.tradeDay ? this.tradeDay.toISOString() : <any>undefined;
        data["tradeDuration"] = this.tradeDuration ? this.tradeDuration.format('d.hh:mm:ss.SSS') : <any>undefined;
        return data;
    }
}

export interface ITradeExportModel {
    id: number;
    contractName: string;
    enteredAt: dayjs.Dayjs;
    exitedAt: dayjs.Dayjs;
    entryPrice: number;
    exitPrice: number;
    fees: number;
    pnL: number;
    size: number;
    type: TradeType;
    tradeDay: dayjs.Dayjs;
    tradeDuration: dayjs.Dayjs;
}

/** 0 = Long 1 = Short */
export enum TradeType {
    Long = 0,
    Short = 1,
}

export class UserExportTradeRequest implements IUserExportTradeRequest {
    tradingAccountId!: number;
    start!: dayjs.Dayjs;
    end!: dayjs.Dayjs;
    timeZone?: string | undefined;

    constructor(data?: IUserExportTradeRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tradingAccountId = _data["tradingAccountId"];
            this.start = _data["start"] ? dayjs(_data["start"].toString()) : <any>undefined;
            this.end = _data["end"] ? dayjs(_data["end"].toString()) : <any>undefined;
            this.timeZone = _data["timeZone"];
        }
    }

    static fromJS(data: any): UserExportTradeRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UserExportTradeRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tradingAccountId"] = this.tradingAccountId;
        data["start"] = this.start ? this.start.toISOString() : <any>undefined;
        data["end"] = this.end ? this.end.toISOString() : <any>undefined;
        data["timeZone"] = this.timeZone;
        return data;
    }
}

export interface IUserExportTradeRequest {
    tradingAccountId: number;
    start: dayjs.Dayjs;
    end: dayjs.Dayjs;
    timeZone?: string | undefined;
}

export class SetTradeLimitsResult implements ISetTradeLimitsResult {
    success!: boolean;
    message!: string;

    constructor(data?: ISetTradeLimitsResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.success = _data["success"];
            this.message = _data["message"];
        }
    }

    static fromJS(data: any): SetTradeLimitsResult {
        data = typeof data === 'object' ? data : {};
        let result = new SetTradeLimitsResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        data["message"] = this.message;
        return data;
    }
}

export interface ISetTradeLimitsResult {
    success: boolean;
    message: string;
}

export class TradeLimitsModel implements ITradeLimitsModel {
    tradingAccountId!: number;
    dailyTradeLimit?: number | undefined;
    weeklyTradeLimit?: number | undefined;

    constructor(data?: ITradeLimitsModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tradingAccountId = _data["tradingAccountId"];
            this.dailyTradeLimit = _data["dailyTradeLimit"];
            this.weeklyTradeLimit = _data["weeklyTradeLimit"];
        }
    }

    static fromJS(data: any): TradeLimitsModel {
        data = typeof data === 'object' ? data : {};
        let result = new TradeLimitsModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tradingAccountId"] = this.tradingAccountId;
        data["dailyTradeLimit"] = this.dailyTradeLimit;
        data["weeklyTradeLimit"] = this.weeklyTradeLimit;
        return data;
    }
}

export interface ITradeLimitsModel {
    tradingAccountId: number;
    dailyTradeLimit?: number | undefined;
    weeklyTradeLimit?: number | undefined;
}

/** 0 = Success 1 = AccountNotFound 2 = NameTooLong 3 = NameAlreadyUsed 4 = DoesNotOwnAccount */
export enum SetAccountNicknameResultCode {
    Success = 0,
    AccountNotFound = 1,
    NameTooLong = 2,
    NameAlreadyUsed = 3,
    DoesNotOwnAccount = 4,
}

export class SetAccountNicknameRequest implements ISetAccountNicknameRequest {
    accountId!: number;
    nickname?: string | undefined;

    constructor(data?: ISetAccountNicknameRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accountId = _data["accountId"];
            this.nickname = _data["nickname"];
        }
    }

    static fromJS(data: any): SetAccountNicknameRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SetAccountNicknameRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accountId"] = this.accountId;
        data["nickname"] = this.nickname;
        return data;
    }
}

export interface ISetAccountNicknameRequest {
    accountId: number;
    nickname?: string | undefined;
}

/** 0 = Success 1 = AccountNotFound 2 = AccountClosed 3 = InvalidDrawDownLimit 4 = AccountIsFollower 5 = InvalidDailyLossLimit */
export enum TradingAccountResult {
    Success = 0,
    AccountNotFound = 1,
    AccountClosed = 2,
    InvalidDrawDownLimit = 3,
    AccountIsFollower = 4,
    InvalidDailyLossLimit = 5,
}

export class PersonalDailyLimitsResponse implements IPersonalDailyLimitsResponse {
    success!: boolean;
    errorMessage?: string | undefined;

    constructor(data?: IPersonalDailyLimitsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.success = _data["success"];
            this.errorMessage = _data["errorMessage"];
        }
    }

    static fromJS(data: any): PersonalDailyLimitsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new PersonalDailyLimitsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        data["errorMessage"] = this.errorMessage;
        return data;
    }
}

export interface IPersonalDailyLimitsResponse {
    success: boolean;
    errorMessage?: string | undefined;
}

export class PersonalDailyLimitsRequest implements IPersonalDailyLimitsRequest {
    tradingAccountId!: number;
    personalDailyLossLimit?: number | undefined;
    personalDailyProfitTarget?: number | undefined;
    personalDailyLossLimitAction!: PersonalDailyAction;
    personalDailyProfitTargetAction!: PersonalDailyAction;
    personalDailyLossLimitTrailing!: boolean;
    pdllTrailingType!: PersonalDailyLossLimitTrailingType;

    constructor(data?: IPersonalDailyLimitsRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tradingAccountId = _data["tradingAccountId"];
            this.personalDailyLossLimit = _data["personalDailyLossLimit"];
            this.personalDailyProfitTarget = _data["personalDailyProfitTarget"];
            this.personalDailyLossLimitAction = _data["personalDailyLossLimitAction"];
            this.personalDailyProfitTargetAction = _data["personalDailyProfitTargetAction"];
            this.personalDailyLossLimitTrailing = _data["personalDailyLossLimitTrailing"];
            this.pdllTrailingType = _data["pdllTrailingType"];
        }
    }

    static fromJS(data: any): PersonalDailyLimitsRequest {
        data = typeof data === 'object' ? data : {};
        let result = new PersonalDailyLimitsRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tradingAccountId"] = this.tradingAccountId;
        data["personalDailyLossLimit"] = this.personalDailyLossLimit;
        data["personalDailyProfitTarget"] = this.personalDailyProfitTarget;
        data["personalDailyLossLimitAction"] = this.personalDailyLossLimitAction;
        data["personalDailyProfitTargetAction"] = this.personalDailyProfitTargetAction;
        data["personalDailyLossLimitTrailing"] = this.personalDailyLossLimitTrailing;
        data["pdllTrailingType"] = this.pdllTrailingType;
        return data;
    }
}

export interface IPersonalDailyLimitsRequest {
    tradingAccountId: number;
    personalDailyLossLimit?: number | undefined;
    personalDailyProfitTarget?: number | undefined;
    personalDailyLossLimitAction: PersonalDailyAction;
    personalDailyProfitTargetAction: PersonalDailyAction;
    personalDailyLossLimitTrailing: boolean;
    pdllTrailingType: PersonalDailyLossLimitTrailingType;
}

export class FollowTraderResponse implements IFollowTraderResponse {
    success!: boolean;
    errorMessage?: string | undefined;

    constructor(data?: IFollowTraderResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.success = _data["success"];
            this.errorMessage = _data["errorMessage"];
        }
    }

    static fromJS(data: any): FollowTraderResponse {
        data = typeof data === 'object' ? data : {};
        let result = new FollowTraderResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        data["errorMessage"] = this.errorMessage;
        return data;
    }
}

export interface IFollowTraderResponse {
    success: boolean;
    errorMessage?: string | undefined;
}

export class FollowTraderRequest implements IFollowTraderRequest {
    leaderId!: number;
    tradingAccountId!: number;
    ratio!: number;

    constructor(data?: IFollowTraderRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.leaderId = _data["leaderId"];
            this.tradingAccountId = _data["tradingAccountId"];
            this.ratio = _data["ratio"];
        }
    }

    static fromJS(data: any): FollowTraderRequest {
        data = typeof data === 'object' ? data : {};
        let result = new FollowTraderRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["leaderId"] = this.leaderId;
        data["tradingAccountId"] = this.tradingAccountId;
        data["ratio"] = this.ratio;
        return data;
    }
}

export interface IFollowTraderRequest {
    leaderId: number;
    tradingAccountId: number;
    ratio: number;
}

export class FollowTraderEntry implements IFollowTraderEntry {
    tradingAccountId!: number;
    tradingAccountName!: string;
    leaderAccountId!: number;
    leaderAccountName!: string;
    ratio!: number;

    constructor(data?: IFollowTraderEntry) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tradingAccountId = _data["tradingAccountId"];
            this.tradingAccountName = _data["tradingAccountName"];
            this.leaderAccountId = _data["leaderAccountId"];
            this.leaderAccountName = _data["leaderAccountName"];
            this.ratio = _data["ratio"];
        }
    }

    static fromJS(data: any): FollowTraderEntry {
        data = typeof data === 'object' ? data : {};
        let result = new FollowTraderEntry();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tradingAccountId"] = this.tradingAccountId;
        data["tradingAccountName"] = this.tradingAccountName;
        data["leaderAccountId"] = this.leaderAccountId;
        data["leaderAccountName"] = this.leaderAccountName;
        data["ratio"] = this.ratio;
        return data;
    }
}

export interface IFollowTraderEntry {
    tradingAccountId: number;
    tradingAccountName: string;
    leaderAccountId: number;
    leaderAccountName: string;
    ratio: number;
}

export class TradingAccountModelBase implements ITradingAccountModelBase {
    accountName!: string;
    nickname?: string | undefined;
    userId!: number;
    startingBalance?: number | undefined;
    balance!: number;
    status?: TradingAccountStatus | undefined;
    lockoutExpiration?: dayjs.Dayjs | undefined;
    lockoutReason?: string | undefined;
    dailyTradeLimit?: number | undefined;
    weeklyTradeLimit?: number | undefined;
    marketDataLevel!: MarketDataLevel;
    accountId!: number;
    winRate!: number;
    profitAndLoss?: number | undefined;
    startDate!: dayjs.Dayjs;
    closedDate?: dayjs.Dayjs | undefined;
    dailyLoss?: number | undefined;
    overrideDailyLossLimit?: number | undefined;
    maximumLoss?: number | undefined;
    drawDownLimit!: number;
    combineDailyLoss!: number;
    maxPositions!: number;
    type!: TradingAccountType;
    startOfDayBalance!: number;
    combineName!: string;
    platformId!: PlatformId;
    platformAccountId?: string | undefined;
    platformUserName?: string | undefined;
    maxMargin?: number | undefined;
    minimumMll?: number | undefined;
    isSharing!: boolean;

    constructor(data?: ITradingAccountModelBase) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accountName = _data["accountName"];
            this.nickname = _data["nickname"];
            this.userId = _data["userId"];
            this.startingBalance = _data["startingBalance"];
            this.balance = _data["balance"];
            this.status = _data["status"];
            this.lockoutExpiration = _data["lockoutExpiration"] ? dayjs(_data["lockoutExpiration"].toString()) : <any>undefined;
            this.lockoutReason = _data["lockoutReason"];
            this.dailyTradeLimit = _data["dailyTradeLimit"];
            this.weeklyTradeLimit = _data["weeklyTradeLimit"];
            this.marketDataLevel = _data["marketDataLevel"];
            this.accountId = _data["accountId"];
            this.winRate = _data["winRate"];
            this.profitAndLoss = _data["profitAndLoss"];
            this.startDate = _data["startDate"] ? dayjs(_data["startDate"].toString()) : <any>undefined;
            this.closedDate = _data["closedDate"] ? dayjs(_data["closedDate"].toString()) : <any>undefined;
            this.dailyLoss = _data["dailyLoss"];
            this.overrideDailyLossLimit = _data["overrideDailyLossLimit"];
            this.maximumLoss = _data["maximumLoss"];
            this.drawDownLimit = _data["drawDownLimit"];
            this.combineDailyLoss = _data["combineDailyLoss"];
            this.maxPositions = _data["maxPositions"];
            this.type = _data["type"];
            this.startOfDayBalance = _data["startOfDayBalance"];
            this.combineName = _data["combineName"];
            this.platformId = _data["platformId"];
            this.platformAccountId = _data["platformAccountId"];
            this.platformUserName = _data["platformUserName"];
            this.maxMargin = _data["maxMargin"];
            this.minimumMll = _data["minimumMll"];
            this.isSharing = _data["isSharing"];
        }
    }

    static fromJS(data: any): TradingAccountModelBase {
        data = typeof data === 'object' ? data : {};
        let result = new TradingAccountModelBase();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accountName"] = this.accountName;
        data["nickname"] = this.nickname;
        data["userId"] = this.userId;
        data["startingBalance"] = this.startingBalance;
        data["balance"] = this.balance;
        data["status"] = this.status;
        data["lockoutExpiration"] = this.lockoutExpiration ? this.lockoutExpiration.toISOString() : <any>undefined;
        data["lockoutReason"] = this.lockoutReason;
        data["dailyTradeLimit"] = this.dailyTradeLimit;
        data["weeklyTradeLimit"] = this.weeklyTradeLimit;
        data["marketDataLevel"] = this.marketDataLevel;
        data["accountId"] = this.accountId;
        data["winRate"] = this.winRate;
        data["profitAndLoss"] = this.profitAndLoss;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["closedDate"] = this.closedDate ? this.closedDate.toISOString() : <any>undefined;
        data["dailyLoss"] = this.dailyLoss;
        data["overrideDailyLossLimit"] = this.overrideDailyLossLimit;
        data["maximumLoss"] = this.maximumLoss;
        data["drawDownLimit"] = this.drawDownLimit;
        data["combineDailyLoss"] = this.combineDailyLoss;
        data["maxPositions"] = this.maxPositions;
        data["type"] = this.type;
        data["startOfDayBalance"] = this.startOfDayBalance;
        data["combineName"] = this.combineName;
        data["platformId"] = this.platformId;
        data["platformAccountId"] = this.platformAccountId;
        data["platformUserName"] = this.platformUserName;
        data["maxMargin"] = this.maxMargin;
        data["minimumMll"] = this.minimumMll;
        data["isSharing"] = this.isSharing;
        return data;
    }
}

export interface ITradingAccountModelBase {
    accountName: string;
    nickname?: string | undefined;
    userId: number;
    startingBalance?: number | undefined;
    balance: number;
    status?: TradingAccountStatus | undefined;
    lockoutExpiration?: dayjs.Dayjs | undefined;
    lockoutReason?: string | undefined;
    dailyTradeLimit?: number | undefined;
    weeklyTradeLimit?: number | undefined;
    marketDataLevel: MarketDataLevel;
    accountId: number;
    winRate: number;
    profitAndLoss?: number | undefined;
    startDate: dayjs.Dayjs;
    closedDate?: dayjs.Dayjs | undefined;
    dailyLoss?: number | undefined;
    overrideDailyLossLimit?: number | undefined;
    maximumLoss?: number | undefined;
    drawDownLimit: number;
    combineDailyLoss: number;
    maxPositions: number;
    type: TradingAccountType;
    startOfDayBalance: number;
    combineName: string;
    platformId: PlatformId;
    platformAccountId?: string | undefined;
    platformUserName?: string | undefined;
    maxMargin?: number | undefined;
    minimumMll?: number | undefined;
    isSharing: boolean;
}

export class TradingAccountModel extends TradingAccountModelBase implements ITradingAccountModel {
    realizedDayPnl?: number | undefined;
    updatedAt!: dayjs.Dayjs;
    personalDailyLossLimit?: number | undefined;
    personalDailyLossLimitAction!: PersonalDailyAction;
    personalDailyLossLimitTrailing!: boolean;
    pdllTrailingType!: PersonalDailyLossLimitTrailingType;
    pdllTrailingBalance?: number | undefined;
    pdllTrailingStartingBalance?: number | undefined;
    personalDailyProfitTarget?: number | undefined;
    personalDailyProfitTargetAction!: PersonalDailyAction;
    totalProfit!: number;
    totalLoss!: number;
    totalTrades!: number;
    dailyTrades!: number;
    isFollower!: boolean;
    isLeader!: boolean;
    openPnl!: number;
    highestBalance!: number;
    highestUnrealizedBalance!: number;
    highestRealizedBalance!: number;
    ineligible!: boolean;
    templateId?: number | undefined;
    currentDayTrades!: number;
    currentWeekTrades!: number;

    constructor(data?: ITradingAccountModel) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.realizedDayPnl = _data["realizedDayPnl"];
            this.updatedAt = _data["updatedAt"] ? dayjs(_data["updatedAt"].toString()) : <any>undefined;
            this.personalDailyLossLimit = _data["personalDailyLossLimit"];
            this.personalDailyLossLimitAction = _data["personalDailyLossLimitAction"];
            this.personalDailyLossLimitTrailing = _data["personalDailyLossLimitTrailing"];
            this.pdllTrailingType = _data["pdllTrailingType"];
            this.pdllTrailingBalance = _data["pdllTrailingBalance"];
            this.pdllTrailingStartingBalance = _data["pdllTrailingStartingBalance"];
            this.personalDailyProfitTarget = _data["personalDailyProfitTarget"];
            this.personalDailyProfitTargetAction = _data["personalDailyProfitTargetAction"];
            this.totalProfit = _data["totalProfit"];
            this.totalLoss = _data["totalLoss"];
            this.totalTrades = _data["totalTrades"];
            this.dailyTrades = _data["dailyTrades"];
            this.isFollower = _data["isFollower"];
            this.isLeader = _data["isLeader"];
            this.openPnl = _data["openPnl"];
            this.highestBalance = _data["highestBalance"];
            this.highestUnrealizedBalance = _data["highestUnrealizedBalance"];
            this.highestRealizedBalance = _data["highestRealizedBalance"];
            this.ineligible = _data["ineligible"];
            this.templateId = _data["templateId"];
            this.currentDayTrades = _data["currentDayTrades"];
            this.currentWeekTrades = _data["currentWeekTrades"];
        }
    }

    static override fromJS(data: any): TradingAccountModel {
        data = typeof data === 'object' ? data : {};
        let result = new TradingAccountModel();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["realizedDayPnl"] = this.realizedDayPnl;
        data["updatedAt"] = this.updatedAt ? this.updatedAt.toISOString() : <any>undefined;
        data["personalDailyLossLimit"] = this.personalDailyLossLimit;
        data["personalDailyLossLimitAction"] = this.personalDailyLossLimitAction;
        data["personalDailyLossLimitTrailing"] = this.personalDailyLossLimitTrailing;
        data["pdllTrailingType"] = this.pdllTrailingType;
        data["pdllTrailingBalance"] = this.pdllTrailingBalance;
        data["pdllTrailingStartingBalance"] = this.pdllTrailingStartingBalance;
        data["personalDailyProfitTarget"] = this.personalDailyProfitTarget;
        data["personalDailyProfitTargetAction"] = this.personalDailyProfitTargetAction;
        data["totalProfit"] = this.totalProfit;
        data["totalLoss"] = this.totalLoss;
        data["totalTrades"] = this.totalTrades;
        data["dailyTrades"] = this.dailyTrades;
        data["isFollower"] = this.isFollower;
        data["isLeader"] = this.isLeader;
        data["openPnl"] = this.openPnl;
        data["highestBalance"] = this.highestBalance;
        data["highestUnrealizedBalance"] = this.highestUnrealizedBalance;
        data["highestRealizedBalance"] = this.highestRealizedBalance;
        data["ineligible"] = this.ineligible;
        data["templateId"] = this.templateId;
        data["currentDayTrades"] = this.currentDayTrades;
        data["currentWeekTrades"] = this.currentWeekTrades;
        super.toJSON(data);
        return data;
    }
}

export interface ITradingAccountModel extends ITradingAccountModelBase {
    realizedDayPnl?: number | undefined;
    updatedAt: dayjs.Dayjs;
    personalDailyLossLimit?: number | undefined;
    personalDailyLossLimitAction: PersonalDailyAction;
    personalDailyLossLimitTrailing: boolean;
    pdllTrailingType: PersonalDailyLossLimitTrailingType;
    pdllTrailingBalance?: number | undefined;
    pdllTrailingStartingBalance?: number | undefined;
    personalDailyProfitTarget?: number | undefined;
    personalDailyProfitTargetAction: PersonalDailyAction;
    totalProfit: number;
    totalLoss: number;
    totalTrades: number;
    dailyTrades: number;
    isFollower: boolean;
    isLeader: boolean;
    openPnl: number;
    highestBalance: number;
    highestUnrealizedBalance: number;
    highestRealizedBalance: number;
    ineligible: boolean;
    templateId?: number | undefined;
    currentDayTrades: number;
    currentWeekTrades: number;
}

/** 0 = Level1 1 = Level2 */
export enum MarketDataLevel {
    Level1 = 0,
    Level2 = 1,
}

export class TradingAccountStateLogModel implements ITradingAccountStateLogModel {
    timestamp!: dayjs.Dayjs;
    value?: number | undefined;
    type!: TradingAccountStateLogType;

    constructor(data?: ITradingAccountStateLogModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.timestamp = _data["timestamp"] ? dayjs(_data["timestamp"].toString()) : <any>undefined;
            this.value = _data["value"];
            this.type = _data["type"];
        }
    }

    static fromJS(data: any): TradingAccountStateLogModel {
        data = typeof data === 'object' ? data : {};
        let result = new TradingAccountStateLogModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["timestamp"] = this.timestamp ? this.timestamp.toISOString() : <any>undefined;
        data["value"] = this.value;
        data["type"] = this.type;
        return data;
    }
}

export interface ITradingAccountStateLogModel {
    timestamp: dayjs.Dayjs;
    value?: number | undefined;
    type: TradingAccountStateLogType;
}

/** 1 = HighestRealizedPnL 2 = HighestUnrealizedPnL */
export enum TradingAccountStateLogType {
    HighestRealizedPnL = 1,
    HighestUnrealizedPnL = 2,
}

export class TradingAccountStateLogRequest implements ITradingAccountStateLogRequest {
    tradingAccountId!: number;
    type?: TradingAccountStateLogType | undefined;
    startTime?: dayjs.Dayjs | undefined;
    endTime?: dayjs.Dayjs | undefined;

    constructor(data?: ITradingAccountStateLogRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tradingAccountId = _data["tradingAccountId"];
            this.type = _data["type"];
            this.startTime = _data["startTime"] ? dayjs(_data["startTime"].toString()) : <any>undefined;
            this.endTime = _data["endTime"] ? dayjs(_data["endTime"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): TradingAccountStateLogRequest {
        data = typeof data === 'object' ? data : {};
        let result = new TradingAccountStateLogRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tradingAccountId"] = this.tradingAccountId;
        data["type"] = this.type;
        data["startTime"] = this.startTime ? this.startTime.toISOString() : <any>undefined;
        data["endTime"] = this.endTime ? this.endTime.toISOString() : <any>undefined;
        return data;
    }
}

export interface ITradingAccountStateLogRequest {
    tradingAccountId: number;
    type?: TradingAccountStateLogType | undefined;
    startTime?: dayjs.Dayjs | undefined;
    endTime?: dayjs.Dayjs | undefined;
}

export class TradingRuleModel implements ITradingRuleModel {
    id!: TradingRuleType;
    name!: string;
    priority!: number;

    constructor(data?: ITradingRuleModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.priority = _data["priority"];
        }
    }

    static fromJS(data: any): TradingRuleModel {
        data = typeof data === 'object' ? data : {};
        let result = new TradingRuleModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["priority"] = this.priority;
        return data;
    }
}

export interface ITradingRuleModel {
    id: TradingRuleType;
    name: string;
    priority: number;
}

export class UserAgreementModel implements IUserAgreementModel {
    id!: number;
    title!: string;
    url!: string;
    customAcceptText?: string | undefined;
    isProfessional!: boolean;
    updatedAt!: dayjs.Dayjs;

    constructor(data?: IUserAgreementModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.title = _data["title"];
            this.url = _data["url"];
            this.customAcceptText = _data["customAcceptText"];
            this.isProfessional = _data["isProfessional"];
            this.updatedAt = _data["updatedAt"] ? dayjs(_data["updatedAt"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): UserAgreementModel {
        data = typeof data === 'object' ? data : {};
        let result = new UserAgreementModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["title"] = this.title;
        data["url"] = this.url;
        data["customAcceptText"] = this.customAcceptText;
        data["isProfessional"] = this.isProfessional;
        data["updatedAt"] = this.updatedAt ? this.updatedAt.toISOString() : <any>undefined;
        return data;
    }
}

export interface IUserAgreementModel {
    id: number;
    title: string;
    url: string;
    customAcceptText?: string | undefined;
    isProfessional: boolean;
    updatedAt: dayjs.Dayjs;
}

export class SignAgreementRequest implements ISignAgreementRequest {
    agreementIds!: number[];
    name!: string;
    streetAddress!: string;
    city!: string;
    state!: string;
    zipCode!: string;
    countryCode!: string;
    country!: string;

    constructor(data?: ISignAgreementRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.agreementIds = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["agreementIds"])) {
                this.agreementIds = [] as any;
                for (let item of _data["agreementIds"])
                    this.agreementIds!.push(item);
            }
            this.name = _data["name"];
            this.streetAddress = _data["streetAddress"];
            this.city = _data["city"];
            this.state = _data["state"];
            this.zipCode = _data["zipCode"];
            this.countryCode = _data["countryCode"];
            this.country = _data["country"];
        }
    }

    static fromJS(data: any): SignAgreementRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SignAgreementRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.agreementIds)) {
            data["agreementIds"] = [];
            for (let item of this.agreementIds)
                data["agreementIds"].push(item);
        }
        data["name"] = this.name;
        data["streetAddress"] = this.streetAddress;
        data["city"] = this.city;
        data["state"] = this.state;
        data["zipCode"] = this.zipCode;
        data["countryCode"] = this.countryCode;
        data["country"] = this.country;
        return data;
    }
}

export interface ISignAgreementRequest {
    agreementIds: number[];
    name: string;
    streetAddress: string;
    city: string;
    state: string;
    zipCode: string;
    countryCode: string;
    country: string;
}

export class UserModel implements IUserModel {
    userName!: string;
    email!: string;
    userId!: number;
    firstName!: string;
    lastName!: string;
    hasSignedAgreements!: boolean;
    createdAt!: dayjs.Dayjs;
    roles!: string[];

    constructor(data?: IUserModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.roles = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userName = _data["userName"];
            this.email = _data["email"];
            this.userId = _data["userId"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.hasSignedAgreements = _data["hasSignedAgreements"];
            this.createdAt = _data["createdAt"] ? dayjs(_data["createdAt"].toString()) : <any>undefined;
            if (Array.isArray(_data["roles"])) {
                this.roles = [] as any;
                for (let item of _data["roles"])
                    this.roles!.push(item);
            }
        }
    }

    static fromJS(data: any): UserModel {
        data = typeof data === 'object' ? data : {};
        let result = new UserModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userName"] = this.userName;
        data["email"] = this.email;
        data["userId"] = this.userId;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["hasSignedAgreements"] = this.hasSignedAgreements;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : <any>undefined;
        if (Array.isArray(this.roles)) {
            data["roles"] = [];
            for (let item of this.roles)
                data["roles"].push(item);
        }
        return data;
    }
}

export interface IUserModel {
    userName: string;
    email: string;
    userId: number;
    firstName: string;
    lastName: string;
    hasSignedAgreements: boolean;
    createdAt: dayjs.Dayjs;
    roles: string[];
}

/** Represents a response to a request for creating a new user API key. */
export class CreateUserApiKeyResponse implements ICreateUserApiKeyResponse {
    /** Indicates whether the API key creation was successful. */
    success!: boolean;
    /** Contains an error message if the API key creation failed. */
    errorMessage?: string | undefined;
    /** The newly created API key, if the creation was successful. */
    apiKey?: string | undefined;

    constructor(data?: ICreateUserApiKeyResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.success = _data["success"];
            this.errorMessage = _data["errorMessage"];
            this.apiKey = _data["apiKey"];
        }
    }

    static fromJS(data: any): CreateUserApiKeyResponse {
        data = typeof data === 'object' ? data : {};
        let result = new CreateUserApiKeyResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        data["errorMessage"] = this.errorMessage;
        data["apiKey"] = this.apiKey;
        return data;
    }
}

/** Represents a response to a request for creating a new user API key. */
export interface ICreateUserApiKeyResponse {
    /** Indicates whether the API key creation was successful. */
    success: boolean;
    /** Contains an error message if the API key creation failed. */
    errorMessage?: string | undefined;
    /** The newly created API key, if the creation was successful. */
    apiKey?: string | undefined;
}

/** Represents a response to a request for revoking an existing user API key. */
export class RevokeUserApiKeyResponse implements IRevokeUserApiKeyResponse {
    /** Indicates whether the API key revocation was successful. */
    success!: boolean;
    /** Contains an error message if the API key revocation failed. */
    errorMessage?: string | undefined;

    constructor(data?: IRevokeUserApiKeyResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.success = _data["success"];
            this.errorMessage = _data["errorMessage"];
        }
    }

    static fromJS(data: any): RevokeUserApiKeyResponse {
        data = typeof data === 'object' ? data : {};
        let result = new RevokeUserApiKeyResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        data["errorMessage"] = this.errorMessage;
        return data;
    }
}

/** Represents a response to a request for revoking an existing user API key. */
export interface IRevokeUserApiKeyResponse {
    /** Indicates whether the API key revocation was successful. */
    success: boolean;
    /** Contains an error message if the API key revocation failed. */
    errorMessage?: string | undefined;
}

/** Represents a request to revoke an existing user API key. */
export class RevokeUserApiKeyRequest implements IRevokeUserApiKeyRequest {
    /** The API key to be revoked. */
    apiKey!: string;

    constructor(data?: IRevokeUserApiKeyRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.apiKey = _data["apiKey"];
        }
    }

    static fromJS(data: any): RevokeUserApiKeyRequest {
        data = typeof data === 'object' ? data : {};
        let result = new RevokeUserApiKeyRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["apiKey"] = this.apiKey;
        return data;
    }
}

/** Represents a request to revoke an existing user API key. */
export interface IRevokeUserApiKeyRequest {
    /** The API key to be revoked. */
    apiKey: string;
}

export class UserApiKeyModel implements IUserApiKeyModel {
    key!: string;
    createdAt!: dayjs.Dayjs;
    lastUsedAt?: dayjs.Dayjs | undefined;

    constructor(data?: IUserApiKeyModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.key = _data["key"];
            this.createdAt = _data["createdAt"] ? dayjs(_data["createdAt"].toString()) : <any>undefined;
            this.lastUsedAt = _data["lastUsedAt"] ? dayjs(_data["lastUsedAt"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): UserApiKeyModel {
        data = typeof data === 'object' ? data : {};
        let result = new UserApiKeyModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["key"] = this.key;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : <any>undefined;
        data["lastUsedAt"] = this.lastUsedAt ? this.lastUsedAt.toISOString() : <any>undefined;
        return data;
    }
}

export interface IUserApiKeyModel {
    key: string;
    createdAt: dayjs.Dayjs;
    lastUsedAt?: dayjs.Dayjs | undefined;
}

export class DashboardLinkResponse implements IDashboardLinkResponse {
    error?: string | undefined;
    url?: string | undefined;

    constructor(data?: IDashboardLinkResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.error = _data["error"];
            this.url = _data["url"];
        }
    }

    static fromJS(data: any): DashboardLinkResponse {
        data = typeof data === 'object' ? data : {};
        let result = new DashboardLinkResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["error"] = this.error;
        data["url"] = this.url;
        return data;
    }
}

export interface IDashboardLinkResponse {
    error?: string | undefined;
    url?: string | undefined;
}

export class UserDataUploadResponse implements IUserDataUploadResponse {
    success!: boolean;
    url!: string;
    errorMessage!: string;

    constructor(data?: IUserDataUploadResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.success = _data["success"];
            this.url = _data["url"];
            this.errorMessage = _data["errorMessage"];
        }
    }

    static fromJS(data: any): UserDataUploadResponse {
        data = typeof data === 'object' ? data : {};
        let result = new UserDataUploadResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        data["url"] = this.url;
        data["errorMessage"] = this.errorMessage;
        return data;
    }
}

export interface IUserDataUploadResponse {
    success: boolean;
    url: string;
    errorMessage: string;
}

export class NotificationModel implements INotificationModel {
    notificationId!: number;
    title!: string;
    content!: string;
    updatedAt!: dayjs.Dayjs;

    constructor(data?: INotificationModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.notificationId = _data["notificationId"];
            this.title = _data["title"];
            this.content = _data["content"];
            this.updatedAt = _data["updatedAt"] ? dayjs(_data["updatedAt"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): NotificationModel {
        data = typeof data === 'object' ? data : {};
        let result = new NotificationModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["notificationId"] = this.notificationId;
        data["title"] = this.title;
        data["content"] = this.content;
        data["updatedAt"] = this.updatedAt ? this.updatedAt.toISOString() : <any>undefined;
        return data;
    }
}

export interface INotificationModel {
    notificationId: number;
    title: string;
    content: string;
    updatedAt: dayjs.Dayjs;
}

export class ReadNotificationResponse implements IReadNotificationResponse {
    success!: boolean;
    errorMessage?: string | undefined;

    constructor(data?: IReadNotificationResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.success = _data["success"];
            this.errorMessage = _data["errorMessage"];
        }
    }

    static fromJS(data: any): ReadNotificationResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ReadNotificationResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        data["errorMessage"] = this.errorMessage;
        return data;
    }
}

export interface IReadNotificationResponse {
    success: boolean;
    errorMessage?: string | undefined;
}

export class ReadNotificationRequest implements IReadNotificationRequest {
    notificationId!: number;

    constructor(data?: IReadNotificationRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.notificationId = _data["notificationId"];
        }
    }

    static fromJS(data: any): ReadNotificationRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ReadNotificationRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["notificationId"] = this.notificationId;
        return data;
    }
}

export interface IReadNotificationRequest {
    notificationId: number;
}

export class RoleModel implements IRoleModel {
    id!: number;
    name!: string;
    description!: string;

    constructor(data?: IRoleModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): RoleModel {
        data = typeof data === 'object' ? data : {};
        let result = new RoleModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["description"] = this.description;
        return data;
    }
}

export interface IRoleModel {
    id: number;
    name: string;
    description: string;
}

export class UserRoleModel implements IUserRoleModel {
    roleId!: number;
    userId!: number;

    constructor(data?: IUserRoleModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.roleId = _data["roleId"];
            this.userId = _data["userId"];
        }
    }

    static fromJS(data: any): UserRoleModel {
        data = typeof data === 'object' ? data : {};
        let result = new UserRoleModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["roleId"] = this.roleId;
        data["userId"] = this.userId;
        return data;
    }
}

export interface IUserRoleModel {
    roleId: number;
    userId: number;
}

export class UserSettingsModel implements IUserSettingsModel {
    risk?: number | undefined;
    toMake?: number | undefined;
    autoCenter?: boolean | undefined;
    showConfirmations?: boolean | undefined;
    autoApply?: boolean | undefined;
    streamerMode?: boolean | undefined;
    soundNotifications?: boolean | undefined;
    custom?: JsonDocument | undefined;

    constructor(data?: IUserSettingsModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.risk = _data["risk"];
            this.toMake = _data["toMake"];
            this.autoCenter = _data["autoCenter"];
            this.showConfirmations = _data["showConfirmations"];
            this.autoApply = _data["autoApply"];
            this.streamerMode = _data["streamerMode"];
            this.soundNotifications = _data["soundNotifications"];
            this.custom = _data["custom"] ? JsonDocument.fromJS(_data["custom"]) : <any>undefined;
        }
    }

    static fromJS(data: any): UserSettingsModel {
        data = typeof data === 'object' ? data : {};
        let result = new UserSettingsModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["risk"] = this.risk;
        data["toMake"] = this.toMake;
        data["autoCenter"] = this.autoCenter;
        data["showConfirmations"] = this.showConfirmations;
        data["autoApply"] = this.autoApply;
        data["streamerMode"] = this.streamerMode;
        data["soundNotifications"] = this.soundNotifications;
        data["custom"] = this.custom ? this.custom.toJSON() : <any>undefined;
        return data;
    }
}

export interface IUserSettingsModel {
    risk?: number | undefined;
    toMake?: number | undefined;
    autoCenter?: boolean | undefined;
    showConfirmations?: boolean | undefined;
    autoApply?: boolean | undefined;
    streamerMode?: boolean | undefined;
    soundNotifications?: boolean | undefined;
    custom?: JsonDocument | undefined;
}

export class ActiveViolationModel implements IActiveViolationModel {
    type!: ViolationType;
    triggeredAt!: dayjs.Dayjs;
    expiresAt?: dayjs.Dayjs | undefined;
    duration!: ViolationDuration;
    violationBalance!: number;
    violationTotalDayPnl!: number;
    minimumBalance!: number;
    dailyLossLimit!: number;
    personalDailyLossLimit?: number | undefined;
    personalDailyProfitTarget?: number | undefined;
    accountTemplateId?: number | undefined;
    ruleId?: TradingRuleType | undefined;
    customViolation?: CustomViolationModel | undefined;

    constructor(data?: IActiveViolationModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.type = _data["type"];
            this.triggeredAt = _data["triggeredAt"] ? dayjs(_data["triggeredAt"].toString()) : <any>undefined;
            this.expiresAt = _data["expiresAt"] ? dayjs(_data["expiresAt"].toString()) : <any>undefined;
            this.duration = _data["duration"];
            this.violationBalance = _data["violationBalance"];
            this.violationTotalDayPnl = _data["violationTotalDayPnl"];
            this.minimumBalance = _data["minimumBalance"];
            this.dailyLossLimit = _data["dailyLossLimit"];
            this.personalDailyLossLimit = _data["personalDailyLossLimit"];
            this.personalDailyProfitTarget = _data["personalDailyProfitTarget"];
            this.accountTemplateId = _data["accountTemplateId"];
            this.ruleId = _data["ruleId"];
            this.customViolation = _data["customViolation"] ? CustomViolationModel.fromJS(_data["customViolation"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ActiveViolationModel {
        data = typeof data === 'object' ? data : {};
        let result = new ActiveViolationModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this.type;
        data["triggeredAt"] = this.triggeredAt ? this.triggeredAt.toISOString() : <any>undefined;
        data["expiresAt"] = this.expiresAt ? this.expiresAt.toISOString() : <any>undefined;
        data["duration"] = this.duration;
        data["violationBalance"] = this.violationBalance;
        data["violationTotalDayPnl"] = this.violationTotalDayPnl;
        data["minimumBalance"] = this.minimumBalance;
        data["dailyLossLimit"] = this.dailyLossLimit;
        data["personalDailyLossLimit"] = this.personalDailyLossLimit;
        data["personalDailyProfitTarget"] = this.personalDailyProfitTarget;
        data["accountTemplateId"] = this.accountTemplateId;
        data["ruleId"] = this.ruleId;
        data["customViolation"] = this.customViolation ? this.customViolation.toJSON() : <any>undefined;
        return data;
    }
}

export interface IActiveViolationModel {
    type: ViolationType;
    triggeredAt: dayjs.Dayjs;
    expiresAt?: dayjs.Dayjs | undefined;
    duration: ViolationDuration;
    violationBalance: number;
    violationTotalDayPnl: number;
    minimumBalance: number;
    dailyLossLimit: number;
    personalDailyLossLimit?: number | undefined;
    personalDailyProfitTarget?: number | undefined;
    accountTemplateId?: number | undefined;
    ruleId?: TradingRuleType | undefined;
    customViolation?: CustomViolationModel | undefined;
}

/** 0 = Unspecified 1 = DailyLossLimit 2 = MaximumLossLimit 3 = PersonalDailyLossLimit 4 = PersonalStop 5 = PersonalDailyProfitTarget 6 = Rule 7 = Custom 8 = TrailingPersonalDailyLossLimit */
export enum ViolationType {
    Unspecified = 0,
    DailyLossLimit = 1,
    MaximumLossLimit = 2,
    PersonalDailyLossLimit = 3,
    PersonalStop = 4,
    PersonalDailyProfitTarget = 5,
    Rule = 6,
    Custom = 7,
    TrailingPersonalDailyLossLimit = 8,
}

export class CustomViolationModel implements ICustomViolationModel {
    title!: string;
    message?: string | undefined;
    extraData?: string | undefined;

    constructor(data?: ICustomViolationModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.title = _data["title"];
            this.message = _data["message"];
            this.extraData = _data["extraData"];
        }
    }

    static fromJS(data: any): CustomViolationModel {
        data = typeof data === 'object' ? data : {};
        let result = new CustomViolationModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["title"] = this.title;
        data["message"] = this.message;
        data["extraData"] = this.extraData;
        return data;
    }
}

export interface ICustomViolationModel {
    title: string;
    message?: string | undefined;
    extraData?: string | undefined;
}

export class Headers implements IHeaders {

    [key: string]: any;

    constructor(data?: IHeaders) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
        }
    }

    static fromJS(data: any): Headers {
        data = typeof data === 'object' ? data : {};
        let result = new Headers();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        return data;
    }
}

export interface IHeaders {

    [key: string]: any;
}

export class RootElement implements IRootElement {

    [key: string]: any;

    constructor(data?: IRootElement) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
        }
    }

    static fromJS(data: any): RootElement {
        data = typeof data === 'object' ? data : {};
        let result = new RootElement();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        return data;
    }
}

export interface IRootElement {

    [key: string]: any;
}

export interface FileParameter {
    data: any;
    fileName: string;
}

export interface FileResponse {
    data: Blob;
    status: number;
    fileName?: string;
    headers?: { [name: string]: any };
}

export class ApiException extends Error {
    override message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    if (result !== null && result !== undefined)
        throw result;
    else
        throw new ApiException(message, status, response, headers, null);
}

function isAxiosError(obj: any): obj is AxiosError {
    return obj && obj.isAxiosError === true;
}
